export default  [
    {
      "value": "132",
      "text": "北京市",
      "children": [
        {
          "value": "133",
          "text": "东城区",
          "children": [
            {
              "value": "133",
              "text": "东城区"
            }
          ]
        },
        {
          "value": "134",
          "text": "西城区",
          "children": [
            {
              "value": "134",
              "text": "西城区"
            }
          ]
        },
        {
          "value": "135",
          "text": "崇文区",
          "children": [
            {
              "value": "135",
              "text": "崇文区"
            }
          ]
        },
        {
          "value": "136",
          "text": "宣武区",
          "children": [
            {
              "value": "136",
              "text": "宣武区"
            }
          ]
        },
        {
          "value": "137",
          "text": "朝阳区",
          "children": [
            {
              "value": "137",
              "text": "朝阳区"
            }
          ]
        },
        {
          "value": "138",
          "text": "丰台区",
          "children": [
            {
              "value": "138",
              "text": "丰台区"
            }
          ]
        },
        {
          "value": "139",
          "text": "石景山区",
          "children": [
            {
              "value": "139",
              "text": "石景山区"
            }
          ]
        },
        {
          "value": "140",
          "text": "海淀区",
          "children": [
            {
              "value": "140",
              "text": "海淀区"
            }
          ]
        },
        {
          "value": "141",
          "text": "门头沟",
          "children": [
            {
              "value": "141",
              "text": "门头沟"
            }
          ]
        },
        {
          "value": "142",
          "text": "房山区",
          "children": [
            {
              "value": "142",
              "text": "房山区"
            }
          ]
        },
        {
          "value": "143",
          "text": "通州区",
          "children": [
            {
              "value": "143",
              "text": "通州区"
            }
          ]
        },
        {
          "value": "144",
          "text": "顺义区",
          "children": [
            {
              "value": "144",
              "text": "顺义区"
            }
          ]
        },
        {
          "value": "145",
          "text": "昌平区",
          "children": [
            {
              "value": "145",
              "text": "昌平区"
            }
          ]
        },
        {
          "value": "146",
          "text": "大兴区",
          "children": [
            {
              "value": "146",
              "text": "大兴区"
            }
          ]
        },
        {
          "value": "147",
          "text": "平谷区",
          "children": [
            {
              "value": "147",
              "text": "平谷区"
            }
          ]
        },
        {
          "value": "148",
          "text": "怀柔区",
          "children": [
            {
              "value": "148",
              "text": "怀柔区"
            }
          ]
        },
        {
          "value": "149",
          "text": "密云区",
          "children": [
            {
              "value": "149",
              "text": "密云区"
            }
          ]
        },
        {
          "value": "150",
          "text": "延庆县",
          "children": [
            {
              "value": "150",
              "text": "延庆县"
            }
          ]
        }
      ]
    },
    {
      "value": "151",
      "text": "天津市",
      "children": [
        {
          "value": "152",
          "text": "和平区",
          "children": [
            {
              "value": "152",
              "text": "和平区"
            }
          ]
        },
        {
          "value": "153",
          "text": "河东区",
          "children": [
            {
              "value": "153",
              "text": "河东区"
            }
          ]
        },
        {
          "value": "154",
          "text": "河西区",
          "children": [
            {
              "value": "154",
              "text": "河西区"
            }
          ]
        },
        {
          "value": "155",
          "text": "南开区",
          "children": [
            {
              "value": "155",
              "text": "南开区"
            }
          ]
        },
        {
          "value": "156",
          "text": "河北区",
          "children": [
            {
              "value": "156",
              "text": "河北区"
            }
          ]
        },
        {
          "value": "157",
          "text": "红桥区",
          "children": [
            {
              "value": "157",
              "text": "红桥区"
            }
          ]
        },
        {
          "value": "161",
          "text": "东丽区",
          "children": [
            {
              "value": "161",
              "text": "东丽区"
            }
          ]
        },
        {
          "value": "162",
          "text": "西青区",
          "children": [
            {
              "value": "162",
              "text": "西青区"
            }
          ]
        },
        {
          "value": "163",
          "text": "津南区",
          "children": [
            {
              "value": "163",
              "text": "津南区"
            }
          ]
        },
        {
          "value": "164",
          "text": "北辰区",
          "children": [
            {
              "value": "164",
              "text": "北辰区"
            }
          ]
        },
        {
          "value": "165",
          "text": "武清区",
          "children": [
            {
              "value": "165",
              "text": "武清区"
            }
          ]
        },
        {
          "value": "166",
          "text": "宝坻区",
          "children": [
            {
              "value": "166",
              "text": "宝坻区"
            }
          ]
        },
        {
          "value": "167",
          "text": "宁河县",
          "children": [
            {
              "value": "167",
              "text": "宁河县"
            }
          ]
        },
        {
          "value": "168",
          "text": "静海县",
          "children": [
            {
              "value": "168",
              "text": "静海县"
            }
          ]
        },
        {
          "value": "169",
          "text": "蓟县",
          "children": [
            {
              "value": "169",
              "text": "蓟县"
            }
          ]
        },
        {
          "value": "3412",
          "text": "滨海新区",
          "children": [
            {
              "value": "3560",
              "text": "塘沽区"
            },
            {
              "value": "3687",
              "text": "大港区"
            }
          ]
        }
      ]
    },
    {
      "value": "170",
      "text": "河北省",
      "children": [
        {
          "value": "171",
          "text": "石家庄市",
          "children": [
            {
              "value": "172",
              "text": "长安区"
            },
            {
              "value": "173",
              "text": "桥东区"
            },
            {
              "value": "174",
              "text": "桥西区"
            },
            {
              "value": "175",
              "text": "新华区"
            },
            {
              "value": "176",
              "text": "井陉矿区"
            },
            {
              "value": "177",
              "text": "井陉县"
            },
            {
              "value": "178",
              "text": "正定县"
            },
            {
              "value": "179",
              "text": "栾城区"
            },
            {
              "value": "180",
              "text": "行唐县"
            },
            {
              "value": "181",
              "text": "灵寿县"
            },
            {
              "value": "182",
              "text": "高邑县"
            },
            {
              "value": "183",
              "text": "深泽县"
            },
            {
              "value": "184",
              "text": "赞皇县"
            },
            {
              "value": "185",
              "text": "无极县"
            },
            {
              "value": "186",
              "text": "平山县"
            },
            {
              "value": "187",
              "text": "元氏县"
            },
            {
              "value": "188",
              "text": "赵县"
            },
            {
              "value": "189",
              "text": "辛集市"
            },
            {
              "value": "190",
              "text": "藁城区"
            },
            {
              "value": "191",
              "text": "晋州市"
            },
            {
              "value": "192",
              "text": "新乐市"
            },
            {
              "value": "193",
              "text": "鹿泉区"
            },
            {
              "value": "3624",
              "text": "裕华区"
            }
          ]
        },
        {
          "value": "194",
          "text": "唐山市",
          "children": [
            {
              "value": "195",
              "text": "路南区"
            },
            {
              "value": "196",
              "text": "路北区"
            },
            {
              "value": "197",
              "text": "古冶区"
            },
            {
              "value": "198",
              "text": "开平区"
            },
            {
              "value": "199",
              "text": "新区"
            },
            {
              "value": "200",
              "text": "丰润区"
            },
            {
              "value": "201",
              "text": "滦县"
            },
            {
              "value": "202",
              "text": "滦南县"
            },
            {
              "value": "203",
              "text": "乐亭县"
            },
            {
              "value": "204",
              "text": "迁西县"
            },
            {
              "value": "205",
              "text": "玉田县"
            },
            {
              "value": "206",
              "text": "曹妃甸区"
            },
            {
              "value": "207",
              "text": "遵化市"
            },
            {
              "value": "208",
              "text": "丰南区"
            },
            {
              "value": "209",
              "text": "迁安市"
            }
          ]
        },
        {
          "value": "210",
          "text": "秦皇岛市",
          "children": [
            {
              "value": "211",
              "text": "海港区"
            },
            {
              "value": "212",
              "text": "山海关区"
            },
            {
              "value": "213",
              "text": "北戴河区"
            },
            {
              "value": "214",
              "text": "青龙满族自治县"
            },
            {
              "value": "215",
              "text": "昌黎县"
            },
            {
              "value": "216",
              "text": "抚宁区"
            },
            {
              "value": "217",
              "text": "卢龙县"
            }
          ]
        },
        {
          "value": "218",
          "text": "邯郸市",
          "children": [
            {
              "value": "219",
              "text": "邯山区"
            },
            {
              "value": "220",
              "text": "丛台区"
            },
            {
              "value": "221",
              "text": "复兴区"
            },
            {
              "value": "222",
              "text": "峰峰矿区"
            },
            {
              "value": "223",
              "text": "邯郸县"
            },
            {
              "value": "224",
              "text": "临漳县"
            },
            {
              "value": "225",
              "text": "成安县"
            },
            {
              "value": "226",
              "text": "大名县"
            },
            {
              "value": "227",
              "text": "涉县"
            },
            {
              "value": "228",
              "text": "磁县"
            },
            {
              "value": "229",
              "text": "肥乡区"
            },
            {
              "value": "230",
              "text": "永年区"
            },
            {
              "value": "231",
              "text": "邱县"
            },
            {
              "value": "232",
              "text": "鸡泽县"
            },
            {
              "value": "233",
              "text": "广平县"
            },
            {
              "value": "234",
              "text": "馆陶县"
            },
            {
              "value": "235",
              "text": "魏县"
            },
            {
              "value": "236",
              "text": "曲周县"
            },
            {
              "value": "237",
              "text": "武安市"
            }
          ]
        },
        {
          "value": "238",
          "text": "邢台市",
          "children": [
            {
              "value": "239",
              "text": "桥东区"
            },
            {
              "value": "240",
              "text": "桥西区"
            },
            {
              "value": "241",
              "text": "邢台县"
            },
            {
              "value": "242",
              "text": "临城县"
            },
            {
              "value": "243",
              "text": "内丘县"
            },
            {
              "value": "244",
              "text": "柏乡县"
            },
            {
              "value": "245",
              "text": "隆尧县"
            },
            {
              "value": "246",
              "text": "任县"
            },
            {
              "value": "247",
              "text": "南和县"
            },
            {
              "value": "248",
              "text": "宁晋县"
            },
            {
              "value": "249",
              "text": "巨鹿县"
            },
            {
              "value": "250",
              "text": "新河县"
            },
            {
              "value": "251",
              "text": "广宗县"
            },
            {
              "value": "252",
              "text": "平乡县"
            },
            {
              "value": "253",
              "text": "威县"
            },
            {
              "value": "254",
              "text": "清河县"
            },
            {
              "value": "255",
              "text": "临西县"
            },
            {
              "value": "256",
              "text": "南宫市"
            },
            {
              "value": "257",
              "text": "沙河市"
            }
          ]
        },
        {
          "value": "258",
          "text": "保定市",
          "children": [
            {
              "value": "259",
              "text": "竞秀区"
            },
            {
              "value": "260",
              "text": "莲池区"
            },
            {
              "value": "262",
              "text": "满城区"
            },
            {
              "value": "263",
              "text": "清苑县"
            },
            {
              "value": "264",
              "text": "涞水县"
            },
            {
              "value": "265",
              "text": "阜平县"
            },
            {
              "value": "266",
              "text": "徐水区"
            },
            {
              "value": "267",
              "text": "定兴县"
            },
            {
              "value": "268",
              "text": "唐县"
            },
            {
              "value": "269",
              "text": "高阳县"
            },
            {
              "value": "270",
              "text": "容城县"
            },
            {
              "value": "271",
              "text": "涞源县"
            },
            {
              "value": "272",
              "text": "望都县"
            },
            {
              "value": "273",
              "text": "安新县"
            },
            {
              "value": "274",
              "text": "易县"
            },
            {
              "value": "275",
              "text": "曲阳县"
            },
            {
              "value": "276",
              "text": "蠡县"
            },
            {
              "value": "277",
              "text": "顺平县"
            },
            {
              "value": "278",
              "text": "博野县"
            },
            {
              "value": "279",
              "text": "雄县"
            },
            {
              "value": "280",
              "text": "涿州市"
            },
            {
              "value": "281",
              "text": "定州市"
            },
            {
              "value": "282",
              "text": "安国市"
            },
            {
              "value": "283",
              "text": "高碑店市"
            }
          ]
        },
        {
          "value": "284",
          "text": "张家口市",
          "children": [
            {
              "value": "285",
              "text": "桥东区"
            },
            {
              "value": "286",
              "text": "桥西区"
            },
            {
              "value": "287",
              "text": "宣化区"
            },
            {
              "value": "288",
              "text": "下花园区"
            },
            {
              "value": "289",
              "text": "宣化县"
            },
            {
              "value": "290",
              "text": "张北县"
            },
            {
              "value": "291",
              "text": "康保县"
            },
            {
              "value": "292",
              "text": "沽源县"
            },
            {
              "value": "293",
              "text": "尚义县"
            },
            {
              "value": "294",
              "text": "蔚县"
            },
            {
              "value": "295",
              "text": "阳原县"
            },
            {
              "value": "296",
              "text": "怀安县"
            },
            {
              "value": "297",
              "text": "万全区"
            },
            {
              "value": "298",
              "text": "怀来县"
            },
            {
              "value": "299",
              "text": "涿鹿县"
            },
            {
              "value": "300",
              "text": "赤城县"
            },
            {
              "value": "301",
              "text": "崇礼区"
            }
          ]
        },
        {
          "value": "302",
          "text": "承德市",
          "children": [
            {
              "value": "303",
              "text": "双桥区"
            },
            {
              "value": "304",
              "text": "双滦区"
            },
            {
              "value": "305",
              "text": "鹰手营子矿区"
            },
            {
              "value": "306",
              "text": "承德县"
            },
            {
              "value": "307",
              "text": "兴隆县"
            },
            {
              "value": "308",
              "text": "平泉市"
            },
            {
              "value": "309",
              "text": "滦平县"
            },
            {
              "value": "310",
              "text": "隆化县"
            },
            {
              "value": "311",
              "text": "丰宁满族自治县"
            },
            {
              "value": "312",
              "text": "宽城满族自治县"
            },
            {
              "value": "313",
              "text": "围场满族蒙古族自治县"
            }
          ]
        },
        {
          "value": "314",
          "text": "沧州市",
          "children": [
            {
              "value": "315",
              "text": "新华区"
            },
            {
              "value": "316",
              "text": "运河区"
            },
            {
              "value": "317",
              "text": "沧县"
            },
            {
              "value": "318",
              "text": "青县"
            },
            {
              "value": "319",
              "text": "东光县"
            },
            {
              "value": "320",
              "text": "海兴县"
            },
            {
              "value": "321",
              "text": "盐山县"
            },
            {
              "value": "322",
              "text": "肃宁县"
            },
            {
              "value": "323",
              "text": "南皮县"
            },
            {
              "value": "324",
              "text": "吴桥县"
            },
            {
              "value": "325",
              "text": "献县"
            },
            {
              "value": "326",
              "text": "孟村回族自治县"
            },
            {
              "value": "327",
              "text": "泊头市"
            },
            {
              "value": "328",
              "text": "任丘市"
            },
            {
              "value": "329",
              "text": "黄骅市"
            },
            {
              "value": "330",
              "text": "河间市"
            }
          ]
        },
        {
          "value": "331",
          "text": "廊坊市",
          "children": [
            {
              "value": "332",
              "text": "安次区"
            },
            {
              "value": "333",
              "text": "固安县"
            },
            {
              "value": "334",
              "text": "永清县"
            },
            {
              "value": "335",
              "text": "香河县"
            },
            {
              "value": "336",
              "text": "大城县"
            },
            {
              "value": "337",
              "text": "文安县"
            },
            {
              "value": "338",
              "text": "大厂回族自治县"
            },
            {
              "value": "339",
              "text": "霸州市"
            },
            {
              "value": "340",
              "text": "三河市"
            },
            {
              "value": "3631",
              "text": "广阳区"
            },
            {
              "value": "3705",
              "text": "开发区"
            }
          ]
        },
        {
          "value": "341",
          "text": "衡水市",
          "children": [
            {
              "value": "342",
              "text": "桃城区"
            },
            {
              "value": "343",
              "text": "枣强县"
            },
            {
              "value": "344",
              "text": "武邑县"
            },
            {
              "value": "345",
              "text": "武强县"
            },
            {
              "value": "346",
              "text": "饶阳县"
            },
            {
              "value": "347",
              "text": "安平县"
            },
            {
              "value": "348",
              "text": "故城县"
            },
            {
              "value": "349",
              "text": "景县"
            },
            {
              "value": "350",
              "text": "阜城县"
            },
            {
              "value": "351",
              "text": "冀州区"
            },
            {
              "value": "352",
              "text": "深州市"
            }
          ]
        }
      ]
    },
    {
      "value": "353",
      "text": "山西省",
      "children": [
        {
          "value": "354",
          "text": "太原市",
          "children": [
            {
              "value": "355",
              "text": "小店区"
            },
            {
              "value": "356",
              "text": "迎泽区"
            },
            {
              "value": "357",
              "text": "杏花岭区"
            },
            {
              "value": "358",
              "text": "尖草坪区"
            },
            {
              "value": "359",
              "text": "万柏林区"
            },
            {
              "value": "360",
              "text": "晋源区"
            },
            {
              "value": "361",
              "text": "清徐县"
            },
            {
              "value": "362",
              "text": "阳曲县"
            },
            {
              "value": "363",
              "text": "娄烦县"
            },
            {
              "value": "364",
              "text": "古交市"
            }
          ]
        },
        {
          "value": "365",
          "text": "大同市",
          "children": [
            {
              "value": "366",
              "text": "城区"
            },
            {
              "value": "367",
              "text": "矿区"
            },
            {
              "value": "368",
              "text": "南郊区"
            },
            {
              "value": "369",
              "text": "新荣区"
            },
            {
              "value": "370",
              "text": "阳高县"
            },
            {
              "value": "371",
              "text": "天镇县"
            },
            {
              "value": "372",
              "text": "广灵县"
            },
            {
              "value": "373",
              "text": "灵丘县"
            },
            {
              "value": "374",
              "text": "浑源县"
            },
            {
              "value": "375",
              "text": "左云县"
            },
            {
              "value": "376",
              "text": "大同县"
            },
            {
              "value": "3729",
              "text": "平城区"
            },
            {
              "value": "3730",
              "text": "云冈区"
            },
            {
              "value": "3731",
              "text": "云州区"
            }
          ]
        },
        {
          "value": "377",
          "text": "阳泉市",
          "children": [
            {
              "value": "378",
              "text": "城区"
            },
            {
              "value": "379",
              "text": "矿区"
            },
            {
              "value": "380",
              "text": "郊区"
            },
            {
              "value": "381",
              "text": "平定县"
            },
            {
              "value": "382",
              "text": "盂县"
            }
          ]
        },
        {
          "value": "383",
          "text": "长治市",
          "children": [
            {
              "value": "384",
              "text": "城区"
            },
            {
              "value": "385",
              "text": "郊区"
            },
            {
              "value": "386",
              "text": "长治县"
            },
            {
              "value": "387",
              "text": "襄垣县"
            },
            {
              "value": "388",
              "text": "屯留县"
            },
            {
              "value": "389",
              "text": "平顺县"
            },
            {
              "value": "390",
              "text": "黎城县"
            },
            {
              "value": "391",
              "text": "壶关县"
            },
            {
              "value": "392",
              "text": "长子县"
            },
            {
              "value": "393",
              "text": "武乡县"
            },
            {
              "value": "394",
              "text": "沁县"
            },
            {
              "value": "395",
              "text": "沁源县"
            },
            {
              "value": "396",
              "text": "潞城市"
            }
          ]
        },
        {
          "value": "397",
          "text": "晋城市",
          "children": [
            {
              "value": "398",
              "text": "城区"
            },
            {
              "value": "399",
              "text": "沁水县"
            },
            {
              "value": "400",
              "text": "阳城县"
            },
            {
              "value": "401",
              "text": "陵川县"
            },
            {
              "value": "402",
              "text": "泽州县"
            },
            {
              "value": "403",
              "text": "高平市"
            }
          ]
        },
        {
          "value": "404",
          "text": "朔州市",
          "children": [
            {
              "value": "405",
              "text": "朔城区"
            },
            {
              "value": "406",
              "text": "平鲁区"
            },
            {
              "value": "407",
              "text": "山阴县"
            },
            {
              "value": "408",
              "text": "应县"
            },
            {
              "value": "409",
              "text": "右玉县"
            },
            {
              "value": "410",
              "text": "怀仁市"
            }
          ]
        },
        {
          "value": "411",
          "text": "忻州市",
          "children": [
            {
              "value": "412",
              "text": "忻府区"
            },
            {
              "value": "413",
              "text": "原平市"
            },
            {
              "value": "414",
              "text": "定襄县"
            },
            {
              "value": "415",
              "text": "五台县"
            },
            {
              "value": "416",
              "text": "代县"
            },
            {
              "value": "417",
              "text": "繁峙县"
            },
            {
              "value": "418",
              "text": "宁武县"
            },
            {
              "value": "419",
              "text": "静乐县"
            },
            {
              "value": "420",
              "text": "神池县"
            },
            {
              "value": "421",
              "text": "五寨县"
            },
            {
              "value": "422",
              "text": "岢岚县"
            },
            {
              "value": "423",
              "text": "河曲县"
            },
            {
              "value": "424",
              "text": "保德县"
            },
            {
              "value": "425",
              "text": "偏关县"
            }
          ]
        },
        {
          "value": "426",
          "text": "吕梁市",
          "children": [
            {
              "value": "427",
              "text": "离石区"
            },
            {
              "value": "428",
              "text": "孝义市"
            },
            {
              "value": "429",
              "text": "汾阳市"
            },
            {
              "value": "430",
              "text": "文水县"
            },
            {
              "value": "431",
              "text": "交城县"
            },
            {
              "value": "432",
              "text": "兴县"
            },
            {
              "value": "433",
              "text": "临县"
            },
            {
              "value": "434",
              "text": "柳林县"
            },
            {
              "value": "435",
              "text": "石楼县"
            },
            {
              "value": "436",
              "text": "岚县"
            },
            {
              "value": "437",
              "text": "方山县"
            },
            {
              "value": "438",
              "text": "中阳县"
            },
            {
              "value": "439",
              "text": "交口县"
            }
          ]
        },
        {
          "value": "440",
          "text": "晋中市",
          "children": [
            {
              "value": "441",
              "text": "榆次区"
            },
            {
              "value": "442",
              "text": "介休市"
            },
            {
              "value": "443",
              "text": "榆社县"
            },
            {
              "value": "444",
              "text": "左权县"
            },
            {
              "value": "445",
              "text": "和顺县"
            },
            {
              "value": "446",
              "text": "昔阳县"
            },
            {
              "value": "447",
              "text": "寿阳县"
            },
            {
              "value": "448",
              "text": "太谷县"
            },
            {
              "value": "449",
              "text": "祁县"
            },
            {
              "value": "450",
              "text": "平遥县"
            },
            {
              "value": "451",
              "text": "灵石县"
            }
          ]
        },
        {
          "value": "452",
          "text": "临汾市",
          "children": [
            {
              "value": "453",
              "text": "尧都区"
            },
            {
              "value": "454",
              "text": "侯马市"
            },
            {
              "value": "455",
              "text": "霍州市"
            },
            {
              "value": "456",
              "text": "曲沃县"
            },
            {
              "value": "457",
              "text": "翼城县"
            },
            {
              "value": "458",
              "text": "襄汾县"
            },
            {
              "value": "459",
              "text": "洪洞县"
            },
            {
              "value": "460",
              "text": "古县"
            },
            {
              "value": "461",
              "text": "安泽县"
            },
            {
              "value": "462",
              "text": "浮山县"
            },
            {
              "value": "463",
              "text": "吉县"
            },
            {
              "value": "464",
              "text": "乡宁县"
            },
            {
              "value": "465",
              "text": "蒲县"
            },
            {
              "value": "466",
              "text": "大宁县"
            },
            {
              "value": "467",
              "text": "永和县"
            },
            {
              "value": "468",
              "text": "隰县"
            },
            {
              "value": "469",
              "text": "汾西县"
            }
          ]
        },
        {
          "value": "470",
          "text": "运城市",
          "children": [
            {
              "value": "471",
              "text": "盐湖区"
            },
            {
              "value": "472",
              "text": "永济市"
            },
            {
              "value": "473",
              "text": "河津市"
            },
            {
              "value": "474",
              "text": "芮城县"
            },
            {
              "value": "475",
              "text": "临猗县"
            },
            {
              "value": "476",
              "text": "万荣县"
            },
            {
              "value": "477",
              "text": "新绛县"
            },
            {
              "value": "478",
              "text": "稷山县"
            },
            {
              "value": "479",
              "text": "闻喜县"
            },
            {
              "value": "480",
              "text": "夏县"
            },
            {
              "value": "481",
              "text": "绛县"
            },
            {
              "value": "482",
              "text": "平陆县"
            },
            {
              "value": "483",
              "text": "垣曲县"
            }
          ]
        }
      ]
    },
    {
      "value": "484",
      "text": "内蒙古",
      "children": [
        {
          "value": "485",
          "text": "呼和浩特市",
          "children": [
            {
              "value": "486",
              "text": "新城区"
            },
            {
              "value": "487",
              "text": "回民区"
            },
            {
              "value": "488",
              "text": "玉泉区"
            },
            {
              "value": "489",
              "text": "郊区"
            },
            {
              "value": "490",
              "text": "土默特左旗"
            },
            {
              "value": "491",
              "text": "托克托县"
            },
            {
              "value": "492",
              "text": "和林格尔县"
            },
            {
              "value": "493",
              "text": "清水河县"
            },
            {
              "value": "494",
              "text": "武川县"
            },
            {
              "value": "3554",
              "text": "赛罕区"
            }
          ]
        },
        {
          "value": "495",
          "text": "包头市",
          "children": [
            {
              "value": "496",
              "text": "东河区"
            },
            {
              "value": "497",
              "text": "昆都仑区"
            },
            {
              "value": "498",
              "text": "青山区"
            },
            {
              "value": "499",
              "text": "石拐区"
            },
            {
              "value": "500",
              "text": "白云鄂博矿区"
            },
            {
              "value": "501",
              "text": "郊区"
            },
            {
              "value": "502",
              "text": "土默特右旗"
            },
            {
              "value": "503",
              "text": "固阳县"
            },
            {
              "value": "504",
              "text": "达尔罕茂明安联合旗"
            },
            {
              "value": "3639",
              "text": "九原区"
            }
          ]
        },
        {
          "value": "505",
          "text": "乌海市",
          "children": [
            {
              "value": "506",
              "text": "海勃湾区"
            },
            {
              "value": "507",
              "text": "海南区"
            },
            {
              "value": "508",
              "text": "乌达区"
            }
          ]
        },
        {
          "value": "509",
          "text": "赤峰市",
          "children": [
            {
              "value": "510",
              "text": "红山区"
            },
            {
              "value": "511",
              "text": "元宝山区"
            },
            {
              "value": "512",
              "text": "松山区"
            },
            {
              "value": "513",
              "text": "阿鲁科尔沁旗"
            },
            {
              "value": "514",
              "text": "巴林左旗"
            },
            {
              "value": "515",
              "text": "巴林右旗"
            },
            {
              "value": "516",
              "text": "林西县"
            },
            {
              "value": "517",
              "text": "克什克腾旗"
            },
            {
              "value": "518",
              "text": "翁牛特旗"
            },
            {
              "value": "519",
              "text": "喀喇沁旗"
            },
            {
              "value": "520",
              "text": "宁城县"
            },
            {
              "value": "521",
              "text": "敖汉旗"
            }
          ]
        },
        {
          "value": "522",
          "text": "呼伦贝尔市",
          "children": [
            {
              "value": "523",
              "text": "海拉尔市"
            },
            {
              "value": "524",
              "text": "满洲里市"
            },
            {
              "value": "525",
              "text": "扎兰屯市"
            },
            {
              "value": "526",
              "text": "牙克石市"
            },
            {
              "value": "527",
              "text": "根河市"
            },
            {
              "value": "528",
              "text": "额尔古纳市"
            },
            {
              "value": "529",
              "text": "阿荣旗"
            },
            {
              "value": "530",
              "text": "莫力达瓦旗"
            },
            {
              "value": "531",
              "text": "鄂伦春旗"
            },
            {
              "value": "532",
              "text": "鄂温克族旗"
            },
            {
              "value": "533",
              "text": "新巴尔虎右旗"
            },
            {
              "value": "534",
              "text": "新巴尔虎左旗"
            },
            {
              "value": "535",
              "text": "陈巴尔虎旗"
            },
            {
              "value": "3642",
              "text": "扎赉诺尔区"
            }
          ]
        },
        {
          "value": "536",
          "text": "兴安盟",
          "children": [
            {
              "value": "537",
              "text": "乌兰浩特市"
            },
            {
              "value": "538",
              "text": "阿尔山市"
            },
            {
              "value": "539",
              "text": "科尔沁右翼前旗"
            },
            {
              "value": "540",
              "text": "科尔沁右翼中旗"
            },
            {
              "value": "541",
              "text": "扎赉特旗"
            },
            {
              "value": "542",
              "text": "突泉县"
            }
          ]
        },
        {
          "value": "543",
          "text": "通辽市",
          "children": [
            {
              "value": "544",
              "text": "科尔沁区"
            },
            {
              "value": "545",
              "text": "霍林郭勒市"
            },
            {
              "value": "546",
              "text": "科尔沁左翼中旗"
            },
            {
              "value": "547",
              "text": "科尔沁左翼后旗"
            },
            {
              "value": "548",
              "text": "开鲁县"
            },
            {
              "value": "549",
              "text": "库伦旗"
            },
            {
              "value": "550",
              "text": "奈曼旗"
            },
            {
              "value": "551",
              "text": "扎鲁特旗"
            }
          ]
        },
        {
          "value": "552",
          "text": "锡林郭勒盟",
          "children": [
            {
              "value": "553",
              "text": "二连浩特市"
            },
            {
              "value": "554",
              "text": "锡林浩特市"
            },
            {
              "value": "555",
              "text": "阿巴嘎旗"
            },
            {
              "value": "556",
              "text": "苏尼特左旗"
            },
            {
              "value": "557",
              "text": "苏尼特右旗"
            },
            {
              "value": "558",
              "text": "东乌珠穆沁旗"
            },
            {
              "value": "559",
              "text": "西乌珠穆沁旗"
            },
            {
              "value": "560",
              "text": "太仆寺旗"
            },
            {
              "value": "561",
              "text": "镶黄旗"
            },
            {
              "value": "562",
              "text": "正镶白旗"
            },
            {
              "value": "563",
              "text": "正蓝旗"
            },
            {
              "value": "564",
              "text": "多伦县"
            }
          ]
        },
        {
          "value": "565",
          "text": "乌兰察布盟",
          "children": [
            {
              "value": "566",
              "text": "集宁市"
            },
            {
              "value": "567",
              "text": "丰镇市"
            },
            {
              "value": "568",
              "text": "卓资县"
            },
            {
              "value": "569",
              "text": "化德县"
            },
            {
              "value": "570",
              "text": "商都县"
            },
            {
              "value": "571",
              "text": "兴和县"
            },
            {
              "value": "572",
              "text": "凉城县"
            },
            {
              "value": "573",
              "text": "察哈尔右翼前旗"
            },
            {
              "value": "574",
              "text": "察哈尔右翼中旗"
            },
            {
              "value": "575",
              "text": "察哈尔右翼后旗"
            },
            {
              "value": "576",
              "text": "四子王旗"
            }
          ]
        },
        {
          "value": "577",
          "text": "伊克昭盟",
          "children": [
            {
              "value": "578",
              "text": "东胜市"
            },
            {
              "value": "579",
              "text": "达拉特旗"
            },
            {
              "value": "580",
              "text": "准格尔旗"
            },
            {
              "value": "581",
              "text": "鄂托克前旗"
            },
            {
              "value": "582",
              "text": "鄂托克旗"
            },
            {
              "value": "583",
              "text": "杭锦旗"
            },
            {
              "value": "584",
              "text": "乌审旗"
            },
            {
              "value": "585",
              "text": "伊金霍洛旗"
            }
          ]
        },
        {
          "value": "586",
          "text": "巴彦淖尔盟",
          "children": [
            {
              "value": "587",
              "text": "临河区"
            },
            {
              "value": "588",
              "text": "五原县"
            },
            {
              "value": "589",
              "text": "磴口县"
            },
            {
              "value": "590",
              "text": "乌拉特前旗"
            },
            {
              "value": "591",
              "text": "乌拉特中旗"
            },
            {
              "value": "592",
              "text": "乌拉特后旗"
            },
            {
              "value": "593",
              "text": "杭锦后旗"
            }
          ]
        },
        {
          "value": "594",
          "text": "阿拉善盟",
          "children": [
            {
              "value": "595",
              "text": "阿拉善左旗"
            },
            {
              "value": "596",
              "text": "阿拉善右旗"
            },
            {
              "value": "597",
              "text": "额济纳旗"
            }
          ]
        },
        {
          "value": "3406",
          "text": "锡林浩特",
          "children": [
            {
              "value": "3406",
              "text": "锡林浩特"
            }
          ]
        },
        {
          "value": "3407",
          "text": "鄂尔多斯",
          "children": [
            {
              "value": "3633",
              "text": "东胜区"
            },
            {
              "value": "3690",
              "text": "康巴什区"
            },
            {
              "value": "3691",
              "text": "鄂托克旗"
            },
            {
              "value": "3692",
              "text": "达拉特旗"
            },
            {
              "value": "3693",
              "text": "乌审旗"
            },
            {
              "value": "3694",
              "text": "鄂托克前旗"
            },
            {
              "value": "3695",
              "text": "准格尔旗"
            },
            {
              "value": "3696",
              "text": "杭锦旗"
            },
            {
              "value": "3697",
              "text": "伊金霍洛旗"
            }
          ]
        },
        {
          "value": "3408",
          "text": "海拉尔",
          "children": [
            {
              "value": "3408",
              "text": "海拉尔"
            }
          ]
        },
        {
          "value": "3409",
          "text": "乌海",
          "children": [
            {
              "value": "3409",
              "text": "乌海"
            }
          ]
        }
      ]
    },
    {
      "value": "598",
      "text": "辽宁省",
      "children": [
        {
          "value": "599",
          "text": "沈阳市",
          "children": [
            {
              "value": "600",
              "text": "和平区"
            },
            {
              "value": "601",
              "text": "沈河区"
            },
            {
              "value": "602",
              "text": "大东区"
            },
            {
              "value": "603",
              "text": "皇姑区"
            },
            {
              "value": "604",
              "text": "铁西区"
            },
            {
              "value": "605",
              "text": "苏家屯区"
            },
            {
              "value": "606",
              "text": "浑南新区"
            },
            {
              "value": "607",
              "text": "沈北新区"
            },
            {
              "value": "608",
              "text": "于洪区"
            },
            {
              "value": "609",
              "text": "辽中县"
            },
            {
              "value": "610",
              "text": "康平县"
            },
            {
              "value": "611",
              "text": "法库县"
            },
            {
              "value": "612",
              "text": "新民市"
            },
            {
              "value": "3727",
              "text": "东陵区"
            }
          ]
        },
        {
          "value": "613",
          "text": "大连市",
          "children": [
            {
              "value": "614",
              "text": "中山区"
            },
            {
              "value": "615",
              "text": "西岗区"
            },
            {
              "value": "616",
              "text": "沙河口区"
            },
            {
              "value": "617",
              "text": "甘井子区"
            },
            {
              "value": "618",
              "text": "旅顺口区"
            },
            {
              "value": "619",
              "text": "金州区"
            },
            {
              "value": "620",
              "text": "长海县"
            },
            {
              "value": "621",
              "text": "瓦房店市"
            },
            {
              "value": "622",
              "text": "普兰店市"
            },
            {
              "value": "623",
              "text": "庄河市"
            },
            {
              "value": "3725",
              "text": "高新园区"
            },
            {
              "value": "3726",
              "text": "大连开发区"
            }
          ]
        },
        {
          "value": "624",
          "text": "鞍山市",
          "children": [
            {
              "value": "625",
              "text": "铁东区"
            },
            {
              "value": "626",
              "text": "铁西区"
            },
            {
              "value": "627",
              "text": "立山区"
            },
            {
              "value": "628",
              "text": "千山区"
            },
            {
              "value": "629",
              "text": "台安县"
            },
            {
              "value": "630",
              "text": "岫岩县"
            },
            {
              "value": "631",
              "text": "海城市"
            }
          ]
        },
        {
          "value": "632",
          "text": "抚顺市",
          "children": [
            {
              "value": "633",
              "text": "新抚区"
            },
            {
              "value": "634",
              "text": "露天区"
            },
            {
              "value": "635",
              "text": "望花区"
            },
            {
              "value": "636",
              "text": "顺城区"
            },
            {
              "value": "637",
              "text": "抚顺县"
            },
            {
              "value": "638",
              "text": "新宾县"
            },
            {
              "value": "639",
              "text": "清原县"
            },
            {
              "value": "3643",
              "text": "东洲区"
            }
          ]
        },
        {
          "value": "640",
          "text": "本溪市",
          "children": [
            {
              "value": "641",
              "text": "平山区"
            },
            {
              "value": "642",
              "text": "溪湖区"
            },
            {
              "value": "643",
              "text": "明山区"
            },
            {
              "value": "644",
              "text": "南芬区"
            },
            {
              "value": "645",
              "text": "本溪县"
            },
            {
              "value": "646",
              "text": "恒仁县"
            }
          ]
        },
        {
          "value": "647",
          "text": "丹东市",
          "children": [
            {
              "value": "648",
              "text": "元宝区"
            },
            {
              "value": "649",
              "text": "振兴区"
            },
            {
              "value": "650",
              "text": "振安区"
            },
            {
              "value": "651",
              "text": "宽甸县"
            },
            {
              "value": "652",
              "text": "东港市"
            },
            {
              "value": "653",
              "text": "凤城市"
            }
          ]
        },
        {
          "value": "654",
          "text": "锦州市",
          "children": [
            {
              "value": "655",
              "text": "古塔区"
            },
            {
              "value": "656",
              "text": "凌河区"
            },
            {
              "value": "657",
              "text": "太和区"
            },
            {
              "value": "658",
              "text": "黑山县"
            },
            {
              "value": "659",
              "text": "义县"
            },
            {
              "value": "660",
              "text": "凌海市"
            },
            {
              "value": "661",
              "text": "北镇市"
            },
            {
              "value": "3728",
              "text": "经济技术开发区"
            }
          ]
        },
        {
          "value": "662",
          "text": "营口市",
          "children": [
            {
              "value": "663",
              "text": "站前区"
            },
            {
              "value": "664",
              "text": "西市区"
            },
            {
              "value": "665",
              "text": "鲅鱼圈区"
            },
            {
              "value": "666",
              "text": "老边区"
            },
            {
              "value": "667",
              "text": "盖州市"
            },
            {
              "value": "668",
              "text": "大石桥市"
            }
          ]
        },
        {
          "value": "669",
          "text": "阜新市",
          "children": [
            {
              "value": "670",
              "text": "海州区"
            },
            {
              "value": "671",
              "text": "新邱区"
            },
            {
              "value": "672",
              "text": "太平区"
            },
            {
              "value": "673",
              "text": "清河门区"
            },
            {
              "value": "674",
              "text": "细河区"
            },
            {
              "value": "675",
              "text": "阜新县"
            },
            {
              "value": "676",
              "text": "彰武县"
            }
          ]
        },
        {
          "value": "677",
          "text": "辽阳市",
          "children": [
            {
              "value": "678",
              "text": "白塔区"
            },
            {
              "value": "679",
              "text": "文圣区"
            },
            {
              "value": "680",
              "text": "宏伟区"
            },
            {
              "value": "681",
              "text": "弓长岭区"
            },
            {
              "value": "682",
              "text": "太子河区"
            },
            {
              "value": "683",
              "text": "辽阳县"
            },
            {
              "value": "684",
              "text": "灯塔市"
            }
          ]
        },
        {
          "value": "685",
          "text": "盘锦市",
          "children": [
            {
              "value": "686",
              "text": "双台子区"
            },
            {
              "value": "687",
              "text": "兴隆台区"
            },
            {
              "value": "688",
              "text": "大洼县"
            },
            {
              "value": "689",
              "text": "盘山县"
            }
          ]
        },
        {
          "value": "690",
          "text": "铁岭市",
          "children": [
            {
              "value": "691",
              "text": "银州区"
            },
            {
              "value": "692",
              "text": "清河区"
            },
            {
              "value": "693",
              "text": "铁岭县"
            },
            {
              "value": "694",
              "text": "西丰县"
            },
            {
              "value": "695",
              "text": "昌图县"
            },
            {
              "value": "696",
              "text": "调兵山市"
            },
            {
              "value": "697",
              "text": "开原市"
            },
            {
              "value": "3623",
              "text": "新城区"
            }
          ]
        },
        {
          "value": "698",
          "text": "朝阳市",
          "children": [
            {
              "value": "699",
              "text": "双塔区"
            },
            {
              "value": "700",
              "text": "龙城区"
            },
            {
              "value": "701",
              "text": "朝阳县"
            },
            {
              "value": "702",
              "text": "建平县"
            },
            {
              "value": "703",
              "text": "喀喇沁左翼县"
            },
            {
              "value": "704",
              "text": "北票市"
            },
            {
              "value": "705",
              "text": "凌源市"
            }
          ]
        },
        {
          "value": "706",
          "text": "葫芦岛市",
          "children": [
            {
              "value": "707",
              "text": "连山区"
            },
            {
              "value": "708",
              "text": "龙港区"
            },
            {
              "value": "709",
              "text": "南票区"
            },
            {
              "value": "710",
              "text": "绥中县"
            },
            {
              "value": "711",
              "text": "建昌县"
            },
            {
              "value": "712",
              "text": "兴城市"
            }
          ]
        }
      ]
    },
    {
      "value": "713",
      "text": "吉林省",
      "children": [
        {
          "value": "714",
          "text": "长春市",
          "children": [
            {
              "value": "715",
              "text": "南关区"
            },
            {
              "value": "716",
              "text": "宽城区"
            },
            {
              "value": "717",
              "text": "朝阳区"
            },
            {
              "value": "718",
              "text": "二道区"
            },
            {
              "value": "719",
              "text": "绿园区"
            },
            {
              "value": "720",
              "text": "双阳区"
            },
            {
              "value": "721",
              "text": "农安县"
            },
            {
              "value": "722",
              "text": "九台市"
            },
            {
              "value": "723",
              "text": "榆树市"
            },
            {
              "value": "724",
              "text": "德惠市"
            },
            {
              "value": "3557",
              "text": "净月区"
            },
            {
              "value": "3706",
              "text": "汽车产业开发区"
            },
            {
              "value": "3707",
              "text": "经济技术开发区"
            },
            {
              "value": "3708",
              "text": "高新技术开发区"
            }
          ]
        },
        {
          "value": "725",
          "text": "吉林市",
          "children": [
            {
              "value": "726",
              "text": "昌邑区"
            },
            {
              "value": "727",
              "text": "龙潭区"
            },
            {
              "value": "728",
              "text": "船营区"
            },
            {
              "value": "729",
              "text": "丰满区"
            },
            {
              "value": "730",
              "text": "永吉县"
            },
            {
              "value": "731",
              "text": "蛟河市"
            },
            {
              "value": "732",
              "text": "桦甸市"
            },
            {
              "value": "733",
              "text": "舒兰市"
            },
            {
              "value": "734",
              "text": "磐石市"
            }
          ]
        },
        {
          "value": "735",
          "text": "四平市",
          "children": [
            {
              "value": "736",
              "text": "铁西区"
            },
            {
              "value": "737",
              "text": "铁东区"
            },
            {
              "value": "738",
              "text": "梨树县"
            },
            {
              "value": "739",
              "text": "伊通县"
            },
            {
              "value": "740",
              "text": "公主岭市"
            },
            {
              "value": "741",
              "text": "双辽市"
            }
          ]
        },
        {
          "value": "742",
          "text": "辽源市",
          "children": [
            {
              "value": "743",
              "text": "龙山区"
            },
            {
              "value": "744",
              "text": "西安区"
            },
            {
              "value": "745",
              "text": "东丰县"
            },
            {
              "value": "746",
              "text": "东辽县"
            }
          ]
        },
        {
          "value": "747",
          "text": "通化市",
          "children": [
            {
              "value": "748",
              "text": "东昌区"
            },
            {
              "value": "749",
              "text": "二道江区"
            },
            {
              "value": "750",
              "text": "通化县"
            },
            {
              "value": "751",
              "text": "辉南县"
            },
            {
              "value": "752",
              "text": "柳河县"
            },
            {
              "value": "753",
              "text": "梅河口市"
            },
            {
              "value": "754",
              "text": "集安市"
            }
          ]
        },
        {
          "value": "755",
          "text": "白山市",
          "children": [
            {
              "value": "756",
              "text": "八道江区"
            },
            {
              "value": "757",
              "text": "抚松县"
            },
            {
              "value": "758",
              "text": "靖宇县"
            },
            {
              "value": "759",
              "text": "长白县"
            },
            {
              "value": "760",
              "text": "江源区"
            },
            {
              "value": "761",
              "text": "临江市"
            },
            {
              "value": "3626",
              "text": "浑江区"
            }
          ]
        },
        {
          "value": "762",
          "text": "松原市",
          "children": [
            {
              "value": "763",
              "text": "宁江区"
            },
            {
              "value": "764",
              "text": "前郭县"
            },
            {
              "value": "765",
              "text": "长岭县"
            },
            {
              "value": "766",
              "text": "乾安县"
            },
            {
              "value": "767",
              "text": "扶余县"
            }
          ]
        },
        {
          "value": "768",
          "text": "白城市",
          "children": [
            {
              "value": "769",
              "text": "洮北区"
            },
            {
              "value": "770",
              "text": "镇赉县"
            },
            {
              "value": "771",
              "text": "通榆县"
            },
            {
              "value": "772",
              "text": "洮南市"
            },
            {
              "value": "773",
              "text": "大安市"
            }
          ]
        },
        {
          "value": "774",
          "text": "延边朝鲜族自治州",
          "children": [
            {
              "value": "775",
              "text": "延吉市"
            },
            {
              "value": "776",
              "text": "图们市"
            },
            {
              "value": "777",
              "text": "敦化市"
            },
            {
              "value": "778",
              "text": "珲春市"
            },
            {
              "value": "779",
              "text": "龙井市"
            },
            {
              "value": "780",
              "text": "和龙市"
            },
            {
              "value": "781",
              "text": "汪清县"
            },
            {
              "value": "782",
              "text": "安图县"
            }
          ]
        },
        {
          "value": "3634",
          "text": "梅河口",
          "children": [
            {
              "value": "3634",
              "text": "梅河口"
            }
          ]
        },
        {
          "value": "3635",
          "text": "公主岭",
          "children": [
            {
              "value": "3635",
              "text": "公主岭"
            }
          ]
        }
      ]
    },
    {
      "value": "783",
      "text": "黑龙江省",
      "children": [
        {
          "value": "784",
          "text": "哈尔滨市",
          "children": [
            {
              "value": "785",
              "text": "道里区"
            },
            {
              "value": "786",
              "text": "南岗区"
            },
            {
              "value": "787",
              "text": "道外区"
            },
            {
              "value": "788",
              "text": "松北区"
            },
            {
              "value": "789",
              "text": "香坊区"
            },
            {
              "value": "790",
              "text": "阿成区"
            },
            {
              "value": "791",
              "text": "平房区"
            },
            {
              "value": "792",
              "text": "呼兰区"
            },
            {
              "value": "793",
              "text": "依兰县"
            },
            {
              "value": "794",
              "text": "方正县"
            },
            {
              "value": "795",
              "text": "宾县"
            },
            {
              "value": "796",
              "text": "巴彦县"
            },
            {
              "value": "797",
              "text": "木兰县"
            },
            {
              "value": "798",
              "text": "通河县"
            },
            {
              "value": "799",
              "text": "延寿县"
            },
            {
              "value": "800",
              "text": "双城市"
            },
            {
              "value": "801",
              "text": "尚志市"
            },
            {
              "value": "802",
              "text": "五常市"
            },
            {
              "value": "3678",
              "text": "阿城区"
            }
          ]
        },
        {
          "value": "803",
          "text": "齐齐哈尔市",
          "children": [
            {
              "value": "804",
              "text": "龙沙区"
            },
            {
              "value": "805",
              "text": "建华区"
            },
            {
              "value": "806",
              "text": "铁锋区"
            },
            {
              "value": "807",
              "text": "昂昂溪区"
            },
            {
              "value": "808",
              "text": "富拉尔基区"
            },
            {
              "value": "809",
              "text": "碾子山区"
            },
            {
              "value": "810",
              "text": "梅里斯区"
            },
            {
              "value": "811",
              "text": "龙江县"
            },
            {
              "value": "812",
              "text": "依安县"
            },
            {
              "value": "813",
              "text": "泰来县"
            },
            {
              "value": "814",
              "text": "甘南县"
            },
            {
              "value": "815",
              "text": "富裕县"
            },
            {
              "value": "816",
              "text": "克山县"
            },
            {
              "value": "817",
              "text": "克东县"
            },
            {
              "value": "818",
              "text": "拜泉县"
            },
            {
              "value": "819",
              "text": "讷河市"
            }
          ]
        },
        {
          "value": "820",
          "text": "鸡西市",
          "children": [
            {
              "value": "821",
              "text": "鸡冠区"
            },
            {
              "value": "822",
              "text": "恒山区"
            },
            {
              "value": "823",
              "text": "滴道区"
            },
            {
              "value": "824",
              "text": "梨树区"
            },
            {
              "value": "825",
              "text": "城子河区"
            },
            {
              "value": "826",
              "text": "麻山区"
            },
            {
              "value": "827",
              "text": "鸡东县"
            },
            {
              "value": "828",
              "text": "虎林市"
            },
            {
              "value": "829",
              "text": "密山市"
            }
          ]
        },
        {
          "value": "830",
          "text": "鹤岗市",
          "children": [
            {
              "value": "831",
              "text": "向阳区"
            },
            {
              "value": "832",
              "text": "工农区"
            },
            {
              "value": "833",
              "text": "南山区"
            },
            {
              "value": "834",
              "text": "兴安区"
            },
            {
              "value": "835",
              "text": "东山区"
            },
            {
              "value": "836",
              "text": "兴山区"
            },
            {
              "value": "837",
              "text": "萝北县"
            },
            {
              "value": "838",
              "text": "绥滨县"
            }
          ]
        },
        {
          "value": "839",
          "text": "双鸭山市",
          "children": [
            {
              "value": "840",
              "text": "尖山区"
            },
            {
              "value": "841",
              "text": "岭东区"
            },
            {
              "value": "842",
              "text": "四方台区"
            },
            {
              "value": "843",
              "text": "宝山区"
            },
            {
              "value": "844",
              "text": "集贤县"
            },
            {
              "value": "845",
              "text": "友谊县"
            },
            {
              "value": "846",
              "text": "宝清县"
            },
            {
              "value": "847",
              "text": "饶河县"
            }
          ]
        },
        {
          "value": "848",
          "text": "大庆市",
          "children": [
            {
              "value": "849",
              "text": "萨尔图区"
            },
            {
              "value": "850",
              "text": "龙凤区"
            },
            {
              "value": "851",
              "text": "让胡路区"
            },
            {
              "value": "852",
              "text": "红岗区"
            },
            {
              "value": "853",
              "text": "大同区"
            },
            {
              "value": "854",
              "text": "肇州县"
            },
            {
              "value": "855",
              "text": "肇源县"
            },
            {
              "value": "856",
              "text": "林甸县"
            },
            {
              "value": "857",
              "text": "杜尔伯特县"
            }
          ]
        },
        {
          "value": "858",
          "text": "伊春市",
          "children": [
            {
              "value": "859",
              "text": "伊春区"
            },
            {
              "value": "860",
              "text": "南岔区"
            },
            {
              "value": "861",
              "text": "友好区"
            },
            {
              "value": "862",
              "text": "西林区"
            },
            {
              "value": "863",
              "text": "翠峦区"
            },
            {
              "value": "864",
              "text": "新青区"
            },
            {
              "value": "865",
              "text": "美溪区"
            },
            {
              "value": "866",
              "text": "金山屯区"
            },
            {
              "value": "867",
              "text": "五营区"
            },
            {
              "value": "868",
              "text": "乌马河区"
            },
            {
              "value": "869",
              "text": "汤旺河区"
            },
            {
              "value": "870",
              "text": "带岭区"
            },
            {
              "value": "871",
              "text": "乌伊岭区"
            },
            {
              "value": "872",
              "text": "红星区"
            },
            {
              "value": "873",
              "text": "上甘岭区"
            },
            {
              "value": "874",
              "text": "嘉荫县"
            },
            {
              "value": "875",
              "text": "铁力市"
            }
          ]
        },
        {
          "value": "876",
          "text": "佳木斯市",
          "children": [
            {
              "value": "877",
              "text": "向阳区"
            },
            {
              "value": "878",
              "text": "前进区"
            },
            {
              "value": "879",
              "text": "东风区"
            },
            {
              "value": "880",
              "text": "郊区"
            },
            {
              "value": "881",
              "text": "桦南县"
            },
            {
              "value": "882",
              "text": "桦川县"
            },
            {
              "value": "883",
              "text": "汤原县"
            },
            {
              "value": "884",
              "text": "抚远县"
            },
            {
              "value": "885",
              "text": "同江市"
            },
            {
              "value": "886",
              "text": "富锦市"
            }
          ]
        },
        {
          "value": "887",
          "text": "七台河市",
          "children": [
            {
              "value": "888",
              "text": "新兴区"
            },
            {
              "value": "889",
              "text": "桃山区"
            },
            {
              "value": "890",
              "text": "茄子河区"
            },
            {
              "value": "891",
              "text": "勃利县"
            },
            {
              "value": "3732",
              "text": "金沙新区"
            }
          ]
        },
        {
          "value": "892",
          "text": "牡丹江市",
          "children": [
            {
              "value": "893",
              "text": "东安区"
            },
            {
              "value": "894",
              "text": "阳明区"
            },
            {
              "value": "895",
              "text": "爱民区"
            },
            {
              "value": "896",
              "text": "西安区"
            },
            {
              "value": "897",
              "text": "东宁县"
            },
            {
              "value": "898",
              "text": "林口县"
            },
            {
              "value": "899",
              "text": "绥芬河市"
            },
            {
              "value": "900",
              "text": "海林市"
            },
            {
              "value": "901",
              "text": "宁安市"
            },
            {
              "value": "902",
              "text": "穆棱市"
            }
          ]
        },
        {
          "value": "903",
          "text": "黑河市",
          "children": [
            {
              "value": "904",
              "text": "爱辉区"
            },
            {
              "value": "905",
              "text": "嫩江县"
            },
            {
              "value": "906",
              "text": "逊克县"
            },
            {
              "value": "907",
              "text": "孙吴县"
            },
            {
              "value": "908",
              "text": "北安市"
            },
            {
              "value": "909",
              "text": "五大连池市"
            }
          ]
        },
        {
          "value": "910",
          "text": "绥化市",
          "children": [
            {
              "value": "911",
              "text": "安达市"
            },
            {
              "value": "912",
              "text": "肇东市"
            },
            {
              "value": "913",
              "text": "海伦市"
            },
            {
              "value": "914",
              "text": "望奎县"
            },
            {
              "value": "915",
              "text": "兰西县"
            },
            {
              "value": "916",
              "text": "青冈县"
            },
            {
              "value": "917",
              "text": "庆安县"
            },
            {
              "value": "918",
              "text": "明水县"
            },
            {
              "value": "919",
              "text": "绥棱县"
            },
            {
              "value": "3625",
              "text": "北林区"
            }
          ]
        },
        {
          "value": "920",
          "text": "大兴安岭地区",
          "children": [
            {
              "value": "921",
              "text": "呼玛县"
            },
            {
              "value": "922",
              "text": "塔河县"
            },
            {
              "value": "923",
              "text": "漠河县"
            },
            {
              "value": "3682",
              "text": "新林区"
            },
            {
              "value": "3683",
              "text": "松岭区"
            },
            {
              "value": "3684",
              "text": "加格达奇区"
            },
            {
              "value": "3685",
              "text": "呼中区"
            }
          ]
        }
      ]
    },
    {
      "value": "924",
      "text": "上海市",
      "children": [
        {
          "value": "925",
          "text": "上海市",
          "children": [
            {
              "value": "926",
              "text": "浦东新区"
            },
            {
              "value": "927",
              "text": "徐汇区"
            },
            {
              "value": "928",
              "text": "黄浦区"
            },
            {
              "value": "929",
              "text": "杨浦区"
            },
            {
              "value": "930",
              "text": "虹口区"
            },
            {
              "value": "931",
              "text": "闵行区"
            },
            {
              "value": "932",
              "text": "长宁区"
            },
            {
              "value": "933",
              "text": "普陀区"
            },
            {
              "value": "934",
              "text": "宝山区"
            },
            {
              "value": "935",
              "text": "静安区"
            },
            {
              "value": "936",
              "text": "闸北区"
            },
            {
              "value": "937",
              "text": "卢湾区"
            },
            {
              "value": "938",
              "text": "松江区"
            },
            {
              "value": "939",
              "text": "嘉定区"
            },
            {
              "value": "940",
              "text": "南汇区"
            },
            {
              "value": "941",
              "text": "金山区"
            },
            {
              "value": "942",
              "text": "青浦区"
            },
            {
              "value": "943",
              "text": "奉贤区"
            },
            {
              "value": "944",
              "text": "崇明县"
            }
          ]
        }
      ]
    },
    {
      "value": "945",
      "text": "江苏省",
      "children": [
        {
          "value": "946",
          "text": "南京市",
          "children": [
            {
              "value": "947",
              "text": "玄武区"
            },
            {
              "value": "948",
              "text": "白下区"
            },
            {
              "value": "949",
              "text": "秦淮区"
            },
            {
              "value": "950",
              "text": "建邺区"
            },
            {
              "value": "951",
              "text": "鼓楼区"
            },
            {
              "value": "952",
              "text": "下关区"
            },
            {
              "value": "953",
              "text": "浦口区"
            },
            {
              "value": "954",
              "text": "栖霞区"
            },
            {
              "value": "955",
              "text": "雨花台区"
            },
            {
              "value": "956",
              "text": "江宁区"
            },
            {
              "value": "957",
              "text": "六合区"
            },
            {
              "value": "958",
              "text": "溧水区"
            },
            {
              "value": "959",
              "text": "高淳区"
            }
          ]
        },
        {
          "value": "960",
          "text": "无锡市",
          "children": [
            {
              "value": "961",
              "text": "崇安区"
            },
            {
              "value": "962",
              "text": "南长区"
            },
            {
              "value": "963",
              "text": "北塘区"
            },
            {
              "value": "964",
              "text": "郊区"
            },
            {
              "value": "965",
              "text": "滨湖区"
            },
            {
              "value": "966",
              "text": "江阴市"
            },
            {
              "value": "967",
              "text": "宜兴市"
            },
            {
              "value": "968",
              "text": "锡山区"
            },
            {
              "value": "3637",
              "text": "惠山区"
            },
            {
              "value": "3715",
              "text": "新区"
            },
            {
              "value": "3716",
              "text": "新吴区"
            },
            {
              "value": "3717",
              "text": "梁溪区"
            }
          ]
        },
        {
          "value": "969",
          "text": "徐州市",
          "children": [
            {
              "value": "970",
              "text": "鼓楼区"
            },
            {
              "value": "971",
              "text": "云龙区"
            },
            {
              "value": "972",
              "text": "九里区"
            },
            {
              "value": "973",
              "text": "贾汪区"
            },
            {
              "value": "974",
              "text": "泉山区"
            },
            {
              "value": "975",
              "text": "丰县"
            },
            {
              "value": "976",
              "text": "沛县"
            },
            {
              "value": "977",
              "text": "铜山区"
            },
            {
              "value": "978",
              "text": "睢宁县"
            },
            {
              "value": "979",
              "text": "新沂市"
            },
            {
              "value": "980",
              "text": "邳州市"
            },
            {
              "value": "3712",
              "text": "铜山经济技术开发区"
            },
            {
              "value": "3713",
              "text": "金山桥开发区"
            },
            {
              "value": "3714",
              "text": "八段工业园区"
            }
          ]
        },
        {
          "value": "981",
          "text": "常州市",
          "children": [
            {
              "value": "982",
              "text": "天宁区"
            },
            {
              "value": "983",
              "text": "钟楼区"
            },
            {
              "value": "984",
              "text": "戚墅堰区"
            },
            {
              "value": "985",
              "text": "郊区"
            },
            {
              "value": "986",
              "text": "溧阳市"
            },
            {
              "value": "987",
              "text": "金坛市"
            },
            {
              "value": "988",
              "text": "武进区"
            },
            {
              "value": "3558",
              "text": "新北区"
            },
            {
              "value": "3711",
              "text": "金坛区"
            }
          ]
        },
        {
          "value": "989",
          "text": "苏州市",
          "children": [
            {
              "value": "990",
              "text": "姑苏区"
            },
            {
              "value": "991",
              "text": "相城区"
            },
            {
              "value": "992",
              "text": "虎丘区"
            },
            {
              "value": "993",
              "text": "工业园区"
            },
            {
              "value": "994",
              "text": "常熟市"
            },
            {
              "value": "995",
              "text": "张家港市"
            },
            {
              "value": "996",
              "text": "昆山市"
            },
            {
              "value": "997",
              "text": "吴江区"
            },
            {
              "value": "998",
              "text": "太仓市"
            },
            {
              "value": "999",
              "text": "吴中区"
            },
            {
              "value": "3719",
              "text": "金阊区"
            },
            {
              "value": "3720",
              "text": "高新区"
            },
            {
              "value": "3721",
              "text": "平江区"
            },
            {
              "value": "3722",
              "text": "沧浪区"
            }
          ]
        },
        {
          "value": "1000",
          "text": "南通市",
          "children": [
            {
              "value": "1001",
              "text": "崇川区"
            },
            {
              "value": "1002",
              "text": "港闸区"
            },
            {
              "value": "1003",
              "text": "海安县"
            },
            {
              "value": "1004",
              "text": "如东县"
            },
            {
              "value": "1005",
              "text": "启东市"
            },
            {
              "value": "1006",
              "text": "如皋市"
            },
            {
              "value": "1007",
              "text": "通州区"
            },
            {
              "value": "1008",
              "text": "海门市"
            },
            {
              "value": "3709",
              "text": "南通经济技术开发区"
            }
          ]
        },
        {
          "value": "1009",
          "text": "连云港市",
          "children": [
            {
              "value": "1010",
              "text": "连云区"
            },
            {
              "value": "1011",
              "text": "云台区"
            },
            {
              "value": "1012",
              "text": "新浦区"
            },
            {
              "value": "1013",
              "text": "海州区"
            },
            {
              "value": "1014",
              "text": "赣榆县"
            },
            {
              "value": "1015",
              "text": "东海县"
            },
            {
              "value": "1016",
              "text": "灌云县"
            },
            {
              "value": "1017",
              "text": "灌南县"
            }
          ]
        },
        {
          "value": "1018",
          "text": "淮安市",
          "children": [
            {
              "value": "1019",
              "text": "清江浦区"
            },
            {
              "value": "1020",
              "text": "清浦区"
            },
            {
              "value": "1021",
              "text": "淮阴区"
            },
            {
              "value": "1022",
              "text": "涟水县"
            },
            {
              "value": "1023",
              "text": "洪泽县"
            },
            {
              "value": "1024",
              "text": "盱眙县"
            },
            {
              "value": "1025",
              "text": "金湖县"
            },
            {
              "value": "1026",
              "text": "淮安区"
            },
            {
              "value": "3676",
              "text": "清河区"
            }
          ]
        },
        {
          "value": "1027",
          "text": "盐城市",
          "children": [
            {
              "value": "1028",
              "text": "亭湖区"
            },
            {
              "value": "1029",
              "text": "响水县"
            },
            {
              "value": "1030",
              "text": "滨海县"
            },
            {
              "value": "1031",
              "text": "阜宁县"
            },
            {
              "value": "1032",
              "text": "射阳县"
            },
            {
              "value": "1033",
              "text": "建湖县"
            },
            {
              "value": "1034",
              "text": "盐都区"
            },
            {
              "value": "1035",
              "text": "东台市"
            },
            {
              "value": "1036",
              "text": "大丰区"
            }
          ]
        },
        {
          "value": "1037",
          "text": "扬州市",
          "children": [
            {
              "value": "1038",
              "text": "广陵区"
            },
            {
              "value": "1039",
              "text": "郊区"
            },
            {
              "value": "1040",
              "text": "宝应县"
            },
            {
              "value": "1041",
              "text": "邗江区"
            },
            {
              "value": "1042",
              "text": "仪征市"
            },
            {
              "value": "1043",
              "text": "高邮市"
            },
            {
              "value": "1044",
              "text": "江都区"
            }
          ]
        },
        {
          "value": "1045",
          "text": "镇江市",
          "children": [
            {
              "value": "1046",
              "text": "京口区"
            },
            {
              "value": "1047",
              "text": "润州区"
            },
            {
              "value": "1048",
              "text": "丹徒区"
            },
            {
              "value": "1049",
              "text": "丹阳市"
            },
            {
              "value": "1050",
              "text": "扬中市"
            },
            {
              "value": "1051",
              "text": "句容市"
            },
            {
              "value": "3723",
              "text": "镇江新区"
            },
            {
              "value": "3724",
              "text": "丹徒新区"
            }
          ]
        },
        {
          "value": "1052",
          "text": "泰州市",
          "children": [
            {
              "value": "1053",
              "text": "海陵区"
            },
            {
              "value": "1054",
              "text": "高港区"
            },
            {
              "value": "1055",
              "text": "兴化市"
            },
            {
              "value": "1056",
              "text": "靖江市"
            },
            {
              "value": "1057",
              "text": "泰兴市"
            },
            {
              "value": "1058",
              "text": "姜堰市"
            },
            {
              "value": "3718",
              "text": "泰州医药高新区"
            }
          ]
        },
        {
          "value": "1059",
          "text": "宿迁市",
          "children": [
            {
              "value": "1060",
              "text": "宿城区"
            },
            {
              "value": "1061",
              "text": "宿豫区"
            },
            {
              "value": "1062",
              "text": "沭阳县"
            },
            {
              "value": "1063",
              "text": "泗阳县"
            },
            {
              "value": "1064",
              "text": "泗洪县"
            },
            {
              "value": "3710",
              "text": "宿迁经济开发区"
            }
          ]
        }
      ]
    },
    {
      "value": "1065",
      "text": "浙江省",
      "children": [
        {
          "value": "1066",
          "text": "杭州市",
          "children": [
            {
              "value": "1067",
              "text": "上城区"
            },
            {
              "value": "1068",
              "text": "下城区"
            },
            {
              "value": "1069",
              "text": "江干区"
            },
            {
              "value": "1070",
              "text": "拱墅区"
            },
            {
              "value": "1071",
              "text": "西湖区"
            },
            {
              "value": "1072",
              "text": "滨江区"
            },
            {
              "value": "1073",
              "text": "桐庐县"
            },
            {
              "value": "1074",
              "text": "淳安县"
            },
            {
              "value": "1075",
              "text": "萧山区"
            },
            {
              "value": "1076",
              "text": "建德市"
            },
            {
              "value": "1077",
              "text": "富阳区"
            },
            {
              "value": "1078",
              "text": "余杭区"
            },
            {
              "value": "1079",
              "text": "临安市"
            },
            {
              "value": "3982",
              "text": "下沙区"
            }
          ]
        },
        {
          "value": "1080",
          "text": "宁波市",
          "children": [
            {
              "value": "1081",
              "text": "海曙区"
            },
            {
              "value": "1082",
              "text": "江东区"
            },
            {
              "value": "1083",
              "text": "江北区"
            },
            {
              "value": "1084",
              "text": "北仑区"
            },
            {
              "value": "1085",
              "text": "镇海区"
            },
            {
              "value": "1086",
              "text": "象山县"
            },
            {
              "value": "1087",
              "text": "宁海县"
            },
            {
              "value": "1088",
              "text": "鄞州区"
            },
            {
              "value": "1089",
              "text": "余姚市"
            },
            {
              "value": "1090",
              "text": "慈溪市"
            },
            {
              "value": "1091",
              "text": "奉化市"
            },
            {
              "value": "3989",
              "text": "高新科技开发区"
            }
          ]
        },
        {
          "value": "1092",
          "text": "温州市",
          "children": [
            {
              "value": "1093",
              "text": "鹿城区"
            },
            {
              "value": "1094",
              "text": "龙湾区"
            },
            {
              "value": "1095",
              "text": "瓯海区"
            },
            {
              "value": "1096",
              "text": "洞头区"
            },
            {
              "value": "1097",
              "text": "永嘉县"
            },
            {
              "value": "1098",
              "text": "平阳县"
            },
            {
              "value": "1099",
              "text": "苍南县"
            },
            {
              "value": "1100",
              "text": "文成县"
            },
            {
              "value": "1101",
              "text": "泰顺县"
            },
            {
              "value": "1102",
              "text": "瑞安市"
            },
            {
              "value": "1103",
              "text": "乐清市"
            },
            {
              "value": "3968",
              "text": "茶山高教园区"
            }
          ]
        },
        {
          "value": "1104",
          "text": "嘉兴市",
          "children": [
            {
              "value": "1105",
              "text": "秀城区"
            },
            {
              "value": "1106",
              "text": "郊区"
            },
            {
              "value": "1107",
              "text": "嘉善县"
            },
            {
              "value": "1108",
              "text": "海盐县"
            },
            {
              "value": "1109",
              "text": "海宁市"
            },
            {
              "value": "1110",
              "text": "平湖市"
            },
            {
              "value": "1111",
              "text": "桐乡市"
            },
            {
              "value": "3645",
              "text": "秀洲区"
            },
            {
              "value": "3646",
              "text": "南湖区"
            }
          ]
        },
        {
          "value": "1112",
          "text": "湖州市",
          "children": [
            {
              "value": "1113",
              "text": "吴兴区"
            },
            {
              "value": "1114",
              "text": "南浔区"
            },
            {
              "value": "1115",
              "text": "德清县"
            },
            {
              "value": "1116",
              "text": "长兴县"
            },
            {
              "value": "1117",
              "text": "安吉县"
            }
          ]
        },
        {
          "value": "1118",
          "text": "绍兴市",
          "children": [
            {
              "value": "1119",
              "text": "越城区"
            },
            {
              "value": "1120",
              "text": "柯桥区"
            },
            {
              "value": "1121",
              "text": "新昌县"
            },
            {
              "value": "1122",
              "text": "诸暨市"
            },
            {
              "value": "1123",
              "text": "上虞区"
            },
            {
              "value": "1124",
              "text": "嵊州市"
            }
          ]
        },
        {
          "value": "1125",
          "text": "金华市",
          "children": [
            {
              "value": "1126",
              "text": "婺城区"
            },
            {
              "value": "1127",
              "text": "金东区"
            },
            {
              "value": "1128",
              "text": "武义县"
            },
            {
              "value": "1129",
              "text": "浦江县"
            },
            {
              "value": "1130",
              "text": "磐安县"
            },
            {
              "value": "1131",
              "text": "兰溪市"
            },
            {
              "value": "1132",
              "text": "义乌市"
            },
            {
              "value": "1133",
              "text": "东阳市"
            },
            {
              "value": "1134",
              "text": "永康市"
            }
          ]
        },
        {
          "value": "1135",
          "text": "衢州市",
          "children": [
            {
              "value": "1136",
              "text": "柯城区"
            },
            {
              "value": "1137",
              "text": "衢江区"
            },
            {
              "value": "1138",
              "text": "常山县"
            },
            {
              "value": "1139",
              "text": "开化县"
            },
            {
              "value": "1140",
              "text": "龙游县"
            },
            {
              "value": "1141",
              "text": "江山市"
            }
          ]
        },
        {
          "value": "1142",
          "text": "舟山市",
          "children": [
            {
              "value": "1143",
              "text": "定海区"
            },
            {
              "value": "1144",
              "text": "普陀区"
            },
            {
              "value": "1145",
              "text": "岱山县"
            },
            {
              "value": "1146",
              "text": "嵊泗县"
            }
          ]
        },
        {
          "value": "1147",
          "text": "台州市",
          "children": [
            {
              "value": "1148",
              "text": "椒江区"
            },
            {
              "value": "1149",
              "text": "黄岩区"
            },
            {
              "value": "1150",
              "text": "路桥区"
            },
            {
              "value": "1151",
              "text": "玉环县"
            },
            {
              "value": "1152",
              "text": "三门县"
            },
            {
              "value": "1153",
              "text": "天台县"
            },
            {
              "value": "1154",
              "text": "仙居县"
            },
            {
              "value": "1155",
              "text": "温岭市"
            },
            {
              "value": "1156",
              "text": "临海市"
            }
          ]
        },
        {
          "value": "1157",
          "text": "丽水市",
          "children": [
            {
              "value": "1158",
              "text": "莲都区"
            },
            {
              "value": "1159",
              "text": "龙泉市"
            },
            {
              "value": "1160",
              "text": "青田县"
            },
            {
              "value": "1161",
              "text": "云和县"
            },
            {
              "value": "1162",
              "text": "庆元县"
            },
            {
              "value": "1163",
              "text": "缙云县"
            },
            {
              "value": "1164",
              "text": "遂昌县"
            },
            {
              "value": "1165",
              "text": "松阳县"
            },
            {
              "value": "1166",
              "text": "景宁县"
            }
          ]
        }
      ]
    },
    {
      "value": "1167",
      "text": "安徽省",
      "children": [
        {
          "value": "1168",
          "text": "合肥市",
          "children": [
            {
              "value": "1173",
              "text": "长丰县"
            },
            {
              "value": "1174",
              "text": "肥东县"
            },
            {
              "value": "1175",
              "text": "肥西县"
            },
            {
              "value": "3414",
              "text": "包河区"
            },
            {
              "value": "3415",
              "text": "蜀山区"
            },
            {
              "value": "3416",
              "text": "庐阳区"
            },
            {
              "value": "3417",
              "text": "瑶海区"
            },
            {
              "value": "3418",
              "text": "庐江县"
            },
            {
              "value": "3419",
              "text": "巢湖市"
            },
            {
              "value": "3420",
              "text": "高新区"
            },
            {
              "value": "3851",
              "text": "北城新区"
            },
            {
              "value": "3853",
              "text": "政务文化新区"
            },
            {
              "value": "3856",
              "text": "新站综合开发试验区"
            },
            {
              "value": "3911",
              "text": "经济技术开发区"
            },
            {
              "value": "3916",
              "text": "滨湖新区"
            }
          ]
        },
        {
          "value": "1176",
          "text": "芜湖市",
          "children": [
            {
              "value": "1177",
              "text": "镜湖区"
            },
            {
              "value": "1178",
              "text": "马塘区"
            },
            {
              "value": "1179",
              "text": "新芜区"
            },
            {
              "value": "1180",
              "text": "鸠江区"
            },
            {
              "value": "1181",
              "text": "芜湖县"
            },
            {
              "value": "1182",
              "text": "繁昌县"
            },
            {
              "value": "1183",
              "text": "南陵县"
            },
            {
              "value": "3647",
              "text": "弋江区"
            },
            {
              "value": "3648",
              "text": "三山区"
            },
            {
              "value": "3677",
              "text": "无为县"
            }
          ]
        },
        {
          "value": "1184",
          "text": "蚌埠市",
          "children": [
            {
              "value": "1185",
              "text": "龙子湖区"
            },
            {
              "value": "1186",
              "text": "蚌山区"
            },
            {
              "value": "1187",
              "text": "禹会区"
            },
            {
              "value": "1188",
              "text": "淮上区"
            },
            {
              "value": "1189",
              "text": "怀远县"
            },
            {
              "value": "1190",
              "text": "五河县"
            },
            {
              "value": "1191",
              "text": "固镇县"
            }
          ]
        },
        {
          "value": "1192",
          "text": "淮南市",
          "children": [
            {
              "value": "1193",
              "text": "大通区"
            },
            {
              "value": "1194",
              "text": "田家庵区"
            },
            {
              "value": "1195",
              "text": "谢家集区"
            },
            {
              "value": "1196",
              "text": "八公山区"
            },
            {
              "value": "1197",
              "text": "潘集区"
            },
            {
              "value": "1198",
              "text": "凤台县"
            },
            {
              "value": "1261",
              "text": "寿县"
            },
            {
              "value": "3847",
              "text": "淮南高新技术开发区"
            }
          ]
        },
        {
          "value": "1199",
          "text": "马鞍山市",
          "children": [
            {
              "value": "1200",
              "text": "金家庄区"
            },
            {
              "value": "1201",
              "text": "花山区"
            },
            {
              "value": "1202",
              "text": "雨山区"
            },
            {
              "value": "1203",
              "text": "当涂县"
            },
            {
              "value": "1278",
              "text": "含山县"
            },
            {
              "value": "1279",
              "text": "和县"
            },
            {
              "value": "3651",
              "text": "博望区"
            }
          ]
        },
        {
          "value": "1204",
          "text": "淮北市",
          "children": [
            {
              "value": "1205",
              "text": "杜集区"
            },
            {
              "value": "1206",
              "text": "相山区"
            },
            {
              "value": "1207",
              "text": "烈山区"
            },
            {
              "value": "1208",
              "text": "濉溪县"
            }
          ]
        },
        {
          "value": "1209",
          "text": "铜陵市",
          "children": [
            {
              "value": "1210",
              "text": "铜官区"
            },
            {
              "value": "1211",
              "text": "狮子山区"
            },
            {
              "value": "1212",
              "text": "郊区"
            },
            {
              "value": "1213",
              "text": "铜陵县"
            },
            {
              "value": "3935",
              "text": "枞阳县"
            },
            {
              "value": "3943",
              "text": "义安区"
            }
          ]
        },
        {
          "value": "1214",
          "text": "安庆市",
          "children": [
            {
              "value": "1215",
              "text": "迎江区"
            },
            {
              "value": "1216",
              "text": "大观区"
            },
            {
              "value": "1217",
              "text": "宜秀区"
            },
            {
              "value": "1218",
              "text": "怀宁县"
            },
            {
              "value": "1219",
              "text": "枞阳县"
            },
            {
              "value": "1220",
              "text": "潜山县"
            },
            {
              "value": "1221",
              "text": "太湖县"
            },
            {
              "value": "1222",
              "text": "宿松县"
            },
            {
              "value": "1223",
              "text": "望江县"
            },
            {
              "value": "1224",
              "text": "岳西县"
            },
            {
              "value": "1225",
              "text": "桐城市"
            }
          ]
        },
        {
          "value": "1226",
          "text": "黄山市",
          "children": [
            {
              "value": "1227",
              "text": "屯溪区"
            },
            {
              "value": "1228",
              "text": "黄山区"
            },
            {
              "value": "1229",
              "text": "徽州区"
            },
            {
              "value": "1230",
              "text": "歙县"
            },
            {
              "value": "1231",
              "text": "休宁县"
            },
            {
              "value": "1232",
              "text": "黟县"
            },
            {
              "value": "1233",
              "text": "祁门县"
            }
          ]
        },
        {
          "value": "1234",
          "text": "滁州市",
          "children": [
            {
              "value": "1235",
              "text": "琅琊区"
            },
            {
              "value": "1236",
              "text": "南谯区"
            },
            {
              "value": "1237",
              "text": "来安县"
            },
            {
              "value": "1238",
              "text": "全椒县"
            },
            {
              "value": "1239",
              "text": "定远县"
            },
            {
              "value": "1240",
              "text": "凤阳县"
            },
            {
              "value": "1241",
              "text": "天长市"
            },
            {
              "value": "1242",
              "text": "明光市"
            }
          ]
        },
        {
          "value": "1243",
          "text": "阜阳市",
          "children": [
            {
              "value": "1244",
              "text": "颍州区"
            },
            {
              "value": "1245",
              "text": "颍东区"
            },
            {
              "value": "1246",
              "text": "颍泉区"
            },
            {
              "value": "1247",
              "text": "临泉县"
            },
            {
              "value": "1248",
              "text": "太和县"
            },
            {
              "value": "1249",
              "text": "阜南县"
            },
            {
              "value": "1250",
              "text": "颍上县"
            },
            {
              "value": "1251",
              "text": "界首市"
            },
            {
              "value": "3962",
              "text": "经济开发区"
            }
          ]
        },
        {
          "value": "1252",
          "text": "宿州市",
          "children": [
            {
              "value": "1253",
              "text": "埇桥区"
            },
            {
              "value": "1254",
              "text": "砀山县"
            },
            {
              "value": "1255",
              "text": "萧县"
            },
            {
              "value": "1256",
              "text": "灵璧县"
            },
            {
              "value": "1257",
              "text": "泗县"
            },
            {
              "value": "3958",
              "text": "经济开发区"
            }
          ]
        },
        {
          "value": "1258",
          "text": "六安市",
          "children": [
            {
              "value": "1259",
              "text": "金安区"
            },
            {
              "value": "1260",
              "text": "裕安区"
            },
            {
              "value": "1262",
              "text": "霍邱县"
            },
            {
              "value": "1263",
              "text": "舒城县"
            },
            {
              "value": "1264",
              "text": "金寨县"
            },
            {
              "value": "1265",
              "text": "霍山县"
            },
            {
              "value": "3949",
              "text": "叶集区"
            }
          ]
        },
        {
          "value": "1266",
          "text": "宣城市",
          "children": [
            {
              "value": "1267",
              "text": "宣州区"
            },
            {
              "value": "1268",
              "text": "宁国市"
            },
            {
              "value": "1269",
              "text": "郎溪县"
            },
            {
              "value": "1270",
              "text": "广德县"
            },
            {
              "value": "1271",
              "text": "泾县"
            },
            {
              "value": "1272",
              "text": "旌德县"
            },
            {
              "value": "1273",
              "text": "绩溪县"
            }
          ]
        },
        {
          "value": "1274",
          "text": "巢湖市",
          "children": [
            {
              "value": "1275",
              "text": "巢湖区"
            },
            {
              "value": "1276",
              "text": "庐江县"
            },
            {
              "value": "1277",
              "text": "无为县"
            }
          ]
        },
        {
          "value": "1280",
          "text": "池州市",
          "children": [
            {
              "value": "1281",
              "text": "贵池区"
            },
            {
              "value": "1282",
              "text": "东至县"
            },
            {
              "value": "1283",
              "text": "石台县"
            },
            {
              "value": "1284",
              "text": "青阳县"
            }
          ]
        },
        {
          "value": "3403",
          "text": "亳州市",
          "children": [
            {
              "value": "3404",
              "text": "蒙城县"
            },
            {
              "value": "3620",
              "text": "谯城区"
            },
            {
              "value": "3621",
              "text": "涡阳县"
            },
            {
              "value": "3622",
              "text": "利辛县"
            }
          ]
        }
      ]
    },
    {
      "value": "1285",
      "text": "福建省",
      "children": [
        {
          "value": "1286",
          "text": "福州市",
          "children": [
            {
              "value": "1287",
              "text": "鼓楼区"
            },
            {
              "value": "1288",
              "text": "台江区"
            },
            {
              "value": "1289",
              "text": "仓山区"
            },
            {
              "value": "1290",
              "text": "马尾区"
            },
            {
              "value": "1291",
              "text": "晋安区"
            },
            {
              "value": "1292",
              "text": "闽侯县"
            },
            {
              "value": "1293",
              "text": "连江县"
            },
            {
              "value": "1294",
              "text": "罗源县"
            },
            {
              "value": "1295",
              "text": "闽清县"
            },
            {
              "value": "1296",
              "text": "永泰县"
            },
            {
              "value": "1297",
              "text": "平潭县"
            },
            {
              "value": "1298",
              "text": "福清市"
            },
            {
              "value": "1299",
              "text": "长乐市"
            }
          ]
        },
        {
          "value": "1300",
          "text": "厦门市",
          "children": [
            {
              "value": "1301",
              "text": "思明区"
            },
            {
              "value": "1302",
              "text": "海沧区"
            },
            {
              "value": "1303",
              "text": "湖里区"
            },
            {
              "value": "1304",
              "text": "集美区"
            },
            {
              "value": "1305",
              "text": "同安区"
            },
            {
              "value": "1306",
              "text": "翔安区"
            }
          ]
        },
        {
          "value": "1307",
          "text": "宁德市",
          "children": [
            {
              "value": "1308",
              "text": "蕉城区"
            },
            {
              "value": "1309",
              "text": "霞浦县"
            },
            {
              "value": "1310",
              "text": "古田县"
            },
            {
              "value": "1311",
              "text": "屏南县"
            },
            {
              "value": "1312",
              "text": "寿宁县"
            },
            {
              "value": "1313",
              "text": "周宁县"
            },
            {
              "value": "1314",
              "text": "柘荣县"
            },
            {
              "value": "1315",
              "text": "福安市"
            },
            {
              "value": "1316",
              "text": "福鼎市"
            },
            {
              "value": "3835",
              "text": "东侨开发区"
            }
          ]
        },
        {
          "value": "1317",
          "text": "莆田市",
          "children": [
            {
              "value": "1318",
              "text": "城厢区"
            },
            {
              "value": "1319",
              "text": "涵江区"
            },
            {
              "value": "1320",
              "text": "荔城区"
            },
            {
              "value": "1321",
              "text": "秀屿区"
            },
            {
              "value": "1322",
              "text": "仙游县"
            }
          ]
        },
        {
          "value": "1323",
          "text": "泉州市",
          "children": [
            {
              "value": "1324",
              "text": "鲤城区"
            },
            {
              "value": "1325",
              "text": "丰泽区"
            },
            {
              "value": "1326",
              "text": "洛江区"
            },
            {
              "value": "1327",
              "text": "泉港区"
            },
            {
              "value": "1328",
              "text": "惠安县"
            },
            {
              "value": "1329",
              "text": "安溪县"
            },
            {
              "value": "1330",
              "text": "永春县"
            },
            {
              "value": "1331",
              "text": "德化县"
            },
            {
              "value": "1332",
              "text": "金门县"
            },
            {
              "value": "1333",
              "text": "石狮市"
            },
            {
              "value": "1334",
              "text": "晋江市"
            },
            {
              "value": "1335",
              "text": "南安市"
            }
          ]
        },
        {
          "value": "1336",
          "text": "漳州市",
          "children": [
            {
              "value": "1337",
              "text": "芗城区"
            },
            {
              "value": "1338",
              "text": "龙文区"
            },
            {
              "value": "1339",
              "text": "云霄县"
            },
            {
              "value": "1340",
              "text": "漳浦县"
            },
            {
              "value": "1341",
              "text": "诏安县"
            },
            {
              "value": "1342",
              "text": "长泰县"
            },
            {
              "value": "1343",
              "text": "东山县"
            },
            {
              "value": "1344",
              "text": "南靖县"
            },
            {
              "value": "1345",
              "text": "平和县"
            },
            {
              "value": "1346",
              "text": "华安县"
            },
            {
              "value": "1347",
              "text": "龙海市"
            }
          ]
        },
        {
          "value": "1348",
          "text": "龙岩市",
          "children": [
            {
              "value": "1349",
              "text": "新罗区"
            },
            {
              "value": "1350",
              "text": "长汀县"
            },
            {
              "value": "1351",
              "text": "永定县"
            },
            {
              "value": "1352",
              "text": "上杭县"
            },
            {
              "value": "1353",
              "text": "武平县"
            },
            {
              "value": "1354",
              "text": "连城县"
            },
            {
              "value": "1355",
              "text": "漳平市"
            }
          ]
        },
        {
          "value": "1356",
          "text": "三明市",
          "children": [
            {
              "value": "1357",
              "text": "梅列区"
            },
            {
              "value": "1358",
              "text": "三元区"
            },
            {
              "value": "1359",
              "text": "明溪县"
            },
            {
              "value": "1360",
              "text": "清流县"
            },
            {
              "value": "1361",
              "text": "宁化县"
            },
            {
              "value": "1362",
              "text": "大田县"
            },
            {
              "value": "1363",
              "text": "尤溪县"
            },
            {
              "value": "1364",
              "text": "沙县"
            },
            {
              "value": "1365",
              "text": "将乐县"
            },
            {
              "value": "1366",
              "text": "泰宁县"
            },
            {
              "value": "1367",
              "text": "建宁县"
            },
            {
              "value": "1368",
              "text": "永安市"
            }
          ]
        },
        {
          "value": "1369",
          "text": "南平市",
          "children": [
            {
              "value": "1370",
              "text": "延平区"
            },
            {
              "value": "1371",
              "text": "顺昌县"
            },
            {
              "value": "1372",
              "text": "浦城县"
            },
            {
              "value": "1373",
              "text": "光泽县"
            },
            {
              "value": "1374",
              "text": "松溪县"
            },
            {
              "value": "1375",
              "text": "政和县"
            },
            {
              "value": "1376",
              "text": "邵武市"
            },
            {
              "value": "1377",
              "text": "武夷山市"
            },
            {
              "value": "1378",
              "text": "建瓯市"
            },
            {
              "value": "1379",
              "text": "建阳市"
            }
          ]
        },
        {
          "value": "3675",
          "text": "福安市",
          "children": [
            {
              "value": "3675",
              "text": "福安市"
            }
          ]
        }
      ]
    },
    {
      "value": "1380",
      "text": "江西省",
      "children": [
        {
          "value": "1381",
          "text": "南昌市",
          "children": [
            {
              "value": "1382",
              "text": "东湖区"
            },
            {
              "value": "1383",
              "text": "西湖区"
            },
            {
              "value": "1384",
              "text": "青云谱区"
            },
            {
              "value": "1385",
              "text": "湾里区"
            },
            {
              "value": "1386",
              "text": "青山湖区"
            },
            {
              "value": "1387",
              "text": "南昌县"
            },
            {
              "value": "1388",
              "text": "新建区"
            },
            {
              "value": "1389",
              "text": "安义县"
            },
            {
              "value": "1390",
              "text": "进贤县"
            },
            {
              "value": "3699",
              "text": "红谷滩新区"
            },
            {
              "value": "3700",
              "text": "高新区"
            },
            {
              "value": "3701",
              "text": "南昌经济开发区"
            },
            {
              "value": "3702",
              "text": "小蓝经济技术开发区"
            },
            {
              "value": "3703",
              "text": "桑海经济技术开发区"
            },
            {
              "value": "3704",
              "text": "望城新区"
            },
            {
              "value": "3828",
              "text": "昌北区"
            }
          ]
        },
        {
          "value": "1391",
          "text": "景德镇市",
          "children": [
            {
              "value": "1392",
              "text": "昌江区"
            },
            {
              "value": "1393",
              "text": "珠山区"
            },
            {
              "value": "1394",
              "text": "浮梁县"
            },
            {
              "value": "1395",
              "text": "乐平市"
            }
          ]
        },
        {
          "value": "1396",
          "text": "萍乡市",
          "children": [
            {
              "value": "1397",
              "text": "安源区"
            },
            {
              "value": "1398",
              "text": "湘东区"
            },
            {
              "value": "1399",
              "text": "莲花县"
            },
            {
              "value": "1400",
              "text": "上栗县"
            },
            {
              "value": "1401",
              "text": "芦溪县"
            }
          ]
        },
        {
          "value": "1402",
          "text": "九江市",
          "children": [
            {
              "value": "1403",
              "text": "庐山市"
            },
            {
              "value": "1404",
              "text": "浔阳区"
            },
            {
              "value": "1405",
              "text": "九江县"
            },
            {
              "value": "1406",
              "text": "武宁县"
            },
            {
              "value": "1407",
              "text": "修水县"
            },
            {
              "value": "1408",
              "text": "永修县"
            },
            {
              "value": "1409",
              "text": "德安县"
            },
            {
              "value": "1410",
              "text": "星子县"
            },
            {
              "value": "1411",
              "text": "都昌县"
            },
            {
              "value": "1412",
              "text": "湖口县"
            },
            {
              "value": "1413",
              "text": "彭泽县"
            },
            {
              "value": "1414",
              "text": "瑞昌市"
            },
            {
              "value": "3650",
              "text": "共青城市"
            },
            {
              "value": "3751",
              "text": "庐山风景名胜区"
            },
            {
              "value": "3777",
              "text": "濂溪区"
            },
            {
              "value": "3784",
              "text": "采桑区"
            },
            {
              "value": "3788",
              "text": "经济开发区"
            },
            {
              "value": "3792",
              "text": "八里湖新区"
            }
          ]
        },
        {
          "value": "1415",
          "text": "新余市",
          "children": [
            {
              "value": "1416",
              "text": "渝水区"
            },
            {
              "value": "1417",
              "text": "分宜县"
            }
          ]
        },
        {
          "value": "1418",
          "text": "鹰潭市",
          "children": [
            {
              "value": "1419",
              "text": "月湖区"
            },
            {
              "value": "1420",
              "text": "余江县"
            },
            {
              "value": "1421",
              "text": "贵溪市"
            },
            {
              "value": "3747",
              "text": "龙虎山风景旅游区"
            }
          ]
        },
        {
          "value": "1422",
          "text": "赣州市",
          "children": [
            {
              "value": "1423",
              "text": "章贡区"
            },
            {
              "value": "1424",
              "text": "赣县"
            },
            {
              "value": "1425",
              "text": "信丰县"
            },
            {
              "value": "1426",
              "text": "大余县"
            },
            {
              "value": "1427",
              "text": "上犹县"
            },
            {
              "value": "1428",
              "text": "崇义县"
            },
            {
              "value": "1429",
              "text": "安远县"
            },
            {
              "value": "1430",
              "text": "龙南县"
            },
            {
              "value": "1431",
              "text": "定南县"
            },
            {
              "value": "1432",
              "text": "全南县"
            },
            {
              "value": "1433",
              "text": "宁都县"
            },
            {
              "value": "1434",
              "text": "于都县"
            },
            {
              "value": "1435",
              "text": "兴国县"
            },
            {
              "value": "1436",
              "text": "会昌县"
            },
            {
              "value": "1437",
              "text": "寻乌县"
            },
            {
              "value": "1438",
              "text": "石城县"
            },
            {
              "value": "1439",
              "text": "瑞金市"
            },
            {
              "value": "1440",
              "text": "南康市"
            }
          ]
        },
        {
          "value": "1441",
          "text": "宜春市",
          "children": [
            {
              "value": "1442",
              "text": "袁州区"
            },
            {
              "value": "1443",
              "text": "丰城市"
            },
            {
              "value": "1444",
              "text": "樟树市"
            },
            {
              "value": "1445",
              "text": "高安市"
            },
            {
              "value": "1446",
              "text": "奉新县"
            },
            {
              "value": "1447",
              "text": "万载县"
            },
            {
              "value": "1448",
              "text": "上高县"
            },
            {
              "value": "1449",
              "text": "宜丰县"
            },
            {
              "value": "1450",
              "text": "靖安县"
            },
            {
              "value": "1451",
              "text": "铜鼓县"
            }
          ]
        },
        {
          "value": "1452",
          "text": "上饶市",
          "children": [
            {
              "value": "1453",
              "text": "信州区"
            },
            {
              "value": "1454",
              "text": "德兴市"
            },
            {
              "value": "1455",
              "text": "上饶县"
            },
            {
              "value": "1456",
              "text": "广丰县"
            },
            {
              "value": "1457",
              "text": "玉山县"
            },
            {
              "value": "1458",
              "text": "铅山县"
            },
            {
              "value": "1459",
              "text": "横峰县"
            },
            {
              "value": "1460",
              "text": "弋阳县"
            },
            {
              "value": "1461",
              "text": "余干县"
            },
            {
              "value": "1462",
              "text": "鄱阳县"
            },
            {
              "value": "1463",
              "text": "万年县"
            },
            {
              "value": "1464",
              "text": "婺源县"
            }
          ]
        },
        {
          "value": "1465",
          "text": "吉安市",
          "children": [
            {
              "value": "1466",
              "text": "吉州区"
            },
            {
              "value": "1467",
              "text": "井冈山市"
            },
            {
              "value": "1468",
              "text": "吉安县"
            },
            {
              "value": "1469",
              "text": "吉水县"
            },
            {
              "value": "1470",
              "text": "峡江县"
            },
            {
              "value": "1471",
              "text": "新干县"
            },
            {
              "value": "1472",
              "text": "永丰县"
            },
            {
              "value": "1473",
              "text": "泰和县"
            },
            {
              "value": "1474",
              "text": "遂川县"
            },
            {
              "value": "1475",
              "text": "万安县"
            },
            {
              "value": "1476",
              "text": "安福县"
            },
            {
              "value": "1477",
              "text": "永新县"
            },
            {
              "value": "1478",
              "text": "宁冈县"
            },
            {
              "value": "3644",
              "text": "青原区"
            }
          ]
        },
        {
          "value": "1479",
          "text": "抚州市",
          "children": [
            {
              "value": "1480",
              "text": "临川区"
            },
            {
              "value": "1481",
              "text": "南城县"
            },
            {
              "value": "1482",
              "text": "黎川县"
            },
            {
              "value": "1483",
              "text": "南丰县"
            },
            {
              "value": "1484",
              "text": "崇仁县"
            },
            {
              "value": "1485",
              "text": "乐安县"
            },
            {
              "value": "1486",
              "text": "宜黄县"
            },
            {
              "value": "1487",
              "text": "金溪县"
            },
            {
              "value": "1488",
              "text": "资溪县"
            },
            {
              "value": "1489",
              "text": "东乡县"
            },
            {
              "value": "1490",
              "text": "广昌县"
            }
          ]
        }
      ]
    },
    {
      "value": "1491",
      "text": "山东省",
      "children": [
        {
          "value": "1492",
          "text": "济南市",
          "children": [
            {
              "value": "1493",
              "text": "历下区"
            },
            {
              "value": "1494",
              "text": "市中区"
            },
            {
              "value": "1495",
              "text": "槐荫区"
            },
            {
              "value": "1496",
              "text": "天桥区"
            },
            {
              "value": "1497",
              "text": "历城区"
            },
            {
              "value": "1498",
              "text": "长清县"
            },
            {
              "value": "1499",
              "text": "平阴县"
            },
            {
              "value": "1500",
              "text": "济阳县"
            },
            {
              "value": "1501",
              "text": "商河县"
            },
            {
              "value": "1502",
              "text": "章丘市"
            },
            {
              "value": "3553",
              "text": "高新区"
            }
          ]
        },
        {
          "value": "1503",
          "text": "青岛市",
          "children": [
            {
              "value": "1504",
              "text": "市南区"
            },
            {
              "value": "1505",
              "text": "市北区"
            },
            {
              "value": "1506",
              "text": "四方区"
            },
            {
              "value": "1507",
              "text": "黄岛区"
            },
            {
              "value": "1508",
              "text": "崂山区"
            },
            {
              "value": "1509",
              "text": "李沧区"
            },
            {
              "value": "1510",
              "text": "城阳区"
            },
            {
              "value": "1511",
              "text": "胶州市"
            },
            {
              "value": "1512",
              "text": "即墨市"
            },
            {
              "value": "1513",
              "text": "平度市"
            },
            {
              "value": "1514",
              "text": "胶南市"
            },
            {
              "value": "1515",
              "text": "莱西市"
            }
          ]
        },
        {
          "value": "1516",
          "text": "淄博市",
          "children": [
            {
              "value": "1517",
              "text": "淄川区"
            },
            {
              "value": "1518",
              "text": "张店区"
            },
            {
              "value": "1519",
              "text": "博山区"
            },
            {
              "value": "1520",
              "text": "临淄区"
            },
            {
              "value": "1521",
              "text": "周村区"
            },
            {
              "value": "1522",
              "text": "桓台县"
            },
            {
              "value": "1523",
              "text": "高青县"
            },
            {
              "value": "1524",
              "text": "沂源县"
            }
          ]
        },
        {
          "value": "1525",
          "text": "枣庄市",
          "children": [
            {
              "value": "1526",
              "text": "市中区"
            },
            {
              "value": "1527",
              "text": "薛城区"
            },
            {
              "value": "1528",
              "text": "峄城区"
            },
            {
              "value": "1529",
              "text": "台儿庄区"
            },
            {
              "value": "1530",
              "text": "山亭区"
            },
            {
              "value": "1531",
              "text": "滕州市"
            }
          ]
        },
        {
          "value": "1532",
          "text": "东营市",
          "children": [
            {
              "value": "1533",
              "text": "东营区"
            },
            {
              "value": "1534",
              "text": "河口区"
            },
            {
              "value": "1535",
              "text": "垦利县"
            },
            {
              "value": "1536",
              "text": "利津县"
            },
            {
              "value": "1537",
              "text": "广饶县"
            }
          ]
        },
        {
          "value": "1538",
          "text": "烟台市",
          "children": [
            {
              "value": "1539",
              "text": "芝罘区"
            },
            {
              "value": "1540",
              "text": "福山区"
            },
            {
              "value": "1541",
              "text": "牟平区"
            },
            {
              "value": "1542",
              "text": "莱山区"
            },
            {
              "value": "1543",
              "text": "长岛县"
            },
            {
              "value": "1544",
              "text": "龙口市"
            },
            {
              "value": "1545",
              "text": "莱阳市"
            },
            {
              "value": "1546",
              "text": "莱州市"
            },
            {
              "value": "1547",
              "text": "蓬莱市"
            },
            {
              "value": "1548",
              "text": "招远市"
            },
            {
              "value": "1549",
              "text": "栖霞市"
            },
            {
              "value": "1550",
              "text": "海阳市"
            },
            {
              "value": "3740",
              "text": "开发区"
            }
          ]
        },
        {
          "value": "1551",
          "text": "潍坊市",
          "children": [
            {
              "value": "1552",
              "text": "潍城区"
            },
            {
              "value": "1553",
              "text": "寒亭区"
            },
            {
              "value": "1554",
              "text": "坊子区"
            },
            {
              "value": "1555",
              "text": "奎文区"
            },
            {
              "value": "1556",
              "text": "临朐县"
            },
            {
              "value": "1557",
              "text": "昌乐县"
            },
            {
              "value": "1558",
              "text": "青州市"
            },
            {
              "value": "1559",
              "text": "诸城市"
            },
            {
              "value": "1560",
              "text": "寿光市"
            },
            {
              "value": "1561",
              "text": "安丘市"
            },
            {
              "value": "1562",
              "text": "高密市"
            },
            {
              "value": "1563",
              "text": "昌邑市"
            },
            {
              "value": "3743",
              "text": "高新区"
            }
          ]
        },
        {
          "value": "1564",
          "text": "济宁市",
          "children": [
            {
              "value": "1565",
              "text": "市中区"
            },
            {
              "value": "1566",
              "text": "任城区"
            },
            {
              "value": "1567",
              "text": "微山县"
            },
            {
              "value": "1568",
              "text": "鱼台县"
            },
            {
              "value": "1569",
              "text": "金乡县"
            },
            {
              "value": "1570",
              "text": "嘉祥县"
            },
            {
              "value": "1571",
              "text": "汶上县"
            },
            {
              "value": "1572",
              "text": "泗水县"
            },
            {
              "value": "1573",
              "text": "梁山县"
            },
            {
              "value": "1574",
              "text": "曲阜市"
            },
            {
              "value": "1575",
              "text": "兖州区"
            },
            {
              "value": "1576",
              "text": "邹城市"
            },
            {
              "value": "3745",
              "text": "高新区"
            }
          ]
        },
        {
          "value": "1577",
          "text": "泰安市",
          "children": [
            {
              "value": "1578",
              "text": "泰山区"
            },
            {
              "value": "1579",
              "text": "岱岳区"
            },
            {
              "value": "1580",
              "text": "宁阳县"
            },
            {
              "value": "1581",
              "text": "东平县"
            },
            {
              "value": "1582",
              "text": "新泰市"
            },
            {
              "value": "1583",
              "text": "肥城市"
            }
          ]
        },
        {
          "value": "1584",
          "text": "威海市",
          "children": [
            {
              "value": "1585",
              "text": "环翠区"
            },
            {
              "value": "1586",
              "text": "文登区"
            },
            {
              "value": "1587",
              "text": "荣成市"
            },
            {
              "value": "1588",
              "text": "乳山市"
            }
          ]
        },
        {
          "value": "1589",
          "text": "日照市",
          "children": [
            {
              "value": "1590",
              "text": "东港区"
            },
            {
              "value": "1591",
              "text": "岚山区"
            },
            {
              "value": "1592",
              "text": "五莲县"
            },
            {
              "value": "1593",
              "text": "莒县"
            },
            {
              "value": "3733",
              "text": "新市区"
            }
          ]
        },
        {
          "value": "1594",
          "text": "莱芜市",
          "children": [
            {
              "value": "1595",
              "text": "莱城区"
            },
            {
              "value": "1596",
              "text": "钢城区"
            }
          ]
        },
        {
          "value": "1597",
          "text": "临沂市",
          "children": [
            {
              "value": "1598",
              "text": "兰山区"
            },
            {
              "value": "1599",
              "text": "罗庄区"
            },
            {
              "value": "1600",
              "text": "河东区"
            },
            {
              "value": "1601",
              "text": "沂南县"
            },
            {
              "value": "1602",
              "text": "郯城县"
            },
            {
              "value": "1603",
              "text": "沂水县"
            },
            {
              "value": "1604",
              "text": "兰陵县"
            },
            {
              "value": "1605",
              "text": "费县"
            },
            {
              "value": "1606",
              "text": "平邑县"
            },
            {
              "value": "1607",
              "text": "莒南县"
            },
            {
              "value": "1608",
              "text": "蒙阴县"
            },
            {
              "value": "1609",
              "text": "临沭县"
            }
          ]
        },
        {
          "value": "1610",
          "text": "德州市",
          "children": [
            {
              "value": "1611",
              "text": "德城区"
            },
            {
              "value": "1612",
              "text": "陵城区"
            },
            {
              "value": "1613",
              "text": "宁津县"
            },
            {
              "value": "1614",
              "text": "庆云县"
            },
            {
              "value": "1615",
              "text": "临邑县"
            },
            {
              "value": "1616",
              "text": "齐河县"
            },
            {
              "value": "1617",
              "text": "平原县"
            },
            {
              "value": "1618",
              "text": "夏津县"
            },
            {
              "value": "1619",
              "text": "武城县"
            },
            {
              "value": "1620",
              "text": "乐陵市"
            },
            {
              "value": "1621",
              "text": "禹城市"
            }
          ]
        },
        {
          "value": "1622",
          "text": "聊城市",
          "children": [
            {
              "value": "1623",
              "text": "东昌府区"
            },
            {
              "value": "1624",
              "text": "阳谷县"
            },
            {
              "value": "1625",
              "text": "莘县"
            },
            {
              "value": "1626",
              "text": "茌平县"
            },
            {
              "value": "1627",
              "text": "东阿县"
            },
            {
              "value": "1628",
              "text": "冠县"
            },
            {
              "value": "1629",
              "text": "高唐县"
            },
            {
              "value": "1630",
              "text": "临清市"
            }
          ]
        },
        {
          "value": "1631",
          "text": "滨州市",
          "children": [
            {
              "value": "1632",
              "text": "滨城区"
            },
            {
              "value": "1633",
              "text": "惠民县"
            },
            {
              "value": "1634",
              "text": "阳信县"
            },
            {
              "value": "1635",
              "text": "无棣县"
            },
            {
              "value": "1636",
              "text": "沾化区"
            },
            {
              "value": "1637",
              "text": "博兴县"
            },
            {
              "value": "1638",
              "text": "邹平县"
            },
            {
              "value": "3737",
              "text": "北海新区"
            }
          ]
        },
        {
          "value": "1639",
          "text": "菏泽市",
          "children": [
            {
              "value": "1640",
              "text": "牡丹区"
            },
            {
              "value": "1641",
              "text": "曹县"
            },
            {
              "value": "1642",
              "text": "定陶区"
            },
            {
              "value": "1643",
              "text": "成武县"
            },
            {
              "value": "1644",
              "text": "单县"
            },
            {
              "value": "1645",
              "text": "巨野县"
            },
            {
              "value": "1646",
              "text": "郓城县"
            },
            {
              "value": "1647",
              "text": "鄄城县"
            },
            {
              "value": "1648",
              "text": "东明县"
            }
          ]
        }
      ]
    },
    {
      "value": "1649",
      "text": "河南省",
      "children": [
        {
          "value": "1650",
          "text": "郑州市",
          "children": [
            {
              "value": "1651",
              "text": "中原区"
            },
            {
              "value": "1652",
              "text": "二七区"
            },
            {
              "value": "1653",
              "text": "管城区"
            },
            {
              "value": "1654",
              "text": "金水区"
            },
            {
              "value": "1655",
              "text": "上街区"
            },
            {
              "value": "1656",
              "text": "邙山区"
            },
            {
              "value": "1657",
              "text": "中牟县"
            },
            {
              "value": "1658",
              "text": "巩义市"
            },
            {
              "value": "1659",
              "text": "荥阳市"
            },
            {
              "value": "1660",
              "text": "新密市"
            },
            {
              "value": "1661",
              "text": "新郑市"
            },
            {
              "value": "1662",
              "text": "登封市"
            },
            {
              "value": "3559",
              "text": "郑东新区"
            },
            {
              "value": "3640",
              "text": "惠济区"
            },
            {
              "value": "4065",
              "text": "高新技术开发区"
            },
            {
              "value": "4067",
              "text": "经济开发区"
            }
          ]
        },
        {
          "value": "1663",
          "text": "开封市",
          "children": [
            {
              "value": "1664",
              "text": "龙亭区"
            },
            {
              "value": "1665",
              "text": "顺河区"
            },
            {
              "value": "1666",
              "text": "鼓楼区"
            },
            {
              "value": "1667",
              "text": "禹王台区"
            },
            {
              "value": "1668",
              "text": "郊区"
            },
            {
              "value": "1669",
              "text": "杞县"
            },
            {
              "value": "1670",
              "text": "通许县"
            },
            {
              "value": "1671",
              "text": "尉氏县"
            },
            {
              "value": "1672",
              "text": "祥符区"
            },
            {
              "value": "1673",
              "text": "兰考县"
            },
            {
              "value": "4063",
              "text": "金明区"
            }
          ]
        },
        {
          "value": "1674",
          "text": "洛阳市",
          "children": [
            {
              "value": "1675",
              "text": "老城区"
            },
            {
              "value": "1676",
              "text": "西工区"
            },
            {
              "value": "1677",
              "text": "瀍河区"
            },
            {
              "value": "1678",
              "text": "涧西区"
            },
            {
              "value": "1679",
              "text": "吉利区"
            },
            {
              "value": "1680",
              "text": "郊区"
            },
            {
              "value": "1681",
              "text": "孟津县"
            },
            {
              "value": "1682",
              "text": "新安县"
            },
            {
              "value": "1683",
              "text": "栾川县"
            },
            {
              "value": "1684",
              "text": "嵩县"
            },
            {
              "value": "1685",
              "text": "汝阳县"
            },
            {
              "value": "1686",
              "text": "宜阳县"
            },
            {
              "value": "1687",
              "text": "洛宁县"
            },
            {
              "value": "1688",
              "text": "伊川县"
            },
            {
              "value": "1689",
              "text": "偃师市"
            },
            {
              "value": "3649",
              "text": "洛龙区"
            },
            {
              "value": "4058",
              "text": "伊滨县"
            }
          ]
        },
        {
          "value": "1690",
          "text": "平顶山市",
          "children": [
            {
              "value": "1691",
              "text": "新华区"
            },
            {
              "value": "1692",
              "text": "卫东区"
            },
            {
              "value": "1693",
              "text": "石龙区"
            },
            {
              "value": "1694",
              "text": "湛河区"
            },
            {
              "value": "1695",
              "text": "宝丰县"
            },
            {
              "value": "1696",
              "text": "叶县"
            },
            {
              "value": "1697",
              "text": "鲁山县"
            },
            {
              "value": "1698",
              "text": "郏县"
            },
            {
              "value": "1699",
              "text": "舞钢市"
            },
            {
              "value": "1700",
              "text": "汝州市"
            }
          ]
        },
        {
          "value": "1701",
          "text": "安阳市",
          "children": [
            {
              "value": "1702",
              "text": "文峰区"
            },
            {
              "value": "1703",
              "text": "北关区"
            },
            {
              "value": "1704",
              "text": "殷都区"
            },
            {
              "value": "1705",
              "text": "龙安区"
            },
            {
              "value": "1706",
              "text": "安阳县"
            },
            {
              "value": "1707",
              "text": "汤阴县"
            },
            {
              "value": "1708",
              "text": "滑县"
            },
            {
              "value": "1709",
              "text": "内黄县"
            },
            {
              "value": "1710",
              "text": "林州市"
            },
            {
              "value": "4052",
              "text": "开发区"
            }
          ]
        },
        {
          "value": "1711",
          "text": "鹤壁市",
          "children": [
            {
              "value": "1712",
              "text": "鹤山区"
            },
            {
              "value": "1713",
              "text": "山城区"
            },
            {
              "value": "1714",
              "text": "淇滨区"
            },
            {
              "value": "1715",
              "text": "浚县"
            },
            {
              "value": "1716",
              "text": "淇县"
            }
          ]
        },
        {
          "value": "1717",
          "text": "新乡市",
          "children": [
            {
              "value": "1718",
              "text": "红旗区"
            },
            {
              "value": "1719",
              "text": "新华区"
            },
            {
              "value": "1720",
              "text": "凤泉区"
            },
            {
              "value": "1721",
              "text": "牧野区"
            },
            {
              "value": "1722",
              "text": "新乡县"
            },
            {
              "value": "1723",
              "text": "获嘉县"
            },
            {
              "value": "1724",
              "text": "原阳县"
            },
            {
              "value": "1725",
              "text": "延津县"
            },
            {
              "value": "1726",
              "text": "封丘县"
            },
            {
              "value": "1727",
              "text": "长垣县"
            },
            {
              "value": "1728",
              "text": "卫辉市"
            },
            {
              "value": "1729",
              "text": "辉县市"
            },
            {
              "value": "3632",
              "text": "卫滨区"
            }
          ]
        },
        {
          "value": "1730",
          "text": "焦作市",
          "children": [
            {
              "value": "1731",
              "text": "解放区"
            },
            {
              "value": "1732",
              "text": "中站区"
            },
            {
              "value": "1733",
              "text": "马村区"
            },
            {
              "value": "1734",
              "text": "山阳区"
            },
            {
              "value": "1735",
              "text": "修武县"
            },
            {
              "value": "1736",
              "text": "博爱县"
            },
            {
              "value": "1737",
              "text": "武陟县"
            },
            {
              "value": "1738",
              "text": "温县"
            },
            {
              "value": "1739",
              "text": "沁阳市"
            },
            {
              "value": "1740",
              "text": "孟州市"
            }
          ]
        },
        {
          "value": "1741",
          "text": "濮阳市",
          "children": [
            {
              "value": "1742",
              "text": "华龙区"
            },
            {
              "value": "1743",
              "text": "清丰县"
            },
            {
              "value": "1744",
              "text": "南乐县"
            },
            {
              "value": "1745",
              "text": "范县"
            },
            {
              "value": "1746",
              "text": "台前县"
            },
            {
              "value": "1747",
              "text": "濮阳县"
            }
          ]
        },
        {
          "value": "1748",
          "text": "许昌市",
          "children": [
            {
              "value": "1749",
              "text": "魏都区"
            },
            {
              "value": "1750",
              "text": "建安区"
            },
            {
              "value": "1751",
              "text": "鄢陵县"
            },
            {
              "value": "1752",
              "text": "襄城县"
            },
            {
              "value": "1753",
              "text": "禹州市"
            },
            {
              "value": "1754",
              "text": "长葛市"
            }
          ]
        },
        {
          "value": "1755",
          "text": "漯河市",
          "children": [
            {
              "value": "1756",
              "text": "源汇区"
            },
            {
              "value": "1757",
              "text": "郾城区"
            },
            {
              "value": "1758",
              "text": "召陵区"
            },
            {
              "value": "1759",
              "text": "舞阳县"
            },
            {
              "value": "1760",
              "text": "临颍县"
            }
          ]
        },
        {
          "value": "1761",
          "text": "三门峡市",
          "children": [
            {
              "value": "1762",
              "text": "湖滨区"
            },
            {
              "value": "1763",
              "text": "渑池县"
            },
            {
              "value": "1764",
              "text": "陕州区"
            },
            {
              "value": "1765",
              "text": "卢氏县"
            },
            {
              "value": "1766",
              "text": "义马市"
            },
            {
              "value": "1767",
              "text": "灵宝市"
            }
          ]
        },
        {
          "value": "1768",
          "text": "南阳市",
          "children": [
            {
              "value": "1769",
              "text": "宛城区"
            },
            {
              "value": "1770",
              "text": "卧龙区"
            },
            {
              "value": "1771",
              "text": "南召县"
            },
            {
              "value": "1772",
              "text": "方城县"
            },
            {
              "value": "1773",
              "text": "西峡县"
            },
            {
              "value": "1774",
              "text": "镇平县"
            },
            {
              "value": "1775",
              "text": "内乡县"
            },
            {
              "value": "1776",
              "text": "淅川县"
            },
            {
              "value": "1777",
              "text": "社旗县"
            },
            {
              "value": "1778",
              "text": "唐河县"
            },
            {
              "value": "1779",
              "text": "新野县"
            },
            {
              "value": "1780",
              "text": "桐柏县"
            },
            {
              "value": "1781",
              "text": "邓州市"
            }
          ]
        },
        {
          "value": "1782",
          "text": "商丘市",
          "children": [
            {
              "value": "1783",
              "text": "梁园区"
            },
            {
              "value": "1784",
              "text": "睢阳区"
            },
            {
              "value": "1785",
              "text": "民权县"
            },
            {
              "value": "1786",
              "text": "睢县"
            },
            {
              "value": "1787",
              "text": "宁陵县"
            },
            {
              "value": "1788",
              "text": "柘城县"
            },
            {
              "value": "1789",
              "text": "虞城县"
            },
            {
              "value": "1790",
              "text": "夏邑县"
            },
            {
              "value": "1791",
              "text": "永城市"
            }
          ]
        },
        {
          "value": "1792",
          "text": "信阳市",
          "children": [
            {
              "value": "1793",
              "text": "浉河区"
            },
            {
              "value": "1794",
              "text": "平桥区"
            },
            {
              "value": "1795",
              "text": "罗山县"
            },
            {
              "value": "1796",
              "text": "光山县"
            },
            {
              "value": "1797",
              "text": "新县"
            },
            {
              "value": "1798",
              "text": "商城县"
            },
            {
              "value": "1799",
              "text": "固始县"
            },
            {
              "value": "1800",
              "text": "潢川县"
            },
            {
              "value": "1801",
              "text": "淮滨县"
            },
            {
              "value": "1802",
              "text": "息县"
            },
            {
              "value": "4036",
              "text": "羊山新区"
            }
          ]
        },
        {
          "value": "1803",
          "text": "周口市",
          "children": [
            {
              "value": "1804",
              "text": "川汇区"
            },
            {
              "value": "1805",
              "text": "项城市"
            },
            {
              "value": "1806",
              "text": "扶沟县"
            },
            {
              "value": "1807",
              "text": "西华县"
            },
            {
              "value": "1808",
              "text": "商水县"
            },
            {
              "value": "1809",
              "text": "太康县"
            },
            {
              "value": "1810",
              "text": "鹿邑县"
            },
            {
              "value": "1811",
              "text": "郸城县"
            },
            {
              "value": "1812",
              "text": "淮阳县"
            },
            {
              "value": "1813",
              "text": "沈丘县"
            },
            {
              "value": "4042",
              "text": "经济开发区"
            },
            {
              "value": "4044",
              "text": "东城区"
            }
          ]
        },
        {
          "value": "1814",
          "text": "驻马店市",
          "children": [
            {
              "value": "1815",
              "text": "驿城区"
            },
            {
              "value": "1816",
              "text": "确山县"
            },
            {
              "value": "1817",
              "text": "泌阳县"
            },
            {
              "value": "1818",
              "text": "遂平县"
            },
            {
              "value": "1819",
              "text": "西平县"
            },
            {
              "value": "1820",
              "text": "上蔡县"
            },
            {
              "value": "1821",
              "text": "汝南县"
            },
            {
              "value": "1822",
              "text": "平舆县"
            },
            {
              "value": "1823",
              "text": "新蔡县"
            },
            {
              "value": "1824",
              "text": "正阳县"
            }
          ]
        },
        {
          "value": "1825",
          "text": "省直辖行政单位",
          "children": [
            {
              "value": "1826",
              "text": "济源市"
            }
          ]
        },
        {
          "value": "4004",
          "text": "济源市",
          "children": [
            {
              "value": "4008",
              "text": "承留镇"
            },
            {
              "value": "4009",
              "text": "大峪镇"
            },
            {
              "value": "4012",
              "text": "克井镇"
            },
            {
              "value": "4014",
              "text": "梨林镇"
            },
            {
              "value": "4016",
              "text": "坡头镇"
            },
            {
              "value": "4017",
              "text": "邵原镇"
            },
            {
              "value": "4019",
              "text": "思礼镇"
            },
            {
              "value": "4023",
              "text": "王屋镇"
            },
            {
              "value": "4027",
              "text": "轵城镇"
            },
            {
              "value": "4031",
              "text": "下冶镇"
            },
            {
              "value": "4032",
              "text": "五龙口镇"
            },
            {
              "value": "4034",
              "text": "城区"
            }
          ]
        }
      ]
    },
    {
      "value": "1827",
      "text": "湖北省",
      "children": [
        {
          "value": "1828",
          "text": "武汉市",
          "children": [
            {
              "value": "1829",
              "text": "江岸区"
            },
            {
              "value": "1830",
              "text": "江汉区"
            },
            {
              "value": "1831",
              "text": "硚口区"
            },
            {
              "value": "1832",
              "text": "汉阳区"
            },
            {
              "value": "1833",
              "text": "武昌区"
            },
            {
              "value": "1834",
              "text": "青山区"
            },
            {
              "value": "1835",
              "text": "洪山区"
            },
            {
              "value": "1836",
              "text": "东西湖区"
            },
            {
              "value": "1837",
              "text": "汉南区"
            },
            {
              "value": "1838",
              "text": "蔡甸区"
            },
            {
              "value": "1839",
              "text": "江夏区"
            },
            {
              "value": "1840",
              "text": "黄陂区"
            },
            {
              "value": "1841",
              "text": "新洲区"
            },
            {
              "value": "4177",
              "text": "武汉经济技术开发区"
            },
            {
              "value": "4179",
              "text": "东湖高新科技开发区"
            }
          ]
        },
        {
          "value": "1842",
          "text": "黄石市",
          "children": [
            {
              "value": "1843",
              "text": "黄石港区"
            },
            {
              "value": "1844",
              "text": "西塞山区"
            },
            {
              "value": "1845",
              "text": "下陆区"
            },
            {
              "value": "1846",
              "text": "铁山区"
            },
            {
              "value": "1847",
              "text": "阳新县"
            },
            {
              "value": "1848",
              "text": "大冶市"
            },
            {
              "value": "4182",
              "text": "经济技术开发区"
            }
          ]
        },
        {
          "value": "1849",
          "text": "十堰市",
          "children": [
            {
              "value": "1850",
              "text": "茅箭区"
            },
            {
              "value": "1851",
              "text": "张湾区"
            },
            {
              "value": "1852",
              "text": "郧阳区"
            },
            {
              "value": "1853",
              "text": "郧西县"
            },
            {
              "value": "1854",
              "text": "竹山县"
            },
            {
              "value": "1855",
              "text": "竹溪县"
            },
            {
              "value": "1856",
              "text": "房县"
            },
            {
              "value": "1857",
              "text": "丹江口市"
            }
          ]
        },
        {
          "value": "1858",
          "text": "宜昌市",
          "children": [
            {
              "value": "1859",
              "text": "西陵区"
            },
            {
              "value": "1860",
              "text": "伍家岗区"
            },
            {
              "value": "1861",
              "text": "点军区"
            },
            {
              "value": "1862",
              "text": "猇亭区"
            },
            {
              "value": "1863",
              "text": "夷陵区"
            },
            {
              "value": "1864",
              "text": "远安县"
            },
            {
              "value": "1865",
              "text": "兴山县"
            },
            {
              "value": "1866",
              "text": "秭归县"
            },
            {
              "value": "1867",
              "text": "长阳土家族自治县"
            },
            {
              "value": "1868",
              "text": "五峰土家族自治县"
            },
            {
              "value": "1869",
              "text": "宜都市"
            },
            {
              "value": "1870",
              "text": "当阳市"
            },
            {
              "value": "1871",
              "text": "枝江市"
            }
          ]
        },
        {
          "value": "1872",
          "text": "襄阳市",
          "children": [
            {
              "value": "1873",
              "text": "襄城区"
            },
            {
              "value": "1874",
              "text": "樊城区"
            },
            {
              "value": "1875",
              "text": "襄州区"
            },
            {
              "value": "1876",
              "text": "南漳县"
            },
            {
              "value": "1877",
              "text": "谷城县"
            },
            {
              "value": "1878",
              "text": "保康县"
            },
            {
              "value": "1879",
              "text": "老河口市"
            },
            {
              "value": "1880",
              "text": "枣阳市"
            },
            {
              "value": "1881",
              "text": "宜城市"
            }
          ]
        },
        {
          "value": "1882",
          "text": "鄂州市",
          "children": [
            {
              "value": "1883",
              "text": "梁子湖区"
            },
            {
              "value": "1884",
              "text": "华容区"
            },
            {
              "value": "1885",
              "text": "鄂城区"
            }
          ]
        },
        {
          "value": "1886",
          "text": "荆门市",
          "children": [
            {
              "value": "1887",
              "text": "东宝区"
            },
            {
              "value": "1888",
              "text": "掇刀区"
            },
            {
              "value": "1889",
              "text": "京山县"
            },
            {
              "value": "1890",
              "text": "沙洋县"
            },
            {
              "value": "1891",
              "text": "钟祥市"
            }
          ]
        },
        {
          "value": "1892",
          "text": "孝感市",
          "children": [
            {
              "value": "1893",
              "text": "孝南区"
            },
            {
              "value": "1894",
              "text": "孝昌县"
            },
            {
              "value": "1895",
              "text": "大悟县"
            },
            {
              "value": "1896",
              "text": "云梦县"
            },
            {
              "value": "1897",
              "text": "应城市"
            },
            {
              "value": "1898",
              "text": "安陆市"
            },
            {
              "value": "1899",
              "text": "汉川市"
            }
          ]
        },
        {
          "value": "1900",
          "text": "荆州市",
          "children": [
            {
              "value": "1901",
              "text": "沙市区"
            },
            {
              "value": "1902",
              "text": "荆州区"
            },
            {
              "value": "1903",
              "text": "公安县"
            },
            {
              "value": "1904",
              "text": "监利县"
            },
            {
              "value": "1905",
              "text": "江陵县"
            },
            {
              "value": "1906",
              "text": "石首市"
            },
            {
              "value": "1907",
              "text": "洪湖市"
            },
            {
              "value": "1908",
              "text": "松滋市"
            }
          ]
        },
        {
          "value": "1909",
          "text": "黄冈市",
          "children": [
            {
              "value": "1910",
              "text": "黄州区"
            },
            {
              "value": "1911",
              "text": "团风县"
            },
            {
              "value": "1912",
              "text": "红安县"
            },
            {
              "value": "1913",
              "text": "罗田县"
            },
            {
              "value": "1914",
              "text": "英山县"
            },
            {
              "value": "1915",
              "text": "浠水县"
            },
            {
              "value": "1916",
              "text": "蕲春县"
            },
            {
              "value": "1917",
              "text": "黄梅县"
            },
            {
              "value": "1918",
              "text": "麻城市"
            },
            {
              "value": "1919",
              "text": "武穴市"
            }
          ]
        },
        {
          "value": "1920",
          "text": "咸宁市",
          "children": [
            {
              "value": "1921",
              "text": "咸安区"
            },
            {
              "value": "1922",
              "text": "嘉鱼县"
            },
            {
              "value": "1923",
              "text": "通城县"
            },
            {
              "value": "1924",
              "text": "崇阳县"
            },
            {
              "value": "1925",
              "text": "通山县"
            },
            {
              "value": "1926",
              "text": "赤壁市"
            }
          ]
        },
        {
          "value": "1927",
          "text": "恩施土家族苗族自治州",
          "children": [
            {
              "value": "1928",
              "text": "恩施市"
            },
            {
              "value": "1929",
              "text": "利川市"
            },
            {
              "value": "1930",
              "text": "建始县"
            },
            {
              "value": "1931",
              "text": "巴东县"
            },
            {
              "value": "1932",
              "text": "宣恩县"
            },
            {
              "value": "1933",
              "text": "咸丰县"
            },
            {
              "value": "1934",
              "text": "来凤县"
            },
            {
              "value": "1935",
              "text": "鹤峰县"
            }
          ]
        },
        {
          "value": "1936",
          "text": "省直辖行政单位",
          "children": [
            {
              "value": "1937",
              "text": "仙桃市"
            },
            {
              "value": "1938",
              "text": "潜江市"
            },
            {
              "value": "1939",
              "text": "天门市"
            }
          ]
        },
        {
          "value": "3627",
          "text": "随州市",
          "children": [
            {
              "value": "3628",
              "text": "曾都区"
            },
            {
              "value": "3629",
              "text": "随县"
            },
            {
              "value": "3630",
              "text": "广水市"
            }
          ]
        },
        {
          "value": "3681",
          "text": "神农架林区",
          "children": [
            {
              "value": "4160",
              "text": "松柏镇"
            },
            {
              "value": "4162",
              "text": "阳日镇"
            },
            {
              "value": "4164",
              "text": "木鱼镇"
            },
            {
              "value": "4165",
              "text": "红坪镇"
            },
            {
              "value": "4167",
              "text": "新华镇"
            },
            {
              "value": "4168",
              "text": "新华镇"
            },
            {
              "value": "4169",
              "text": "宋洛乡"
            },
            {
              "value": "4170",
              "text": "九湖乡"
            },
            {
              "value": "4173",
              "text": "下谷坪乡"
            }
          ]
        },
        {
          "value": "3761",
          "text": "潜江市",
          "children": [
            {
              "value": "3797",
              "text": "泰丰"
            },
            {
              "value": "3803",
              "text": "竹根滩镇"
            },
            {
              "value": "3811",
              "text": "高石碑镇"
            },
            {
              "value": "3815",
              "text": "积玉口镇"
            },
            {
              "value": "3819",
              "text": "渔洋镇"
            },
            {
              "value": "3823",
              "text": "王场镇"
            },
            {
              "value": "3826",
              "text": "熊口镇"
            },
            {
              "value": "3833",
              "text": "老新镇"
            },
            {
              "value": "3837",
              "text": "浩口镇"
            },
            {
              "value": "3840",
              "text": "张金镇"
            },
            {
              "value": "3843",
              "text": "龙湾镇"
            },
            {
              "value": "3848",
              "text": "江汉石油管理局"
            },
            {
              "value": "3855",
              "text": "潜江经济开发区"
            },
            {
              "value": "3860",
              "text": "西大垸管理区"
            },
            {
              "value": "3865",
              "text": "运粮湖管理区"
            },
            {
              "value": "3868",
              "text": "周矶管理区"
            },
            {
              "value": "3874",
              "text": "后湖管理区"
            },
            {
              "value": "3879",
              "text": "熊口管理区"
            },
            {
              "value": "3881",
              "text": "总口管理区"
            },
            {
              "value": "3884",
              "text": "高场原种场"
            },
            {
              "value": "3889",
              "text": "浩口原种场"
            },
            {
              "value": "4184",
              "text": "园林"
            },
            {
              "value": "4185",
              "text": "杨市"
            },
            {
              "value": "4186",
              "text": "周矶"
            },
            {
              "value": "4187",
              "text": "广华"
            }
          ]
        },
        {
          "value": "3903",
          "text": "天门市",
          "children": [
            {
              "value": "3914",
              "text": "侨乡街道开发区"
            },
            {
              "value": "3917",
              "text": "竟陵街道"
            },
            {
              "value": "3919",
              "text": "杨林街道"
            },
            {
              "value": "3920",
              "text": "佛子山镇"
            },
            {
              "value": "3924",
              "text": "多宝镇"
            },
            {
              "value": "3926",
              "text": "拖市镇"
            },
            {
              "value": "3930",
              "text": "张港镇"
            },
            {
              "value": "3933",
              "text": "蒋场镇"
            },
            {
              "value": "3937",
              "text": "汪场镇"
            },
            {
              "value": "3940",
              "text": "渔薪镇"
            },
            {
              "value": "3942",
              "text": "黄潭镇"
            },
            {
              "value": "3947",
              "text": "岳口镇"
            },
            {
              "value": "3973",
              "text": "横林镇"
            },
            {
              "value": "3980",
              "text": "彭市镇"
            },
            {
              "value": "3983",
              "text": "麻洋镇"
            },
            {
              "value": "3986",
              "text": "多祥镇"
            },
            {
              "value": "3997",
              "text": "干驿镇"
            },
            {
              "value": "3998",
              "text": "马湾镇"
            },
            {
              "value": "4000",
              "text": "卢市镇"
            },
            {
              "value": "4002",
              "text": "小板镇"
            },
            {
              "value": "4003",
              "text": "九真镇"
            },
            {
              "value": "4006",
              "text": "皂市镇"
            },
            {
              "value": "4007",
              "text": "胡市镇"
            },
            {
              "value": "4011",
              "text": "石河镇"
            },
            {
              "value": "4013",
              "text": "净潭乡"
            },
            {
              "value": "4020",
              "text": "蒋湖农场"
            },
            {
              "value": "4024",
              "text": "白茅湖农场"
            },
            {
              "value": "4028",
              "text": "沉湖管委会"
            }
          ]
        },
        {
          "value": "4046",
          "text": "仙桃市",
          "children": [
            {
              "value": "4057",
              "text": "城区"
            },
            {
              "value": "4061",
              "text": "郑场镇"
            },
            {
              "value": "4064",
              "text": "毛嘴镇"
            },
            {
              "value": "4066",
              "text": "豆河镇"
            },
            {
              "value": "4069",
              "text": "三伏潭镇"
            },
            {
              "value": "4071",
              "text": "胡场镇"
            },
            {
              "value": "4073",
              "text": "长埫口镇"
            },
            {
              "value": "4075",
              "text": "西流河镇"
            },
            {
              "value": "4079",
              "text": "沙湖镇"
            },
            {
              "value": "4080",
              "text": "杨林尾镇"
            },
            {
              "value": "4083",
              "text": "彭场镇"
            },
            {
              "value": "4085",
              "text": "张沟镇"
            },
            {
              "value": "4088",
              "text": "郭河镇"
            },
            {
              "value": "4091",
              "text": "沔城镇"
            },
            {
              "value": "4094",
              "text": "通海口镇"
            },
            {
              "value": "4097",
              "text": "陈场镇"
            },
            {
              "value": "4101",
              "text": "工业园区"
            },
            {
              "value": "4104",
              "text": "九合垸原种场"
            },
            {
              "value": "4107",
              "text": "沙湖原种场"
            },
            {
              "value": "4109",
              "text": "排湖渔场"
            },
            {
              "value": "4110",
              "text": "五湖渔场"
            },
            {
              "value": "4112",
              "text": "赵西垸林场"
            },
            {
              "value": "4114",
              "text": "刘家垸林场"
            },
            {
              "value": "4115",
              "text": "畜禽良种场"
            }
          ]
        }
      ]
    },
    {
      "value": "1941",
      "text": "湖南省",
      "children": [
        {
          "value": "1942",
          "text": "长沙市",
          "children": [
            {
              "value": "1943",
              "text": "芙蓉区"
            },
            {
              "value": "1944",
              "text": "天心区"
            },
            {
              "value": "1945",
              "text": "岳麓区"
            },
            {
              "value": "1946",
              "text": "开福区"
            },
            {
              "value": "1947",
              "text": "雨花区"
            },
            {
              "value": "1948",
              "text": "长沙县"
            },
            {
              "value": "1949",
              "text": "望城县"
            },
            {
              "value": "1950",
              "text": "宁乡县"
            },
            {
              "value": "1951",
              "text": "浏阳市"
            }
          ]
        },
        {
          "value": "1952",
          "text": "株洲市",
          "children": [
            {
              "value": "1953",
              "text": "荷塘区"
            },
            {
              "value": "1954",
              "text": "芦淞区"
            },
            {
              "value": "1955",
              "text": "石峰区"
            },
            {
              "value": "1956",
              "text": "天元区"
            },
            {
              "value": "1957",
              "text": "株洲县"
            },
            {
              "value": "1958",
              "text": "攸县"
            },
            {
              "value": "1959",
              "text": "茶陵县"
            },
            {
              "value": "1960",
              "text": "炎陵县"
            },
            {
              "value": "1961",
              "text": "醴陵市"
            },
            {
              "value": "3995",
              "text": "龙云示范区"
            }
          ]
        },
        {
          "value": "1962",
          "text": "湘潭市",
          "children": [
            {
              "value": "1963",
              "text": "雨湖区"
            },
            {
              "value": "1964",
              "text": "岳塘区"
            },
            {
              "value": "1965",
              "text": "湘潭县"
            },
            {
              "value": "1966",
              "text": "湘乡市"
            },
            {
              "value": "1967",
              "text": "韶山市"
            }
          ]
        },
        {
          "value": "1968",
          "text": "衡阳市",
          "children": [
            {
              "value": "1969",
              "text": "珠晖区"
            },
            {
              "value": "1970",
              "text": "雁峰区"
            },
            {
              "value": "1971",
              "text": "石鼓区"
            },
            {
              "value": "1972",
              "text": "蒸湘区"
            },
            {
              "value": "1973",
              "text": "南岳区"
            },
            {
              "value": "1974",
              "text": "衡阳县"
            },
            {
              "value": "1975",
              "text": "衡南县"
            },
            {
              "value": "1976",
              "text": "衡山县"
            },
            {
              "value": "1977",
              "text": "衡东县"
            },
            {
              "value": "1978",
              "text": "祁东县"
            },
            {
              "value": "1979",
              "text": "耒阳市"
            },
            {
              "value": "1980",
              "text": "常宁市"
            }
          ]
        },
        {
          "value": "1981",
          "text": "邵阳市",
          "children": [
            {
              "value": "1982",
              "text": "双清区"
            },
            {
              "value": "1983",
              "text": "大祥区"
            },
            {
              "value": "1984",
              "text": "北塔区"
            },
            {
              "value": "1985",
              "text": "邵东县"
            },
            {
              "value": "1986",
              "text": "新邵县"
            },
            {
              "value": "1987",
              "text": "邵阳县"
            },
            {
              "value": "1988",
              "text": "隆回县"
            },
            {
              "value": "1989",
              "text": "洞口县"
            },
            {
              "value": "1990",
              "text": "绥宁县"
            },
            {
              "value": "1991",
              "text": "新宁县"
            },
            {
              "value": "1992",
              "text": "城步苗族自治县"
            },
            {
              "value": "1993",
              "text": "武冈市"
            }
          ]
        },
        {
          "value": "1994",
          "text": "岳阳市",
          "children": [
            {
              "value": "1995",
              "text": "岳阳楼区"
            },
            {
              "value": "1996",
              "text": "云溪区"
            },
            {
              "value": "1997",
              "text": "君山区"
            },
            {
              "value": "1998",
              "text": "岳阳县"
            },
            {
              "value": "1999",
              "text": "华容县"
            },
            {
              "value": "2000",
              "text": "湘阴县"
            },
            {
              "value": "2001",
              "text": "平江县"
            },
            {
              "value": "2002",
              "text": "汨罗市"
            },
            {
              "value": "2003",
              "text": "临湘市"
            }
          ]
        },
        {
          "value": "2004",
          "text": "常德市",
          "children": [
            {
              "value": "2005",
              "text": "武陵区"
            },
            {
              "value": "2006",
              "text": "鼎城区"
            },
            {
              "value": "2007",
              "text": "安乡县"
            },
            {
              "value": "2008",
              "text": "汉寿县"
            },
            {
              "value": "2009",
              "text": "澧县"
            },
            {
              "value": "2010",
              "text": "临澧县"
            },
            {
              "value": "2011",
              "text": "桃源县"
            },
            {
              "value": "2012",
              "text": "石门县"
            },
            {
              "value": "2013",
              "text": "津市市"
            }
          ]
        },
        {
          "value": "2014",
          "text": "张家界市",
          "children": [
            {
              "value": "2015",
              "text": "永定区"
            },
            {
              "value": "2016",
              "text": "武陵源区"
            },
            {
              "value": "2017",
              "text": "慈利县"
            },
            {
              "value": "2018",
              "text": "桑植县"
            }
          ]
        },
        {
          "value": "2019",
          "text": "益阳市",
          "children": [
            {
              "value": "2020",
              "text": "资阳区"
            },
            {
              "value": "2021",
              "text": "赫山区"
            },
            {
              "value": "2022",
              "text": "南县"
            },
            {
              "value": "2023",
              "text": "桃江县"
            },
            {
              "value": "2024",
              "text": "安化县"
            },
            {
              "value": "2025",
              "text": "沅江市"
            }
          ]
        },
        {
          "value": "2026",
          "text": "郴州市",
          "children": [
            {
              "value": "2027",
              "text": "北湖区"
            },
            {
              "value": "2028",
              "text": "苏仙区"
            },
            {
              "value": "2029",
              "text": "桂阳县"
            },
            {
              "value": "2030",
              "text": "宜章县"
            },
            {
              "value": "2031",
              "text": "永兴县"
            },
            {
              "value": "2032",
              "text": "嘉禾县"
            },
            {
              "value": "2033",
              "text": "临武县"
            },
            {
              "value": "2034",
              "text": "汝城县"
            },
            {
              "value": "2035",
              "text": "桂东县"
            },
            {
              "value": "2036",
              "text": "安仁县"
            },
            {
              "value": "2037",
              "text": "资兴市"
            }
          ]
        },
        {
          "value": "2038",
          "text": "永州市",
          "children": [
            {
              "value": "2039",
              "text": "芝山区"
            },
            {
              "value": "2040",
              "text": "冷水滩区"
            },
            {
              "value": "2041",
              "text": "祁阳县"
            },
            {
              "value": "2042",
              "text": "东安县"
            },
            {
              "value": "2043",
              "text": "双牌县"
            },
            {
              "value": "2044",
              "text": "道县"
            },
            {
              "value": "2045",
              "text": "江永县"
            },
            {
              "value": "2046",
              "text": "宁远县"
            },
            {
              "value": "2047",
              "text": "蓝山县"
            },
            {
              "value": "2048",
              "text": "新田县"
            },
            {
              "value": "2049",
              "text": "江华瑶族自治县"
            },
            {
              "value": "3652",
              "text": "零陵区"
            }
          ]
        },
        {
          "value": "2050",
          "text": "怀化市",
          "children": [
            {
              "value": "2051",
              "text": "鹤城区"
            },
            {
              "value": "2052",
              "text": "中方县"
            },
            {
              "value": "2053",
              "text": "沅陵县"
            },
            {
              "value": "2054",
              "text": "辰溪县"
            },
            {
              "value": "2055",
              "text": "溆浦县"
            },
            {
              "value": "2056",
              "text": "会同县"
            },
            {
              "value": "2057",
              "text": "麻阳苗族自治县"
            },
            {
              "value": "2058",
              "text": "新晃侗族自治县"
            },
            {
              "value": "2059",
              "text": "芷江侗族自治县"
            },
            {
              "value": "2060",
              "text": "靖州苗族侗族自治县"
            },
            {
              "value": "2061",
              "text": "通道侗族自治县"
            },
            {
              "value": "2062",
              "text": "洪江市"
            }
          ]
        },
        {
          "value": "2063",
          "text": "娄底市",
          "children": [
            {
              "value": "2064",
              "text": "娄星区"
            },
            {
              "value": "2065",
              "text": "冷水江市"
            },
            {
              "value": "2066",
              "text": "涟源市"
            },
            {
              "value": "2067",
              "text": "双峰县"
            },
            {
              "value": "2068",
              "text": "新化县"
            }
          ]
        },
        {
          "value": "2069",
          "text": "湘西土家族苗族自治州",
          "children": [
            {
              "value": "2070",
              "text": "吉首市"
            },
            {
              "value": "2071",
              "text": "泸溪县"
            },
            {
              "value": "2072",
              "text": "凤凰县"
            },
            {
              "value": "2073",
              "text": "花垣县"
            },
            {
              "value": "2074",
              "text": "保靖县"
            },
            {
              "value": "2075",
              "text": "古丈县"
            },
            {
              "value": "2076",
              "text": "永顺县"
            },
            {
              "value": "2077",
              "text": "龙山县"
            }
          ]
        }
      ]
    },
    {
      "value": "2078",
      "text": "广东省",
      "children": [
        {
          "value": "2079",
          "text": "广州市",
          "children": [
            {
              "value": "2080",
              "text": "东山区"
            },
            {
              "value": "2081",
              "text": "荔湾区"
            },
            {
              "value": "2082",
              "text": "越秀区"
            },
            {
              "value": "2083",
              "text": "海珠区"
            },
            {
              "value": "2084",
              "text": "天河区"
            },
            {
              "value": "2085",
              "text": "芳村区"
            },
            {
              "value": "2086",
              "text": "白云区"
            },
            {
              "value": "2087",
              "text": "黄埔区"
            },
            {
              "value": "2088",
              "text": "番禺区"
            },
            {
              "value": "2089",
              "text": "花都区"
            },
            {
              "value": "2090",
              "text": "增城区"
            },
            {
              "value": "2091",
              "text": "从化区"
            },
            {
              "value": "3555",
              "text": "萝岗区"
            },
            {
              "value": "3556",
              "text": "南沙区"
            },
            {
              "value": "3844",
              "text": "广州大学城"
            }
          ]
        },
        {
          "value": "2092",
          "text": "韶关市",
          "children": [
            {
              "value": "2093",
              "text": "武江区"
            },
            {
              "value": "2094",
              "text": "浈江区"
            },
            {
              "value": "2095",
              "text": "曲江区"
            },
            {
              "value": "2096",
              "text": "始兴县"
            },
            {
              "value": "2097",
              "text": "仁化县"
            },
            {
              "value": "2098",
              "text": "翁源县"
            },
            {
              "value": "2099",
              "text": "乳源瑶族自治县"
            },
            {
              "value": "2100",
              "text": "新丰县"
            },
            {
              "value": "2101",
              "text": "乐昌市"
            },
            {
              "value": "2102",
              "text": "南雄市"
            }
          ]
        },
        {
          "value": "2103",
          "text": "深圳市",
          "children": [
            {
              "value": "2104",
              "text": "罗湖区"
            },
            {
              "value": "2105",
              "text": "福田区"
            },
            {
              "value": "2106",
              "text": "南山区"
            },
            {
              "value": "2107",
              "text": "宝安区"
            },
            {
              "value": "2108",
              "text": "龙岗区"
            },
            {
              "value": "2109",
              "text": "盐田区"
            },
            {
              "value": "3686",
              "text": "龙华区"
            },
            {
              "value": "3688",
              "text": "坪山新区"
            },
            {
              "value": "3854",
              "text": "光明新区"
            },
            {
              "value": "3863",
              "text": "大鹏新区"
            }
          ]
        },
        {
          "value": "2110",
          "text": "珠海市",
          "children": [
            {
              "value": "2111",
              "text": "香洲区"
            },
            {
              "value": "2112",
              "text": "斗门区"
            },
            {
              "value": "2113",
              "text": "金湾区"
            }
          ]
        },
        {
          "value": "2114",
          "text": "汕头市",
          "children": [
            {
              "value": "2115",
              "text": "濠江区"
            },
            {
              "value": "2116",
              "text": "龙湖区"
            },
            {
              "value": "2117",
              "text": "金平区"
            },
            {
              "value": "2118",
              "text": "潮南区"
            },
            {
              "value": "2119",
              "text": "澄海区"
            },
            {
              "value": "2120",
              "text": "潮阳区"
            },
            {
              "value": "2121",
              "text": "南澳县"
            }
          ]
        },
        {
          "value": "2122",
          "text": "佛山市",
          "children": [
            {
              "value": "2123",
              "text": "禅城区"
            },
            {
              "value": "2124",
              "text": "顺德区"
            },
            {
              "value": "2125",
              "text": "南海区"
            },
            {
              "value": "2126",
              "text": "三水区"
            },
            {
              "value": "2127",
              "text": "高明区"
            }
          ]
        },
        {
          "value": "2128",
          "text": "江门市",
          "children": [
            {
              "value": "2129",
              "text": "蓬江区"
            },
            {
              "value": "2130",
              "text": "江海区"
            },
            {
              "value": "2131",
              "text": "台山市"
            },
            {
              "value": "2132",
              "text": "新会区"
            },
            {
              "value": "2133",
              "text": "开平市"
            },
            {
              "value": "2134",
              "text": "鹤山市"
            },
            {
              "value": "2135",
              "text": "恩平市"
            }
          ]
        },
        {
          "value": "2136",
          "text": "湛江市",
          "children": [
            {
              "value": "2137",
              "text": "赤坎区"
            },
            {
              "value": "2138",
              "text": "霞山区"
            },
            {
              "value": "2139",
              "text": "坡头区"
            },
            {
              "value": "2140",
              "text": "麻章区"
            },
            {
              "value": "2141",
              "text": "遂溪县"
            },
            {
              "value": "2142",
              "text": "徐闻县"
            },
            {
              "value": "2143",
              "text": "廉江市"
            },
            {
              "value": "2144",
              "text": "雷州市"
            },
            {
              "value": "2145",
              "text": "吴川市"
            },
            {
              "value": "3945",
              "text": "经济技术开发区"
            }
          ]
        },
        {
          "value": "2146",
          "text": "茂名市",
          "children": [
            {
              "value": "2147",
              "text": "茂南区"
            },
            {
              "value": "2148",
              "text": "茂港区"
            },
            {
              "value": "2149",
              "text": "电白区"
            },
            {
              "value": "2150",
              "text": "高州市"
            },
            {
              "value": "2151",
              "text": "化州市"
            },
            {
              "value": "2152",
              "text": "信宜市"
            }
          ]
        },
        {
          "value": "2153",
          "text": "肇庆市",
          "children": [
            {
              "value": "2154",
              "text": "端州区"
            },
            {
              "value": "2155",
              "text": "鼎湖区"
            },
            {
              "value": "2156",
              "text": "广宁县"
            },
            {
              "value": "2157",
              "text": "怀集县"
            },
            {
              "value": "2158",
              "text": "封开县"
            },
            {
              "value": "2159",
              "text": "德庆县"
            },
            {
              "value": "2160",
              "text": "高要市"
            },
            {
              "value": "2161",
              "text": "四会市"
            }
          ]
        },
        {
          "value": "2162",
          "text": "惠州市",
          "children": [
            {
              "value": "2163",
              "text": "惠城区"
            },
            {
              "value": "2164",
              "text": "博罗县"
            },
            {
              "value": "2165",
              "text": "惠东县"
            },
            {
              "value": "2166",
              "text": "龙门县"
            },
            {
              "value": "2167",
              "text": "惠阳区"
            },
            {
              "value": "3898",
              "text": "大亚湾区"
            }
          ]
        },
        {
          "value": "2168",
          "text": "梅州市",
          "children": [
            {
              "value": "2169",
              "text": "梅江区"
            },
            {
              "value": "2170",
              "text": "梅县区"
            },
            {
              "value": "2171",
              "text": "大埔县"
            },
            {
              "value": "2172",
              "text": "丰顺县"
            },
            {
              "value": "2173",
              "text": "五华县"
            },
            {
              "value": "2174",
              "text": "平远县"
            },
            {
              "value": "2175",
              "text": "蕉岭县"
            },
            {
              "value": "2176",
              "text": "兴宁市"
            }
          ]
        },
        {
          "value": "2177",
          "text": "汕尾市",
          "children": [
            {
              "value": "2178",
              "text": "城区"
            },
            {
              "value": "2179",
              "text": "海丰县"
            },
            {
              "value": "2180",
              "text": "陆河县"
            },
            {
              "value": "2181",
              "text": "陆丰市"
            }
          ]
        },
        {
          "value": "2182",
          "text": "河源市",
          "children": [
            {
              "value": "2183",
              "text": "源城区"
            },
            {
              "value": "2184",
              "text": "紫金县"
            },
            {
              "value": "2185",
              "text": "龙川县"
            },
            {
              "value": "2186",
              "text": "连平县"
            },
            {
              "value": "2187",
              "text": "和平县"
            },
            {
              "value": "2188",
              "text": "东源县"
            }
          ]
        },
        {
          "value": "2189",
          "text": "阳江市",
          "children": [
            {
              "value": "2190",
              "text": "江城区"
            },
            {
              "value": "2191",
              "text": "阳西县"
            },
            {
              "value": "2192",
              "text": "阳东区"
            },
            {
              "value": "2193",
              "text": "阳春市"
            }
          ]
        },
        {
          "value": "2194",
          "text": "清远市",
          "children": [
            {
              "value": "2195",
              "text": "清城区"
            },
            {
              "value": "2196",
              "text": "佛冈县"
            },
            {
              "value": "2197",
              "text": "阳山县"
            },
            {
              "value": "2198",
              "text": "连山县"
            },
            {
              "value": "2199",
              "text": "连南县"
            },
            {
              "value": "2200",
              "text": "清新区"
            },
            {
              "value": "2201",
              "text": "英德市"
            },
            {
              "value": "2202",
              "text": "连州市"
            }
          ]
        },
        {
          "value": "2203",
          "text": "东莞市",
          "children": [
            {
              "value": "3587",
              "text": "莞城区"
            },
            {
              "value": "3588",
              "text": "南城区"
            },
            {
              "value": "3589",
              "text": "东城区"
            },
            {
              "value": "3590",
              "text": "茶山镇"
            },
            {
              "value": "3591",
              "text": "寮步镇"
            },
            {
              "value": "3592",
              "text": "大岭山镇"
            },
            {
              "value": "3593",
              "text": "大朗镇"
            },
            {
              "value": "3594",
              "text": "松山湖"
            },
            {
              "value": "3595",
              "text": "常平镇"
            },
            {
              "value": "3596",
              "text": "横沥镇"
            },
            {
              "value": "3597",
              "text": "东坑镇"
            },
            {
              "value": "3598",
              "text": "石排镇"
            },
            {
              "value": "3599",
              "text": "企石镇"
            },
            {
              "value": "3600",
              "text": "桥头镇"
            },
            {
              "value": "3601",
              "text": "谢岗镇"
            },
            {
              "value": "3602",
              "text": "塘厦镇"
            },
            {
              "value": "3603",
              "text": "樟木头镇"
            },
            {
              "value": "3604",
              "text": "清溪镇"
            },
            {
              "value": "3605",
              "text": "黄江镇"
            },
            {
              "value": "3606",
              "text": "凤岗镇"
            },
            {
              "value": "3607",
              "text": "万江区"
            },
            {
              "value": "3608",
              "text": "高埗镇"
            },
            {
              "value": "3609",
              "text": "石碣镇"
            },
            {
              "value": "3610",
              "text": "石龙镇"
            },
            {
              "value": "3611",
              "text": "麻涌镇"
            },
            {
              "value": "3612",
              "text": "中堂镇"
            },
            {
              "value": "3613",
              "text": "望牛墩镇"
            },
            {
              "value": "3614",
              "text": "洪梅镇"
            },
            {
              "value": "3615",
              "text": "道滘镇"
            },
            {
              "value": "3616",
              "text": "虎门镇"
            },
            {
              "value": "3617",
              "text": "厚街镇"
            },
            {
              "value": "3618",
              "text": "长安镇"
            },
            {
              "value": "3619",
              "text": "沙田镇"
            }
          ]
        },
        {
          "value": "2204",
          "text": "中山市",
          "children": [
            {
              "value": "3563",
              "text": "石岐街道"
            },
            {
              "value": "3564",
              "text": "东区街道"
            },
            {
              "value": "3565",
              "text": "西区街道"
            },
            {
              "value": "3566",
              "text": "南区街道"
            },
            {
              "value": "3567",
              "text": "五桂山镇"
            },
            {
              "value": "3568",
              "text": "火炬开发区"
            },
            {
              "value": "3569",
              "text": "黄圃镇"
            },
            {
              "value": "3570",
              "text": "南头镇"
            },
            {
              "value": "3571",
              "text": "东凤镇"
            },
            {
              "value": "3572",
              "text": "阜沙镇"
            },
            {
              "value": "3573",
              "text": "小榄镇"
            },
            {
              "value": "3574",
              "text": "东升镇"
            },
            {
              "value": "3575",
              "text": "古镇镇"
            },
            {
              "value": "3576",
              "text": "横栏镇"
            },
            {
              "value": "3577",
              "text": "三角镇"
            },
            {
              "value": "3578",
              "text": "民众镇"
            },
            {
              "value": "3579",
              "text": "南朗镇"
            },
            {
              "value": "3580",
              "text": "港口镇"
            },
            {
              "value": "3581",
              "text": "大涌镇"
            },
            {
              "value": "3582",
              "text": "沙溪镇"
            },
            {
              "value": "3583",
              "text": "三乡镇"
            },
            {
              "value": "3584",
              "text": "板芙镇"
            },
            {
              "value": "3585",
              "text": "神湾镇"
            },
            {
              "value": "3586",
              "text": "坦洲镇"
            },
            {
              "value": "3912",
              "text": "城区"
            },
            {
              "value": "3934",
              "text": "沙朗镇"
            }
          ]
        },
        {
          "value": "2205",
          "text": "潮州市",
          "children": [
            {
              "value": "2206",
              "text": "湘桥区"
            },
            {
              "value": "2207",
              "text": "潮安区"
            },
            {
              "value": "2208",
              "text": "饶平县"
            },
            {
              "value": "3972",
              "text": "枫溪区"
            }
          ]
        },
        {
          "value": "2209",
          "text": "揭阳市",
          "children": [
            {
              "value": "2210",
              "text": "榕城区"
            },
            {
              "value": "2211",
              "text": "揭东县"
            },
            {
              "value": "2212",
              "text": "揭西县"
            },
            {
              "value": "2213",
              "text": "惠来县"
            },
            {
              "value": "2214",
              "text": "普宁市"
            },
            {
              "value": "3873",
              "text": "东山区"
            },
			{
              "value": "4209",
              "text": "蓝城区"
            }
          ]
        },
        {
          "value": "2215",
          "text": "云浮市",
          "children": [
            {
              "value": "2216",
              "text": "云城区"
            },
            {
              "value": "2217",
              "text": "新兴县"
            },
            {
              "value": "2218",
              "text": "郁南县"
            },
            {
              "value": "2219",
              "text": "云安县"
            },
            {
              "value": "2220",
              "text": "罗定市"
            }
          ]
        }
      ]
    },
    {
      "value": "2221",
      "text": "广西",
      "children": [
        {
          "value": "2222",
          "text": "南宁市",
          "children": [
            {
              "value": "2223",
              "text": "兴宁区"
            },
            {
              "value": "2224",
              "text": "青秀区"
            },
            {
              "value": "2225",
              "text": "西乡塘区"
            },
            {
              "value": "2226",
              "text": "江南区"
            },
            {
              "value": "2227",
              "text": "良庆区"
            },
            {
              "value": "2228",
              "text": "邕宁区"
            },
            {
              "value": "2229",
              "text": "武鸣县"
            },
            {
              "value": "2230",
              "text": "隆安县"
            },
            {
              "value": "2231",
              "text": "马山县"
            },
            {
              "value": "2232",
              "text": "上林县"
            },
            {
              "value": "2233",
              "text": "宾阳县"
            },
            {
              "value": "2234",
              "text": "横县"
            }
          ]
        },
        {
          "value": "2235",
          "text": "柳州市",
          "children": [
            {
              "value": "2236",
              "text": "城中区"
            },
            {
              "value": "2237",
              "text": "鱼峰区"
            },
            {
              "value": "2238",
              "text": "柳南区"
            },
            {
              "value": "2239",
              "text": "柳北区"
            },
            {
              "value": "2240",
              "text": "柳江县"
            },
            {
              "value": "2241",
              "text": "柳城县"
            },
            {
              "value": "2242",
              "text": "鹿寨县"
            },
            {
              "value": "2243",
              "text": "融安县"
            },
            {
              "value": "2244",
              "text": "融水县"
            },
            {
              "value": "2245",
              "text": "三江县"
            }
          ]
        },
        {
          "value": "2246",
          "text": "桂林市",
          "children": [
            {
              "value": "2247",
              "text": "秀峰区"
            },
            {
              "value": "2248",
              "text": "叠彩区"
            },
            {
              "value": "2249",
              "text": "象山区"
            },
            {
              "value": "2250",
              "text": "七星区"
            },
            {
              "value": "2251",
              "text": "雁山区"
            },
            {
              "value": "2252",
              "text": "阳朔县"
            },
            {
              "value": "2253",
              "text": "临桂县"
            },
            {
              "value": "2254",
              "text": "灵川县"
            },
            {
              "value": "2255",
              "text": "全州县"
            },
            {
              "value": "2256",
              "text": "兴安县"
            },
            {
              "value": "2257",
              "text": "永福县"
            },
            {
              "value": "2258",
              "text": "灌阳县"
            },
            {
              "value": "2259",
              "text": "龙胜县"
            },
            {
              "value": "2260",
              "text": "资源县"
            },
            {
              "value": "2261",
              "text": "平乐县"
            },
            {
              "value": "2262",
              "text": "荔浦县"
            },
            {
              "value": "2263",
              "text": "恭城县"
            }
          ]
        },
        {
          "value": "2264",
          "text": "梧州市",
          "children": [
            {
              "value": "2265",
              "text": "万秀区"
            },
            {
              "value": "2266",
              "text": "蝶山区"
            },
            {
              "value": "2267",
              "text": "长洲区"
            },
            {
              "value": "2268",
              "text": "龙圩区"
            },
            {
              "value": "2269",
              "text": "藤县"
            },
            {
              "value": "2270",
              "text": "蒙山县"
            },
            {
              "value": "2271",
              "text": "岑溪市"
            },
            {
              "value": "3679",
              "text": "苍梧县"
            }
          ]
        },
        {
          "value": "2272",
          "text": "北海市",
          "children": [
            {
              "value": "2273",
              "text": "海城区"
            },
            {
              "value": "2274",
              "text": "银海区"
            },
            {
              "value": "2275",
              "text": "铁山港区"
            },
            {
              "value": "2276",
              "text": "合浦县"
            }
          ]
        },
        {
          "value": "2277",
          "text": "防城港市",
          "children": [
            {
              "value": "2278",
              "text": "港口区"
            },
            {
              "value": "2279",
              "text": "防城区"
            },
            {
              "value": "2280",
              "text": "上思县"
            },
            {
              "value": "2281",
              "text": "东兴市"
            }
          ]
        },
        {
          "value": "2282",
          "text": "钦州市",
          "children": [
            {
              "value": "2283",
              "text": "钦南区"
            },
            {
              "value": "2284",
              "text": "钦北区"
            },
            {
              "value": "2285",
              "text": "浦北县"
            },
            {
              "value": "2286",
              "text": "灵山县"
            }
          ]
        },
        {
          "value": "2287",
          "text": "贵港市",
          "children": [
            {
              "value": "2288",
              "text": "港北区"
            },
            {
              "value": "2289",
              "text": "港南区"
            },
            {
              "value": "2290",
              "text": "覃塘区"
            },
            {
              "value": "2291",
              "text": "平南县"
            },
            {
              "value": "2292",
              "text": "桂平市"
            }
          ]
        },
        {
          "value": "2293",
          "text": "玉林市",
          "children": [
            {
              "value": "2294",
              "text": "玉州区"
            },
            {
              "value": "2295",
              "text": "容县"
            },
            {
              "value": "2296",
              "text": "陆川县"
            },
            {
              "value": "2297",
              "text": "博白县"
            },
            {
              "value": "2298",
              "text": "兴业县"
            },
            {
              "value": "2299",
              "text": "北流市"
            },
            {
              "value": "3653",
              "text": "福绵区"
            }
          ]
        },
        {
          "value": "2300",
          "text": "崇左市",
          "children": [
            {
              "value": "2301",
              "text": "江州区"
            },
            {
              "value": "2302",
              "text": "凭祥市"
            },
            {
              "value": "2303",
              "text": "扶绥县"
            },
            {
              "value": "2304",
              "text": "宁明县"
            },
            {
              "value": "2305",
              "text": "龙州县"
            },
            {
              "value": "2306",
              "text": "大新县"
            },
            {
              "value": "2307",
              "text": "天等县"
            }
          ]
        },
        {
          "value": "2308",
          "text": "来宾市",
          "children": [
            {
              "value": "2309",
              "text": "兴宾区"
            },
            {
              "value": "2310",
              "text": "合山市"
            },
            {
              "value": "2311",
              "text": "忻城县"
            },
            {
              "value": "2312",
              "text": "象州县"
            },
            {
              "value": "2313",
              "text": "武宣县"
            },
            {
              "value": "2314",
              "text": "金秀县"
            }
          ]
        },
        {
          "value": "2315",
          "text": "贺州市",
          "children": [
            {
              "value": "2316",
              "text": "八步区"
            },
            {
              "value": "2317",
              "text": "昭平县"
            },
            {
              "value": "2318",
              "text": "钟山县"
            },
            {
              "value": "2319",
              "text": "富川县"
            },
            {
              "value": "3831",
              "text": "平桂管理区"
            }
          ]
        },
        {
          "value": "2320",
          "text": "百色市",
          "children": [
            {
              "value": "2321",
              "text": "右江区"
            },
            {
              "value": "2322",
              "text": "田阳县"
            },
            {
              "value": "2323",
              "text": "田东县"
            },
            {
              "value": "2324",
              "text": "平果县"
            },
            {
              "value": "2325",
              "text": "德保县"
            },
            {
              "value": "2326",
              "text": "靖西县"
            },
            {
              "value": "2327",
              "text": "那坡县"
            },
            {
              "value": "2328",
              "text": "凌云县"
            },
            {
              "value": "2329",
              "text": "乐业县"
            },
            {
              "value": "2330",
              "text": "田林县"
            },
            {
              "value": "2331",
              "text": "隆林县"
            },
            {
              "value": "2332",
              "text": "西林县"
            }
          ]
        },
        {
          "value": "2333",
          "text": "河池市",
          "children": [
            {
              "value": "2334",
              "text": "金城江区"
            },
            {
              "value": "2335",
              "text": "宜州市"
            },
            {
              "value": "2336",
              "text": "罗城县"
            },
            {
              "value": "2337",
              "text": "环江县"
            },
            {
              "value": "2338",
              "text": "南丹县"
            },
            {
              "value": "2339",
              "text": "天峨县"
            },
            {
              "value": "2340",
              "text": "凤山县"
            },
            {
              "value": "2341",
              "text": "东兰县"
            },
            {
              "value": "2342",
              "text": "巴马县"
            },
            {
              "value": "2343",
              "text": "都安县"
            },
            {
              "value": "2344",
              "text": "大化县"
            }
          ]
        }
      ]
    },
    {
      "value": "2345",
      "text": "海南省",
      "children": [
        {
          "value": "2346",
          "text": "琼海市",
          "children": [
            {
              "value": "3746",
              "text": "龙江镇"
            },
            {
              "value": "3752",
              "text": "潭门镇"
            },
            {
              "value": "3754",
              "text": "塔洋镇"
            },
            {
              "value": "3756",
              "text": "长坡镇"
            },
            {
              "value": "3758",
              "text": "大路镇"
            },
            {
              "value": "3760",
              "text": "会山镇"
            },
            {
              "value": "3763",
              "text": "彬村山华侨农场"
            },
            {
              "value": "3766",
              "text": "东太农场"
            },
            {
              "value": "3767",
              "text": "东红农场"
            },
            {
              "value": "3770",
              "text": "东升农场"
            },
            {
              "value": "3774",
              "text": "南俸农场"
            },
            {
              "value": "4087",
              "text": "嘉积镇"
            },
            {
              "value": "4089",
              "text": "万泉镇"
            },
            {
              "value": "4092",
              "text": "石壁镇"
            },
            {
              "value": "4096",
              "text": "中原镇"
            },
            {
              "value": "4100",
              "text": "博鳌镇"
            },
            {
              "value": "4105",
              "text": "阳江镇"
            }
          ]
        },
        {
          "value": "2347",
          "text": "儋州市",
          "children": [
            {
              "value": "3769",
              "text": "八一农场"
            },
            {
              "value": "3775",
              "text": "西华农场"
            },
            {
              "value": "3783",
              "text": "西庆农场"
            },
            {
              "value": "3790",
              "text": "西流农场"
            },
            {
              "value": "3800",
              "text": "新盈农场"
            },
            {
              "value": "3805",
              "text": "龙山农场"
            },
            {
              "value": "3808",
              "text": "红岭农场"
            },
            {
              "value": "3921",
              "text": "热作学院"
            },
            {
              "value": "3923",
              "text": "那大镇"
            },
            {
              "value": "3931",
              "text": "富克镇"
            },
            {
              "value": "3938",
              "text": "和庆镇"
            },
            {
              "value": "3941",
              "text": "南丰镇"
            },
            {
              "value": "3944",
              "text": "大成镇"
            },
            {
              "value": "3948",
              "text": "雅星镇"
            },
            {
              "value": "3950",
              "text": "兰洋镇"
            },
            {
              "value": "3954",
              "text": "光村镇"
            },
            {
              "value": "3957",
              "text": "木棠镇"
            },
            {
              "value": "3959",
              "text": "海头镇"
            },
            {
              "value": "3963",
              "text": "峨蔓镇"
            },
            {
              "value": "3966",
              "text": "三都镇"
            },
            {
              "value": "3971",
              "text": "王五镇"
            },
            {
              "value": "3976",
              "text": "白马井镇"
            },
            {
              "value": "3977",
              "text": "中和镇"
            },
            {
              "value": "3978",
              "text": "排浦镇"
            },
            {
              "value": "3979",
              "text": "东成镇"
            },
            {
              "value": "3981",
              "text": "新州镇"
            },
            {
              "value": "3985",
              "text": "洋浦经济开发区"
            },
            {
              "value": "3988",
              "text": "西培农场"
            },
            {
              "value": "3991",
              "text": "西联农场"
            },
            {
              "value": "3993",
              "text": "蓝洋农场"
            }
          ]
        },
        {
          "value": "2348",
          "text": "五指山市",
          "children": [
            {
              "value": "4113",
              "text": "通什镇"
            },
            {
              "value": "4116",
              "text": "南圣镇"
            },
            {
              "value": "4117",
              "text": "毛阳镇"
            },
            {
              "value": "4119",
              "text": "番阳镇"
            },
            {
              "value": "4120",
              "text": "畅好乡"
            },
            {
              "value": "4122",
              "text": "毛道乡"
            },
            {
              "value": "4123",
              "text": "水满乡"
            },
            {
              "value": "4125",
              "text": "畅好农场"
            }
          ]
        },
        {
          "value": "2349",
          "text": "文昌市",
          "children": [
            {
              "value": "3928",
              "text": "文成镇"
            },
            {
              "value": "3952",
              "text": "重兴镇"
            },
            {
              "value": "3967",
              "text": "蓬莱镇"
            },
            {
              "value": "3975",
              "text": "会文镇"
            },
            {
              "value": "3984",
              "text": "东路镇"
            },
            {
              "value": "3992",
              "text": "潭牛镇"
            },
            {
              "value": "3996",
              "text": "东阁镇"
            },
            {
              "value": "3999",
              "text": "文教镇"
            },
            {
              "value": "4001",
              "text": "东郊镇"
            },
            {
              "value": "4005",
              "text": "龙楼镇"
            },
            {
              "value": "4010",
              "text": "昌洒镇"
            },
            {
              "value": "4018",
              "text": "翁田镇"
            },
            {
              "value": "4022",
              "text": "抱罗镇"
            },
            {
              "value": "4030",
              "text": "冯坡镇"
            },
            {
              "value": "4038",
              "text": "锦山镇"
            },
            {
              "value": "4045",
              "text": "铺前镇"
            },
            {
              "value": "4048",
              "text": "公坡镇"
            },
            {
              "value": "4050",
              "text": "迈号镇"
            },
            {
              "value": "4054",
              "text": "清谰镇"
            },
            {
              "value": "4062",
              "text": "南阳镇"
            },
            {
              "value": "4068",
              "text": "新桥镇"
            },
            {
              "value": "4072",
              "text": "头苑镇"
            },
            {
              "value": "4076",
              "text": "宝芳乡"
            },
            {
              "value": "4082",
              "text": "龙马乡"
            },
            {
              "value": "4086",
              "text": "湖山乡"
            },
            {
              "value": "4090",
              "text": "东路农场"
            },
            {
              "value": "4095",
              "text": "南阳农场"
            },
            {
              "value": "4102",
              "text": "罗豆农场"
            },
            {
              "value": "4108",
              "text": "橡胶研究所"
            }
          ]
        },
        {
          "value": "2350",
          "text": "万宁市",
          "children": [
            {
              "value": "3779",
              "text": "兴隆镇"
            },
            {
              "value": "3781",
              "text": "南林农场"
            },
            {
              "value": "3785",
              "text": "万城镇"
            },
            {
              "value": "3791",
              "text": "龙滚镇"
            },
            {
              "value": "3795",
              "text": "和乐镇"
            },
            {
              "value": "3799",
              "text": "后安镇"
            },
            {
              "value": "3802",
              "text": "大茂镇"
            },
            {
              "value": "3804",
              "text": "东澳镇"
            },
            {
              "value": "3807",
              "text": "礼纪镇"
            },
            {
              "value": "3812",
              "text": "长丰镇"
            },
            {
              "value": "3814",
              "text": "山根镇"
            },
            {
              "value": "3818",
              "text": "北大镇"
            },
            {
              "value": "3821",
              "text": "南桥镇"
            },
            {
              "value": "3824",
              "text": "三更罗镇"
            },
            {
              "value": "3858",
              "text": "六连林场"
            },
            {
              "value": "3861",
              "text": "东兴农场"
            },
            {
              "value": "3866",
              "text": "东和农场"
            },
            {
              "value": "3867",
              "text": "新中农场"
            },
            {
              "value": "3869",
              "text": "兴隆华侨农场"
            }
          ]
        },
        {
          "value": "2351",
          "text": "东方市",
          "children": [
            {
              "value": "3872",
              "text": "八所镇"
            },
            {
              "value": "3876",
              "text": "东河镇"
            },
            {
              "value": "3887",
              "text": "大田镇"
            },
            {
              "value": "3891",
              "text": "感城镇"
            },
            {
              "value": "3894",
              "text": "板桥镇"
            },
            {
              "value": "3895",
              "text": "三家镇"
            },
            {
              "value": "3899",
              "text": "四更镇"
            },
            {
              "value": "3902",
              "text": "新龙镇"
            },
            {
              "value": "3905",
              "text": "天安乡"
            },
            {
              "value": "3907",
              "text": "江边乡"
            },
            {
              "value": "3908",
              "text": "广坝农场"
            },
            {
              "value": "3910",
              "text": "东方华侨农场"
            }
          ]
        },
        {
          "value": "2352",
          "text": "定安县",
          "children": [
            {
              "value": "3734",
              "text": "城区"
            },
            {
              "value": "3735",
              "text": "黄竹镇"
            },
            {
              "value": "3736",
              "text": "定城镇"
            },
            {
              "value": "3738",
              "text": "新竹镇"
            },
            {
              "value": "3739",
              "text": "龙湖镇"
            },
            {
              "value": "3741",
              "text": "雷鸣镇"
            },
            {
              "value": "3742",
              "text": "龙门镇"
            },
            {
              "value": "3744",
              "text": "龙河镇"
            },
            {
              "value": "3748",
              "text": "岭口镇"
            },
            {
              "value": "3750",
              "text": "翰林镇"
            },
            {
              "value": "3753",
              "text": "富文镇"
            },
            {
              "value": "3755",
              "text": "金鸡岭农场"
            },
            {
              "value": "3757",
              "text": "中瑞农场"
            },
            {
              "value": "3759",
              "text": "南海农场"
            }
          ]
        },
        {
          "value": "2353",
          "text": "屯昌县",
          "children": [
            {
              "value": "3764",
              "text": "县城内"
            },
            {
              "value": "3771",
              "text": "屯城镇"
            },
            {
              "value": "3773",
              "text": "新兴镇"
            },
            {
              "value": "3776",
              "text": "枫木镇"
            },
            {
              "value": "3778",
              "text": "乌坡镇"
            },
            {
              "value": "3780",
              "text": "南吕镇"
            },
            {
              "value": "3782",
              "text": "南坤镇"
            },
            {
              "value": "3786",
              "text": "中建农场"
            },
            {
              "value": "3789",
              "text": "坡心镇"
            },
            {
              "value": "3793",
              "text": "中坤农场"
            },
            {
              "value": "3796",
              "text": "西昌镇"
            }
          ]
        },
        {
          "value": "2354",
          "text": "澄迈县",
          "children": [
            {
              "value": "4157",
              "text": "城区"
            },
            {
              "value": "4158",
              "text": "金江镇"
            },
            {
              "value": "4159",
              "text": "老城镇"
            },
            {
              "value": "4161",
              "text": "瑞溪镇"
            },
            {
              "value": "4163",
              "text": "永发镇"
            },
            {
              "value": "4166",
              "text": "加乐镇"
            },
            {
              "value": "4171",
              "text": "文儒镇"
            },
            {
              "value": "4172",
              "text": "中兴镇"
            },
            {
              "value": "4174",
              "text": "仁兴镇"
            },
            {
              "value": "4175",
              "text": "福山镇"
            },
            {
              "value": "4176",
              "text": "桥头镇"
            },
            {
              "value": "4178",
              "text": "大丰镇"
            },
            {
              "value": "4180",
              "text": "红光农场"
            },
            {
              "value": "4181",
              "text": "西达农场"
            },
            {
              "value": "4183",
              "text": "金安农场"
            }
          ]
        },
        {
          "value": "2355",
          "text": "临高县",
          "children": [
            {
              "value": "4127",
              "text": "城区"
            },
            {
              "value": "4129",
              "text": "临城镇"
            },
            {
              "value": "4130",
              "text": "波莲镇"
            },
            {
              "value": "4133",
              "text": "东英镇"
            },
            {
              "value": "4135",
              "text": "博厚镇"
            },
            {
              "value": "4138",
              "text": "皇桐镇"
            },
            {
              "value": "4140",
              "text": "多文镇"
            },
            {
              "value": "4141",
              "text": "和舍镇"
            },
            {
              "value": "4144",
              "text": "南宝镇"
            },
            {
              "value": "4146",
              "text": "新盈镇"
            },
            {
              "value": "4148",
              "text": "调楼镇"
            },
            {
              "value": "4150",
              "text": "加来镇"
            },
            {
              "value": "4152",
              "text": "红华农场"
            },
            {
              "value": "4155",
              "text": "加来农场"
            }
          ]
        },
        {
          "value": "2356",
          "text": "白沙县",
          "children": [
            {
              "value": "3857",
              "text": "城区"
            },
            {
              "value": "3862",
              "text": "阜龙乡"
            },
            {
              "value": "3870",
              "text": "青松乡"
            },
            {
              "value": "3871",
              "text": "金波乡"
            },
            {
              "value": "3875",
              "text": "荣邦乡"
            },
            {
              "value": "3877",
              "text": "白沙农场"
            },
            {
              "value": "3880",
              "text": "牙叉镇"
            },
            {
              "value": "3882",
              "text": "龙江农场"
            },
            {
              "value": "3885",
              "text": "七坊镇"
            },
            {
              "value": "3886",
              "text": "邦溪农场"
            },
            {
              "value": "3890",
              "text": "邦溪镇"
            },
            {
              "value": "3893",
              "text": "打安镇"
            },
            {
              "value": "3897",
              "text": "细水乡"
            },
            {
              "value": "3900",
              "text": "元门乡"
            }
          ]
        },
        {
          "value": "2357",
          "text": "昌江县",
          "children": [
            {
              "value": "3810",
              "text": "城区"
            },
            {
              "value": "3813",
              "text": "红林农场"
            },
            {
              "value": "3817",
              "text": "石碌镇"
            },
            {
              "value": "3820",
              "text": "叉河镇"
            },
            {
              "value": "3825",
              "text": "十月田镇"
            },
            {
              "value": "3829",
              "text": "乌烈镇"
            },
            {
              "value": "3832",
              "text": "昌化镇"
            },
            {
              "value": "3836",
              "text": "海尾镇"
            },
            {
              "value": "3839",
              "text": "七叉镇"
            },
            {
              "value": "3842",
              "text": "王下乡"
            },
            {
              "value": "3846",
              "text": "海南矿业公司"
            },
            {
              "value": "3850",
              "text": "霸王岭林场"
            }
          ]
        },
        {
          "value": "2358",
          "text": "乐东县",
          "children": [
            {
              "value": "3961",
              "text": "城区"
            },
            {
              "value": "3964",
              "text": "尖峰岭林业公司"
            },
            {
              "value": "3970",
              "text": "莺歌海盐场"
            },
            {
              "value": "3974",
              "text": "山荣农场"
            },
            {
              "value": "3987",
              "text": "乐光农场"
            },
            {
              "value": "3990",
              "text": "抱由镇"
            },
            {
              "value": "3994",
              "text": "保国农场"
            },
            {
              "value": "4021",
              "text": "万冲镇"
            },
            {
              "value": "4025",
              "text": "大安镇"
            },
            {
              "value": "4029",
              "text": "志仲镇"
            },
            {
              "value": "4033",
              "text": "千家镇"
            },
            {
              "value": "4035",
              "text": "九所镇"
            },
            {
              "value": "4039",
              "text": "利国镇"
            },
            {
              "value": "4041",
              "text": "黄流镇"
            },
            {
              "value": "4043",
              "text": "佛罗镇"
            },
            {
              "value": "4047",
              "text": "尖峰镇"
            },
            {
              "value": "4049",
              "text": "莺歌海镇"
            }
          ]
        },
        {
          "value": "2359",
          "text": "陵水县",
          "children": [
            {
              "value": "3794",
              "text": "城区"
            },
            {
              "value": "3798",
              "text": "东华镇"
            },
            {
              "value": "3801",
              "text": "南平镇"
            },
            {
              "value": "3806",
              "text": "吊罗山林业公司"
            },
            {
              "value": "3809",
              "text": "岭门农场"
            },
            {
              "value": "3816",
              "text": "南平农场"
            },
            {
              "value": "3822",
              "text": "椰林镇"
            },
            {
              "value": "3827",
              "text": "光坡镇"
            },
            {
              "value": "3830",
              "text": "三才镇"
            },
            {
              "value": "3834",
              "text": "英州镇"
            },
            {
              "value": "3838",
              "text": "隆广镇"
            },
            {
              "value": "3841",
              "text": "文罗镇"
            },
            {
              "value": "3845",
              "text": "本号镇"
            },
            {
              "value": "3849",
              "text": "新村镇"
            },
            {
              "value": "3852",
              "text": "黎安镇"
            },
            {
              "value": "3859",
              "text": "提蒙乡"
            },
            {
              "value": "3864",
              "text": "群英乡"
            }
          ]
        },
        {
          "value": "2360",
          "text": "保亭县",
          "children": [
            {
              "value": "2360",
              "text": "保亭县"
            }
          ]
        },
        {
          "value": "2361",
          "text": "琼中县",
          "children": [
            {
              "value": "3762",
              "text": "红毛镇"
            },
            {
              "value": "3765",
              "text": "中平镇"
            },
            {
              "value": "3768",
              "text": "上安乡"
            },
            {
              "value": "3772",
              "text": "什运乡"
            },
            {
              "value": "3883",
              "text": "保亭研究所"
            },
            {
              "value": "3888",
              "text": "新星农场"
            },
            {
              "value": "3892",
              "text": "金江农场"
            },
            {
              "value": "3896",
              "text": "三道农场"
            },
            {
              "value": "3901",
              "text": "保城镇"
            },
            {
              "value": "3904",
              "text": "什玲镇"
            },
            {
              "value": "3906",
              "text": "加茂镇"
            },
            {
              "value": "3909",
              "text": "响水镇"
            },
            {
              "value": "3913",
              "text": "新政镇"
            },
            {
              "value": "3915",
              "text": "三道镇"
            },
            {
              "value": "3918",
              "text": "六弓乡"
            },
            {
              "value": "3922",
              "text": "南林乡"
            },
            {
              "value": "3925",
              "text": "城区"
            },
            {
              "value": "3927",
              "text": "毛感乡"
            },
            {
              "value": "3929",
              "text": "吊罗山乡"
            },
            {
              "value": "3932",
              "text": "黎母山林业公司"
            },
            {
              "value": "3936",
              "text": "阳江农场"
            },
            {
              "value": "3939",
              "text": "乌石农场"
            },
            {
              "value": "3946",
              "text": "加钗农场"
            },
            {
              "value": "3951",
              "text": "长征农场"
            },
            {
              "value": "3953",
              "text": "营根镇"
            },
            {
              "value": "3956",
              "text": "湾岭镇"
            },
            {
              "value": "3960",
              "text": "黎母山镇"
            },
            {
              "value": "3965",
              "text": "和平镇"
            },
            {
              "value": "3969",
              "text": "长征镇"
            }
          ]
        },
        {
          "value": "2362",
          "text": "西南中沙群岛办事处",
          "children": [
            {
              "value": "2362",
              "text": "西南中沙群岛办事处"
            }
          ]
        },
        {
          "value": "2363",
          "text": "海口市",
          "children": [
            {
              "value": "2364",
              "text": "龙华区"
            },
            {
              "value": "2365",
              "text": "秀英区"
            },
            {
              "value": "2366",
              "text": "琼山区"
            },
            {
              "value": "2367",
              "text": "美兰区"
            }
          ]
        },
        {
          "value": "2368",
          "text": "三亚市",
          "children": [
            {
              "value": "2369",
              "text": "海棠区"
            },
            {
              "value": "3654",
              "text": "吉阳区"
            },
            {
              "value": "3655",
              "text": "天涯区"
            },
            {
              "value": "3656",
              "text": "崖州区"
            }
          ]
        },
        {
          "value": "3657",
          "text": "三沙市",
          "children": [
            {
              "value": "4053",
              "text": "中沙群岛"
            },
            {
              "value": "4055",
              "text": "西沙群岛"
            },
            {
              "value": "4059",
              "text": "南沙群岛"
            }
          ]
        }
      ]
    },
    {
      "value": "2370",
      "text": "重庆市",
      "children": [
        {
          "value": "2371",
          "text": "万州区",
          "children": [
            {
              "value": "2371",
              "text": "万州区"
            }
          ]
        },
        {
          "value": "2372",
          "text": "涪陵区",
          "children": [
            {
              "value": "2372",
              "text": "涪陵区"
            }
          ]
        },
        {
          "value": "2373",
          "text": "渝中区",
          "children": [
            {
              "value": "2373",
              "text": "渝中区"
            }
          ]
        },
        {
          "value": "2374",
          "text": "大渡口区",
          "children": [
            {
              "value": "2374",
              "text": "大渡口区"
            }
          ]
        },
        {
          "value": "2375",
          "text": "江北区",
          "children": [
            {
              "value": "2375",
              "text": "江北区"
            }
          ]
        },
        {
          "value": "2376",
          "text": "沙坪坝区",
          "children": [
            {
              "value": "2376",
              "text": "沙坪坝区"
            }
          ]
        },
        {
          "value": "2377",
          "text": "九龙坡区",
          "children": [
            {
              "value": "2377",
              "text": "九龙坡区"
            }
          ]
        },
        {
          "value": "2378",
          "text": "南岸区",
          "children": [
            {
              "value": "2378",
              "text": "南岸区"
            }
          ]
        },
        {
          "value": "2379",
          "text": "北碚区",
          "children": [
            {
              "value": "2379",
              "text": "北碚区"
            }
          ]
        },
        {
          "value": "2380",
          "text": "万盛区",
          "children": [
            {
              "value": "2380",
              "text": "万盛区"
            }
          ]
        },
        {
          "value": "2381",
          "text": "双桥区",
          "children": [
            {
              "value": "2381",
              "text": "双桥区"
            }
          ]
        },
        {
          "value": "2382",
          "text": "渝北区",
          "children": [
            {
              "value": "2382",
              "text": "渝北区"
            }
          ]
        },
        {
          "value": "2383",
          "text": "巴南区",
          "children": [
            {
              "value": "2383",
              "text": "巴南区"
            }
          ]
        },
        {
          "value": "2384",
          "text": "长寿县",
          "children": [
            {
              "value": "2384",
              "text": "长寿县"
            }
          ]
        },
        {
          "value": "2385",
          "text": "綦江县",
          "children": [
            {
              "value": "2385",
              "text": "綦江县"
            }
          ]
        },
        {
          "value": "2386",
          "text": "潼南县",
          "children": [
            {
              "value": "2386",
              "text": "潼南县"
            }
          ]
        },
        {
          "value": "2387",
          "text": "铜梁县",
          "children": [
            {
              "value": "2387",
              "text": "铜梁县"
            }
          ]
        },
        {
          "value": "2388",
          "text": "大足县",
          "children": [
            {
              "value": "2388",
              "text": "大足县"
            }
          ]
        },
        {
          "value": "2389",
          "text": "荣昌县",
          "children": [
            {
              "value": "2389",
              "text": "荣昌县"
            }
          ]
        },
        {
          "value": "2390",
          "text": "璧山县",
          "children": [
            {
              "value": "2390",
              "text": "璧山县"
            }
          ]
        },
        {
          "value": "2391",
          "text": "梁平县",
          "children": [
            {
              "value": "2391",
              "text": "梁平县"
            }
          ]
        },
        {
          "value": "2392",
          "text": "城口县",
          "children": [
            {
              "value": "2392",
              "text": "城口县"
            }
          ]
        },
        {
          "value": "2393",
          "text": "丰都县",
          "children": [
            {
              "value": "2393",
              "text": "丰都县"
            }
          ]
        },
        {
          "value": "2394",
          "text": "垫江县",
          "children": [
            {
              "value": "2394",
              "text": "垫江县"
            }
          ]
        },
        {
          "value": "2395",
          "text": "武隆县",
          "children": [
            {
              "value": "2395",
              "text": "武隆县"
            }
          ]
        },
        {
          "value": "2396",
          "text": "忠县",
          "children": [
            {
              "value": "2396",
              "text": "忠县"
            }
          ]
        },
        {
          "value": "2397",
          "text": "开县",
          "children": [
            {
              "value": "2397",
              "text": "开县"
            }
          ]
        },
        {
          "value": "2398",
          "text": "云阳县",
          "children": [
            {
              "value": "2398",
              "text": "云阳县"
            }
          ]
        },
        {
          "value": "2399",
          "text": "奉节县",
          "children": [
            {
              "value": "2399",
              "text": "奉节县"
            }
          ]
        },
        {
          "value": "2400",
          "text": "巫山县",
          "children": [
            {
              "value": "2400",
              "text": "巫山县"
            }
          ]
        },
        {
          "value": "2401",
          "text": "巫溪县",
          "children": [
            {
              "value": "2401",
              "text": "巫溪县"
            }
          ]
        },
        {
          "value": "2402",
          "text": "黔江土家族苗族自治县",
          "children": [
            {
              "value": "2402",
              "text": "黔江土家族苗族自治县"
            }
          ]
        },
        {
          "value": "2403",
          "text": "石柱土家族自治县",
          "children": [
            {
              "value": "2403",
              "text": "石柱土家族自治县"
            }
          ]
        },
        {
          "value": "2404",
          "text": "秀山土家族苗族自治县",
          "children": [
            {
              "value": "2404",
              "text": "秀山土家族苗族自治县"
            }
          ]
        },
        {
          "value": "2405",
          "text": "酉阳土家族苗族自治县",
          "children": [
            {
              "value": "2405",
              "text": "酉阳土家族苗族自治县"
            }
          ]
        },
        {
          "value": "2406",
          "text": "彭水苗族土家族自治县",
          "children": [
            {
              "value": "2406",
              "text": "彭水苗族土家族自治县"
            }
          ]
        },
        {
          "value": "2407",
          "text": "江津市",
          "children": [
            {
              "value": "2407",
              "text": "江津市"
            }
          ]
        },
        {
          "value": "2408",
          "text": "合川市",
          "children": [
            {
              "value": "2408",
              "text": "合川市"
            }
          ]
        },
        {
          "value": "2409",
          "text": "永川市",
          "children": [
            {
              "value": "2409",
              "text": "永川市"
            }
          ]
        },
        {
          "value": "2410",
          "text": "南川市",
          "children": [
            {
              "value": "2410",
              "text": "南川市"
            }
          ]
        },
        {
          "value": "4118",
          "text": "北部新区",
          "children": [
            {
              "value": "4118",
              "text": "北部新区"
            }
          ]
        },
        {
          "value": "4121",
          "text": "高新区",
          "children": [
            {
              "value": "4121",
              "text": "高新区"
            }
          ]
        },
        {
          "value": "4124",
          "text": "北部新区",
          "children": [
            {
              "value": "4124",
              "text": "北部新区"
            }
          ]
        }
      ]
    },
    {
      "value": "2411",
      "text": "四川省",
      "children": [
        {
          "value": "2412",
          "text": "成都市",
          "children": [
            {
              "value": "2413",
              "text": "锦江区"
            },
            {
              "value": "2414",
              "text": "青羊区"
            },
            {
              "value": "2415",
              "text": "金牛区"
            },
            {
              "value": "2416",
              "text": "武侯区"
            },
            {
              "value": "2417",
              "text": "成华区"
            },
            {
              "value": "2418",
              "text": "龙泉驿区"
            },
            {
              "value": "2419",
              "text": "青白江区"
            },
            {
              "value": "2420",
              "text": "金堂县"
            },
            {
              "value": "2421",
              "text": "双流区"
            },
            {
              "value": "2422",
              "text": "温江区"
            },
            {
              "value": "2423",
              "text": "郫都区"
            },
            {
              "value": "2424",
              "text": "新都区"
            },
            {
              "value": "2425",
              "text": "大邑县"
            },
            {
              "value": "2426",
              "text": "蒲江县"
            },
            {
              "value": "2427",
              "text": "新津县"
            },
            {
              "value": "2428",
              "text": "都江堰市"
            },
            {
              "value": "2429",
              "text": "彭州市"
            },
            {
              "value": "2430",
              "text": "邛崃市"
            },
            {
              "value": "2431",
              "text": "崇州市"
            },
            {
              "value": "3638",
              "text": "简阳市"
            },
            {
              "value": "4099",
              "text": "高新西区"
            },
            {
              "value": "4103",
              "text": "高新区"
            },
            {
              "value": "4111",
              "text": "城口县"
            }
          ]
        },
        {
          "value": "2432",
          "text": "自贡市",
          "children": [
            {
              "value": "2433",
              "text": "自流井区"
            },
            {
              "value": "2434",
              "text": "贡井区"
            },
            {
              "value": "2435",
              "text": "大安区"
            },
            {
              "value": "2436",
              "text": "沿滩区"
            },
            {
              "value": "2437",
              "text": "荣县"
            },
            {
              "value": "2438",
              "text": "富顺县"
            }
          ]
        },
        {
          "value": "2439",
          "text": "攀枝花市",
          "children": [
            {
              "value": "2440",
              "text": "东区"
            },
            {
              "value": "2441",
              "text": "西区"
            },
            {
              "value": "2442",
              "text": "仁和区"
            },
            {
              "value": "2443",
              "text": "米易县"
            },
            {
              "value": "2444",
              "text": "盐边县"
            }
          ]
        },
        {
          "value": "2445",
          "text": "泸州市",
          "children": [
            {
              "value": "2446",
              "text": "江阳区"
            },
            {
              "value": "2447",
              "text": "纳溪区"
            },
            {
              "value": "2448",
              "text": "龙马潭区"
            },
            {
              "value": "2449",
              "text": "泸县"
            },
            {
              "value": "2450",
              "text": "合江县"
            },
            {
              "value": "2451",
              "text": "叙永县"
            },
            {
              "value": "2452",
              "text": "古蔺县"
            }
          ]
        },
        {
          "value": "2453",
          "text": "德阳市",
          "children": [
            {
              "value": "2454",
              "text": "旌阳区"
            },
            {
              "value": "2455",
              "text": "中江县"
            },
            {
              "value": "2456",
              "text": "罗江县"
            },
            {
              "value": "2457",
              "text": "广汉市"
            },
            {
              "value": "2458",
              "text": "什邡市"
            },
            {
              "value": "2459",
              "text": "绵竹市"
            }
          ]
        },
        {
          "value": "2460",
          "text": "绵阳市",
          "children": [
            {
              "value": "2461",
              "text": "涪城区"
            },
            {
              "value": "2462",
              "text": "游仙区"
            },
            {
              "value": "2463",
              "text": "三台县"
            },
            {
              "value": "2464",
              "text": "盐亭县"
            },
            {
              "value": "2465",
              "text": "安州区"
            },
            {
              "value": "2466",
              "text": "梓潼县"
            },
            {
              "value": "2467",
              "text": "北川县"
            },
            {
              "value": "2468",
              "text": "平武县"
            },
            {
              "value": "2469",
              "text": "江油市"
            },
            {
              "value": "3689",
              "text": "高新区"
            },
            {
              "value": "4093",
              "text": "经开区"
            }
          ]
        },
        {
          "value": "2470",
          "text": "广元市",
          "children": [
            {
              "value": "2471",
              "text": "利州区"
            },
            {
              "value": "2472",
              "text": "昭化区"
            },
            {
              "value": "2473",
              "text": "朝天区"
            },
            {
              "value": "2474",
              "text": "旺苍县"
            },
            {
              "value": "2475",
              "text": "青川县"
            },
            {
              "value": "2476",
              "text": "剑阁县"
            },
            {
              "value": "2477",
              "text": "苍溪县"
            }
          ]
        },
        {
          "value": "2478",
          "text": "遂宁市",
          "children": [
            {
              "value": "2479",
              "text": "船山区"
            },
            {
              "value": "2480",
              "text": "安居区"
            },
            {
              "value": "2481",
              "text": "蓬溪县"
            },
            {
              "value": "2482",
              "text": "射洪县"
            },
            {
              "value": "2483",
              "text": "大英县"
            }
          ]
        },
        {
          "value": "2484",
          "text": "内江市",
          "children": [
            {
              "value": "2485",
              "text": "市中区"
            },
            {
              "value": "2486",
              "text": "东兴区"
            },
            {
              "value": "2487",
              "text": "威远县"
            },
            {
              "value": "2488",
              "text": "资中县"
            },
            {
              "value": "2489",
              "text": "隆昌县"
            }
          ]
        },
        {
          "value": "2490",
          "text": "乐山市",
          "children": [
            {
              "value": "2491",
              "text": "市中区"
            },
            {
              "value": "2492",
              "text": "沙湾区"
            },
            {
              "value": "2493",
              "text": "五通桥区"
            },
            {
              "value": "2494",
              "text": "金口河区"
            },
            {
              "value": "2495",
              "text": "犍为县"
            },
            {
              "value": "2496",
              "text": "井研县"
            },
            {
              "value": "2497",
              "text": "夹江县"
            },
            {
              "value": "2498",
              "text": "沐川县"
            },
            {
              "value": "2499",
              "text": "峨边县"
            },
            {
              "value": "2500",
              "text": "马边县"
            },
            {
              "value": "2501",
              "text": "峨眉山市"
            }
          ]
        },
        {
          "value": "2502",
          "text": "南充市",
          "children": [
            {
              "value": "2503",
              "text": "顺庆区"
            },
            {
              "value": "2504",
              "text": "高坪区"
            },
            {
              "value": "2505",
              "text": "嘉陵区"
            },
            {
              "value": "2506",
              "text": "南部县"
            },
            {
              "value": "2507",
              "text": "营山县"
            },
            {
              "value": "2508",
              "text": "蓬安县"
            },
            {
              "value": "2509",
              "text": "仪陇县"
            },
            {
              "value": "2510",
              "text": "西充县"
            },
            {
              "value": "2511",
              "text": "阆中市"
            }
          ]
        },
        {
          "value": "2512",
          "text": "宜宾市",
          "children": [
            {
              "value": "2513",
              "text": "翠屏区"
            },
            {
              "value": "2514",
              "text": "宜宾县"
            },
            {
              "value": "2515",
              "text": "南溪区"
            },
            {
              "value": "2516",
              "text": "江安县"
            },
            {
              "value": "2517",
              "text": "长宁县"
            },
            {
              "value": "2518",
              "text": "高县"
            },
            {
              "value": "2519",
              "text": "珙县"
            },
            {
              "value": "2520",
              "text": "筠连县"
            },
            {
              "value": "2521",
              "text": "兴文县"
            },
            {
              "value": "2522",
              "text": "屏山县"
            }
          ]
        },
        {
          "value": "2523",
          "text": "广安市",
          "children": [
            {
              "value": "2524",
              "text": "广安区"
            },
            {
              "value": "2525",
              "text": "岳池县"
            },
            {
              "value": "2526",
              "text": "武胜县"
            },
            {
              "value": "2527",
              "text": "邻水县"
            },
            {
              "value": "2528",
              "text": "华蓥市"
            },
            {
              "value": "3658",
              "text": "前锋区"
            }
          ]
        },
        {
          "value": "2529",
          "text": "达州市",
          "children": [
            {
              "value": "2530",
              "text": "通川区"
            },
            {
              "value": "2531",
              "text": "万源市"
            },
            {
              "value": "2532",
              "text": "达川区"
            },
            {
              "value": "2533",
              "text": "宣汉县"
            },
            {
              "value": "2534",
              "text": "开江县"
            },
            {
              "value": "2535",
              "text": "大竹县"
            },
            {
              "value": "2536",
              "text": "渠县"
            }
          ]
        },
        {
          "value": "2537",
          "text": "雅安市",
          "children": [
            {
              "value": "2538",
              "text": "雨城区"
            },
            {
              "value": "2539",
              "text": "名山区"
            },
            {
              "value": "2540",
              "text": "荥经县"
            },
            {
              "value": "2541",
              "text": "汉源县"
            },
            {
              "value": "2542",
              "text": "石棉县"
            },
            {
              "value": "2543",
              "text": "天全县"
            },
            {
              "value": "2544",
              "text": "芦山县"
            },
            {
              "value": "2545",
              "text": "宝兴县"
            }
          ]
        },
        {
          "value": "2546",
          "text": "阿坝藏族羌族自治州",
          "children": [
            {
              "value": "2547",
              "text": "汶川县"
            },
            {
              "value": "2548",
              "text": "理县"
            },
            {
              "value": "2549",
              "text": "茂县"
            },
            {
              "value": "2550",
              "text": "松潘县"
            },
            {
              "value": "2551",
              "text": "九寨沟县"
            },
            {
              "value": "2552",
              "text": "金川县"
            },
            {
              "value": "2553",
              "text": "小金县"
            },
            {
              "value": "2554",
              "text": "黑水县"
            },
            {
              "value": "2555",
              "text": "马尔康县"
            },
            {
              "value": "2556",
              "text": "壤塘县"
            },
            {
              "value": "2557",
              "text": "阿坝县"
            },
            {
              "value": "2558",
              "text": "若尔盖县"
            },
            {
              "value": "2559",
              "text": "红原县"
            }
          ]
        },
        {
          "value": "2560",
          "text": "甘孜藏族自治州",
          "children": [
            {
              "value": "2561",
              "text": "康定市"
            },
            {
              "value": "2562",
              "text": "泸定县"
            },
            {
              "value": "2563",
              "text": "丹巴县"
            },
            {
              "value": "2564",
              "text": "九龙县"
            },
            {
              "value": "2565",
              "text": "雅江县"
            },
            {
              "value": "2566",
              "text": "道孚县"
            },
            {
              "value": "2567",
              "text": "炉霍县"
            },
            {
              "value": "2568",
              "text": "甘孜县"
            },
            {
              "value": "2569",
              "text": "新龙县"
            },
            {
              "value": "2570",
              "text": "德格县"
            },
            {
              "value": "2571",
              "text": "白玉县"
            },
            {
              "value": "2572",
              "text": "石渠县"
            },
            {
              "value": "2573",
              "text": "色达县"
            },
            {
              "value": "2574",
              "text": "理塘县"
            },
            {
              "value": "2575",
              "text": "巴塘县"
            },
            {
              "value": "2576",
              "text": "乡城县"
            },
            {
              "value": "2577",
              "text": "稻城县"
            },
            {
              "value": "2578",
              "text": "得荣县"
            }
          ]
        },
        {
          "value": "2579",
          "text": "凉山彝族自治州",
          "children": [
            {
              "value": "2580",
              "text": "西昌市"
            },
            {
              "value": "2581",
              "text": "木里县"
            },
            {
              "value": "2582",
              "text": "盐源县"
            },
            {
              "value": "2583",
              "text": "德昌县"
            },
            {
              "value": "2584",
              "text": "会理县"
            },
            {
              "value": "2585",
              "text": "会东县"
            },
            {
              "value": "2586",
              "text": "宁南县"
            },
            {
              "value": "2587",
              "text": "普格县"
            },
            {
              "value": "2588",
              "text": "布拖县"
            },
            {
              "value": "2589",
              "text": "金阳县"
            },
            {
              "value": "2590",
              "text": "昭觉县"
            },
            {
              "value": "2591",
              "text": "喜德县"
            },
            {
              "value": "2592",
              "text": "冕宁县"
            },
            {
              "value": "2593",
              "text": "越西县"
            },
            {
              "value": "2594",
              "text": "甘洛县"
            },
            {
              "value": "2595",
              "text": "美姑县"
            },
            {
              "value": "2596",
              "text": "雷波县"
            }
          ]
        },
        {
          "value": "2597",
          "text": "巴中市",
          "children": [
            {
              "value": "2598",
              "text": "巴州区"
            },
            {
              "value": "2599",
              "text": "通江县"
            },
            {
              "value": "2600",
              "text": "南江县"
            },
            {
              "value": "2601",
              "text": "平昌县"
            },
            {
              "value": "3659",
              "text": "恩阳区"
            }
          ]
        },
        {
          "value": "2602",
          "text": "眉山地区",
          "children": [
            {
              "value": "2603",
              "text": "眉山市"
            },
            {
              "value": "2604",
              "text": "仁寿县"
            },
            {
              "value": "2605",
              "text": "彭山区"
            },
            {
              "value": "2606",
              "text": "洪雅县"
            },
            {
              "value": "2607",
              "text": "丹棱县"
            },
            {
              "value": "2608",
              "text": "青神县"
            },
            {
              "value": "3410",
              "text": "东坡区"
            }
          ]
        },
        {
          "value": "2609",
          "text": "资阳地区",
          "children": [
            {
              "value": "2610",
              "text": "资阳市"
            },
            {
              "value": "2611",
              "text": "简阳市"
            },
            {
              "value": "2612",
              "text": "安岳县"
            },
            {
              "value": "2613",
              "text": "乐至县"
            },
            {
              "value": "3413",
              "text": "雁江区"
            }
          ]
        }
      ]
    },
    {
      "value": "2614",
      "text": "贵州省",
      "children": [
        {
          "value": "2615",
          "text": "贵阳市",
          "children": [
            {
              "value": "2616",
              "text": "南明区"
            },
            {
              "value": "2617",
              "text": "云岩区"
            },
            {
              "value": "2618",
              "text": "花溪区"
            },
            {
              "value": "2619",
              "text": "乌当区"
            },
            {
              "value": "2620",
              "text": "白云区"
            },
            {
              "value": "2621",
              "text": "观山湖区"
            },
            {
              "value": "2622",
              "text": "开阳县"
            },
            {
              "value": "2623",
              "text": "息烽县"
            },
            {
              "value": "2624",
              "text": "修文县"
            },
            {
              "value": "2625",
              "text": "清镇市"
            },
            {
              "value": "3698",
              "text": "市辖区"
            },
            {
              "value": "4077",
              "text": "小河区"
            }
          ]
        },
        {
          "value": "2626",
          "text": "六盘水市",
          "children": [
            {
              "value": "2627",
              "text": "钟山区"
            },
            {
              "value": "2628",
              "text": "盘县特区"
            },
            {
              "value": "2629",
              "text": "六枝特区"
            },
            {
              "value": "2630",
              "text": "水城县"
            }
          ]
        },
        {
          "value": "2631",
          "text": "遵义市",
          "children": [
            {
              "value": "2632",
              "text": "红花岗区"
            },
            {
              "value": "2633",
              "text": "汇川区"
            },
            {
              "value": "2634",
              "text": "遵义县"
            },
            {
              "value": "2635",
              "text": "桐梓县"
            },
            {
              "value": "2636",
              "text": "绥阳县"
            },
            {
              "value": "2637",
              "text": "正安县"
            },
            {
              "value": "2638",
              "text": "道真仡佬族苗族自治县"
            },
            {
              "value": "2639",
              "text": "务川仡佬族苗族自治县"
            },
            {
              "value": "2640",
              "text": "凤冈县"
            },
            {
              "value": "2641",
              "text": "湄潭县"
            },
            {
              "value": "2642",
              "text": "余庆县"
            },
            {
              "value": "2643",
              "text": "习水县"
            },
            {
              "value": "2644",
              "text": "赤水市"
            },
            {
              "value": "2645",
              "text": "仁怀市"
            },
            {
              "value": "4074",
              "text": "播州区"
            }
          ]
        },
        {
          "value": "2646",
          "text": "铜仁地区",
          "children": [
            {
              "value": "2647",
              "text": "碧江区"
            },
            {
              "value": "2648",
              "text": "江口县"
            },
            {
              "value": "2649",
              "text": "玉屏侗族自治县"
            },
            {
              "value": "2650",
              "text": "石阡县"
            },
            {
              "value": "2651",
              "text": "思南县"
            },
            {
              "value": "2652",
              "text": "印江土家族苗族自治县"
            },
            {
              "value": "2653",
              "text": "德江县"
            },
            {
              "value": "2654",
              "text": "沿河土家族自治县"
            },
            {
              "value": "2655",
              "text": "松桃苗族自治县"
            },
            {
              "value": "2656",
              "text": "万山区"
            }
          ]
        },
        {
          "value": "2657",
          "text": "黔西南布依族苗族自治州",
          "children": [
            {
              "value": "2658",
              "text": "兴义市"
            },
            {
              "value": "2659",
              "text": "兴仁县"
            },
            {
              "value": "2660",
              "text": "普安县"
            },
            {
              "value": "2661",
              "text": "晴隆县"
            },
            {
              "value": "2662",
              "text": "贞丰县"
            },
            {
              "value": "2663",
              "text": "望谟县"
            },
            {
              "value": "2664",
              "text": "册亨县"
            },
            {
              "value": "2665",
              "text": "安龙县"
            }
          ]
        },
        {
          "value": "2666",
          "text": "毕节市",
          "children": [
            {
              "value": "2667",
              "text": "七星关区"
            },
            {
              "value": "2668",
              "text": "大方县"
            },
            {
              "value": "2669",
              "text": "黔西县"
            },
            {
              "value": "2670",
              "text": "金沙县"
            },
            {
              "value": "2671",
              "text": "织金县"
            },
            {
              "value": "2672",
              "text": "纳雍县"
            },
            {
              "value": "2673",
              "text": "威宁彝族回族苗族自治县"
            },
            {
              "value": "2674",
              "text": "赫章县"
            }
          ]
        },
        {
          "value": "2675",
          "text": "安顺市",
          "children": [
            {
              "value": "2676",
              "text": "西秀区"
            },
            {
              "value": "2677",
              "text": "平坝县"
            },
            {
              "value": "2678",
              "text": "普定县"
            },
            {
              "value": "2679",
              "text": "关岭布依族苗族自治县"
            },
            {
              "value": "2680",
              "text": "镇宁布依族苗族自治县"
            },
            {
              "value": "2681",
              "text": "紫云苗族布依族自治县"
            }
          ]
        },
        {
          "value": "2682",
          "text": "黔东南苗族侗族自治州",
          "children": [
            {
              "value": "2683",
              "text": "凯里市"
            },
            {
              "value": "2684",
              "text": "黄平县"
            },
            {
              "value": "2685",
              "text": "施秉县"
            },
            {
              "value": "2686",
              "text": "三穗县"
            },
            {
              "value": "2687",
              "text": "镇远县"
            },
            {
              "value": "2688",
              "text": "岑巩县"
            },
            {
              "value": "2689",
              "text": "天柱县"
            },
            {
              "value": "2690",
              "text": "锦屏县"
            },
            {
              "value": "2691",
              "text": "剑河县"
            },
            {
              "value": "2692",
              "text": "台江县"
            },
            {
              "value": "2693",
              "text": "黎平县"
            },
            {
              "value": "2694",
              "text": "榕江县"
            },
            {
              "value": "2695",
              "text": "从江县"
            },
            {
              "value": "2696",
              "text": "雷山县"
            },
            {
              "value": "2697",
              "text": "麻江县"
            },
            {
              "value": "2698",
              "text": "丹寨县"
            }
          ]
        },
        {
          "value": "2699",
          "text": "黔南布依族苗族自治州",
          "children": [
            {
              "value": "2700",
              "text": "都匀市"
            },
            {
              "value": "2701",
              "text": "福泉市"
            },
            {
              "value": "2702",
              "text": "荔波县"
            },
            {
              "value": "2703",
              "text": "贵定县"
            },
            {
              "value": "2704",
              "text": "瓮安县"
            },
            {
              "value": "2705",
              "text": "独山县"
            },
            {
              "value": "2706",
              "text": "平塘县"
            },
            {
              "value": "2707",
              "text": "罗甸县"
            },
            {
              "value": "2708",
              "text": "长顺县"
            },
            {
              "value": "2709",
              "text": "龙里县"
            },
            {
              "value": "2710",
              "text": "惠水县"
            },
            {
              "value": "2711",
              "text": "三都水族自治县"
            }
          ]
        }
      ]
    },
    {
      "value": "2712",
      "text": "云南省",
      "children": [
        {
          "value": "2713",
          "text": "昆明市",
          "children": [
            {
              "value": "2714",
              "text": "五华区"
            },
            {
              "value": "2715",
              "text": "盘龙区"
            },
            {
              "value": "2716",
              "text": "官渡区"
            },
            {
              "value": "2717",
              "text": "西山区"
            },
            {
              "value": "2718",
              "text": "东川区"
            },
            {
              "value": "2719",
              "text": "呈贡县"
            },
            {
              "value": "2720",
              "text": "晋宁区"
            },
            {
              "value": "2721",
              "text": "富民县"
            },
            {
              "value": "2722",
              "text": "宜良县"
            },
            {
              "value": "2723",
              "text": "石林县"
            },
            {
              "value": "2724",
              "text": "嵩明县"
            },
            {
              "value": "2725",
              "text": "禄劝县"
            },
            {
              "value": "2726",
              "text": "寻甸县"
            },
            {
              "value": "2727",
              "text": "安宁市"
            }
          ]
        },
        {
          "value": "2728",
          "text": "曲靖市",
          "children": [
            {
              "value": "2729",
              "text": "麒麟区"
            },
            {
              "value": "2730",
              "text": "马龙县"
            },
            {
              "value": "2731",
              "text": "陆良县"
            },
            {
              "value": "2732",
              "text": "师宗县"
            },
            {
              "value": "2733",
              "text": "罗平县"
            },
            {
              "value": "2734",
              "text": "富源县"
            },
            {
              "value": "2735",
              "text": "会泽县"
            },
            {
              "value": "2736",
              "text": "沾益县"
            },
            {
              "value": "2737",
              "text": "宣威市"
            }
          ]
        },
        {
          "value": "2738",
          "text": "玉溪市",
          "children": [
            {
              "value": "2739",
              "text": "红塔区"
            },
            {
              "value": "2740",
              "text": "江川区"
            },
            {
              "value": "2741",
              "text": "澄江县"
            },
            {
              "value": "2742",
              "text": "通海县"
            },
            {
              "value": "2743",
              "text": "华宁县"
            },
            {
              "value": "2744",
              "text": "易门县"
            },
            {
              "value": "2745",
              "text": "峨山县"
            },
            {
              "value": "2746",
              "text": "新平县"
            },
            {
              "value": "2747",
              "text": "元江县"
            }
          ]
        },
        {
          "value": "2748",
          "text": "昭通市",
          "children": [
            {
              "value": "2749",
              "text": "昭阳区"
            },
            {
              "value": "2750",
              "text": "鲁甸县"
            },
            {
              "value": "2751",
              "text": "巧家县"
            },
            {
              "value": "2752",
              "text": "盐津县"
            },
            {
              "value": "2753",
              "text": "大关县"
            },
            {
              "value": "2754",
              "text": "永善县"
            },
            {
              "value": "2755",
              "text": "绥江县"
            },
            {
              "value": "2756",
              "text": "镇雄县"
            },
            {
              "value": "2757",
              "text": "彝良县"
            },
            {
              "value": "2758",
              "text": "威信县"
            },
            {
              "value": "2759",
              "text": "水富县"
            }
          ]
        },
        {
          "value": "2760",
          "text": "楚雄彝族自治州",
          "children": [
            {
              "value": "2761",
              "text": "楚雄市"
            },
            {
              "value": "2762",
              "text": "双柏县"
            },
            {
              "value": "2763",
              "text": "牟定县"
            },
            {
              "value": "2764",
              "text": "南华县"
            },
            {
              "value": "2765",
              "text": "姚安县"
            },
            {
              "value": "2766",
              "text": "大姚县"
            },
            {
              "value": "2767",
              "text": "永仁县"
            },
            {
              "value": "2768",
              "text": "元谋县"
            },
            {
              "value": "2769",
              "text": "武定县"
            },
            {
              "value": "2770",
              "text": "禄丰县"
            }
          ]
        },
        {
          "value": "2771",
          "text": "红河哈尼族彝族自治州",
          "children": [
            {
              "value": "2772",
              "text": "个旧市"
            },
            {
              "value": "2773",
              "text": "开远市"
            },
            {
              "value": "2774",
              "text": "蒙自县"
            },
            {
              "value": "2775",
              "text": "屏边县"
            },
            {
              "value": "2776",
              "text": "建水县"
            },
            {
              "value": "2777",
              "text": "石屏县"
            },
            {
              "value": "2778",
              "text": "弥勒市"
            },
            {
              "value": "2779",
              "text": "泸西县"
            },
            {
              "value": "2780",
              "text": "元阳县"
            },
            {
              "value": "2781",
              "text": "红河县"
            },
            {
              "value": "2782",
              "text": "金平县"
            },
            {
              "value": "2783",
              "text": "绿春县"
            },
            {
              "value": "2784",
              "text": "河口县"
            }
          ]
        },
        {
          "value": "2785",
          "text": "文山壮族苗族自治州",
          "children": [
            {
              "value": "2786",
              "text": "文山县"
            },
            {
              "value": "2787",
              "text": "砚山县"
            },
            {
              "value": "2788",
              "text": "西畴县"
            },
            {
              "value": "2789",
              "text": "麻栗坡县"
            },
            {
              "value": "2790",
              "text": "马关县"
            },
            {
              "value": "2791",
              "text": "丘北县"
            },
            {
              "value": "2792",
              "text": "广南县"
            },
            {
              "value": "2793",
              "text": "富宁县"
            }
          ]
        },
        {
          "value": "2794",
          "text": "普洱市",
          "children": [
            {
              "value": "2795",
              "text": "思茅区"
            },
            {
              "value": "2796",
              "text": "普洱哈尼族彝族自治县"
            },
            {
              "value": "2797",
              "text": "墨江县"
            },
            {
              "value": "2798",
              "text": "景东县"
            },
            {
              "value": "2799",
              "text": "景谷县"
            },
            {
              "value": "2800",
              "text": "镇沅县"
            },
            {
              "value": "2801",
              "text": "江城县"
            },
            {
              "value": "2802",
              "text": "孟连县"
            },
            {
              "value": "2803",
              "text": "澜沧县"
            },
            {
              "value": "2804",
              "text": "西盟县"
            },
            {
              "value": "3661",
              "text": "宁洱县"
            }
          ]
        },
        {
          "value": "2805",
          "text": "西双版纳傣族自治州",
          "children": [
            {
              "value": "2806",
              "text": "景洪市"
            },
            {
              "value": "2807",
              "text": "勐海县"
            },
            {
              "value": "2808",
              "text": "勐腊县"
            }
          ]
        },
        {
          "value": "2809",
          "text": "大理白族自治州",
          "children": [
            {
              "value": "2810",
              "text": "大理市"
            },
            {
              "value": "2811",
              "text": "祥云县"
            },
            {
              "value": "2812",
              "text": "祥云县"
            },
            {
              "value": "2813",
              "text": "宾川县"
            },
            {
              "value": "2814",
              "text": "弥渡县"
            },
            {
              "value": "2815",
              "text": "南涧县"
            },
            {
              "value": "2816",
              "text": "巍山县"
            },
            {
              "value": "2817",
              "text": "永平县"
            },
            {
              "value": "2818",
              "text": "云龙县"
            },
            {
              "value": "2819",
              "text": "洱源县"
            },
            {
              "value": "2820",
              "text": "剑川县"
            },
            {
              "value": "2821",
              "text": "鹤庆县"
            },
			{
              "value": "4208",
              "text": "漾濞彝族自治县"
            }
          ]
        },
        {
          "value": "2822",
          "text": "保山市",
          "children": [
            {
              "value": "2823",
              "text": "隆阳区"
            },
            {
              "value": "2824",
              "text": "施甸县"
            },
            {
              "value": "2825",
              "text": "腾冲市"
            },
            {
              "value": "2826",
              "text": "龙陵县"
            },
            {
              "value": "2827",
              "text": "昌宁县"
            }
          ]
        },
        {
          "value": "2828",
          "text": "德宏傣族景颇族自治州",
          "children": [
            {
              "value": "2829",
              "text": "畹町市"
            },
            {
              "value": "2830",
              "text": "瑞丽市"
            },
            {
              "value": "2831",
              "text": "芒市"
            },
            {
              "value": "2832",
              "text": "梁河县"
            },
            {
              "value": "2833",
              "text": "盈江县"
            },
            {
              "value": "2834",
              "text": "陇川县"
            }
          ]
        },
        {
          "value": "2835",
          "text": "丽江市",
          "children": [
            {
              "value": "2836",
              "text": "玉龙县"
            },
            {
              "value": "2837",
              "text": "永胜县"
            },
            {
              "value": "2838",
              "text": "华坪县"
            },
            {
              "value": "2839",
              "text": "宁蒗县"
            },
            {
              "value": "3660",
              "text": "古城区"
            }
          ]
        },
        {
          "value": "2840",
          "text": "怒江傈僳族自治州",
          "children": [
            {
              "value": "2841",
              "text": "泸水县"
            },
            {
              "value": "2842",
              "text": "福贡县"
            },
            {
              "value": "2843",
              "text": "贡山县"
            },
            {
              "value": "2844",
              "text": "兰坪县"
            }
          ]
        },
        {
          "value": "2845",
          "text": "迪庆藏族自治州",
          "children": [
            {
              "value": "2846",
              "text": "香格里拉"
            },
            {
              "value": "2847",
              "text": "德钦县"
            },
            {
              "value": "2848",
              "text": "维西县"
            }
          ]
        },
        {
          "value": "2849",
          "text": "临沧市",
          "children": [
            {
              "value": "2850",
              "text": "临翔区"
            },
            {
              "value": "2851",
              "text": "凤庆县"
            },
            {
              "value": "2852",
              "text": "云县"
            },
            {
              "value": "2853",
              "text": "永德县"
            },
            {
              "value": "2854",
              "text": "镇康县"
            },
            {
              "value": "2855",
              "text": "双江县"
            },
            {
              "value": "2856",
              "text": "耿马县"
            },
            {
              "value": "2857",
              "text": "沧源县"
            }
          ]
        }
      ]
    },
    {
      "value": "2858",
      "text": "西藏",
      "children": [
        {
          "value": "2859",
          "text": "拉萨市",
          "children": [
            {
              "value": "2860",
              "text": "城关区"
            },
            {
              "value": "2861",
              "text": "林周县"
            },
            {
              "value": "2862",
              "text": "当雄县"
            },
            {
              "value": "2863",
              "text": "尼木县"
            },
            {
              "value": "2864",
              "text": "曲水县"
            },
            {
              "value": "2865",
              "text": "堆龙德庆县"
            },
            {
              "value": "2866",
              "text": "达孜县"
            },
            {
              "value": "2867",
              "text": "墨竹工卡县"
            }
          ]
        },
        {
          "value": "2868",
          "text": "昌都地区",
          "children": [
            {
              "value": "2869",
              "text": "卡若区"
            },
            {
              "value": "2870",
              "text": "江达县"
            },
            {
              "value": "2871",
              "text": "贡觉县"
            },
            {
              "value": "2872",
              "text": "类乌齐县"
            },
            {
              "value": "2873",
              "text": "丁青县"
            },
            {
              "value": "2874",
              "text": "察雅县"
            },
            {
              "value": "2875",
              "text": "八宿县"
            },
            {
              "value": "2876",
              "text": "左贡县"
            },
            {
              "value": "2877",
              "text": "芒康县"
            },
            {
              "value": "2878",
              "text": "洛隆县"
            },
            {
              "value": "2879",
              "text": "边坝县"
            }
          ]
        },
        {
          "value": "2880",
          "text": "山南地区",
          "children": [
            {
              "value": "2881",
              "text": "乃东县"
            },
            {
              "value": "2882",
              "text": "扎囊县"
            },
            {
              "value": "2883",
              "text": "贡嘎县"
            },
            {
              "value": "2884",
              "text": "桑日县"
            },
            {
              "value": "2885",
              "text": "琼结县"
            },
            {
              "value": "2886",
              "text": "曲松县"
            },
            {
              "value": "2887",
              "text": "措美县"
            },
            {
              "value": "2888",
              "text": "洛扎县"
            },
            {
              "value": "2889",
              "text": "加查县"
            },
            {
              "value": "2890",
              "text": "隆子县"
            },
            {
              "value": "2891",
              "text": "错那县"
            },
            {
              "value": "2892",
              "text": "浪卡子县"
            }
          ]
        },
        {
          "value": "2893",
          "text": "日喀则地区",
          "children": [
            {
              "value": "2894",
              "text": "桑珠孜区"
            },
            {
              "value": "2895",
              "text": "南木林县"
            },
            {
              "value": "2896",
              "text": "江孜县"
            },
            {
              "value": "2897",
              "text": "定日县"
            },
            {
              "value": "2898",
              "text": "萨迦县"
            },
            {
              "value": "2899",
              "text": "拉孜县"
            },
            {
              "value": "2900",
              "text": "昂仁县"
            },
            {
              "value": "2901",
              "text": "谢通门县"
            },
            {
              "value": "2902",
              "text": "白朗县"
            },
            {
              "value": "2903",
              "text": "仁布县"
            },
            {
              "value": "2904",
              "text": "康马县"
            },
            {
              "value": "2905",
              "text": "定结县"
            },
            {
              "value": "2906",
              "text": "仲巴县"
            },
            {
              "value": "2907",
              "text": "亚东县"
            },
            {
              "value": "2908",
              "text": "吉隆县"
            },
            {
              "value": "2909",
              "text": "聂拉木县"
            },
            {
              "value": "2910",
              "text": "萨嘎县"
            },
            {
              "value": "2911",
              "text": "岗巴县"
            }
          ]
        },
        {
          "value": "2912",
          "text": "那曲地区",
          "children": [
            {
              "value": "2913",
              "text": "双湖县"
            },
            {
              "value": "2914",
              "text": "嘉黎县"
            },
            {
              "value": "2915",
              "text": "比如县"
            },
            {
              "value": "2916",
              "text": "聂荣县"
            },
            {
              "value": "2917",
              "text": "安多县"
            },
            {
              "value": "2918",
              "text": "申扎县"
            },
            {
              "value": "2919",
              "text": "索县"
            },
            {
              "value": "2920",
              "text": "班戈县"
            },
            {
              "value": "2921",
              "text": "巴青县"
            },
            {
              "value": "2922",
              "text": "尼玛县"
            },
            {
              "value": "3680",
              "text": "色尼区"
            }
          ]
        },
        {
          "value": "2923",
          "text": "阿里地区",
          "children": [
            {
              "value": "2924",
              "text": "普兰县"
            },
            {
              "value": "2925",
              "text": "札达县"
            },
            {
              "value": "2926",
              "text": "噶尔县"
            },
            {
              "value": "2927",
              "text": "日土县"
            },
            {
              "value": "2928",
              "text": "革吉县"
            },
            {
              "value": "2929",
              "text": "改则县"
            },
            {
              "value": "2930",
              "text": "措勤县"
            }
          ]
        },
        {
          "value": "2931",
          "text": "林芝地区",
          "children": [
            {
              "value": "2932",
              "text": "巴宜区"
            },
            {
              "value": "2933",
              "text": "工布江达县"
            },
            {
              "value": "2934",
              "text": "米林县"
            },
            {
              "value": "2935",
              "text": "墨脱县"
            },
            {
              "value": "2936",
              "text": "波密县"
            },
            {
              "value": "2937",
              "text": "察隅县"
            },
            {
              "value": "2938",
              "text": "朗县"
            }
          ]
        }
      ]
    },
    {
      "value": "2939",
      "text": "陕西省",
      "children": [
        {
          "value": "2940",
          "text": "西安市",
          "children": [
            {
              "value": "2941",
              "text": "新城区"
            },
            {
              "value": "2942",
              "text": "碑林区"
            },
            {
              "value": "2943",
              "text": "莲湖区"
            },
            {
              "value": "2944",
              "text": "灞桥区"
            },
            {
              "value": "2945",
              "text": "未央区"
            },
            {
              "value": "2946",
              "text": "雁塔区"
            },
            {
              "value": "2947",
              "text": "阎良区"
            },
            {
              "value": "2948",
              "text": "临潼区"
            },
            {
              "value": "2949",
              "text": "长安区"
            },
            {
              "value": "2950",
              "text": "蓝田县"
            },
            {
              "value": "2951",
              "text": "周至县"
            },
            {
              "value": "2952",
              "text": "户县"
            },
            {
              "value": "2953",
              "text": "高陵县"
            },
            {
              "value": "4106",
              "text": "西安武警工程学院"
            },
            {
              "value": "4199",
              "text": "西咸新区"
            }
          ]
        },
        {
          "value": "2954",
          "text": "铜川市",
          "children": [
            {
              "value": "2955",
              "text": "王益区"
            },
            {
              "value": "2956",
              "text": "印台区"
            },
            {
              "value": "2957",
              "text": "耀州区"
            },
            {
              "value": "2958",
              "text": "宜君县"
            }
          ]
        },
        {
          "value": "2959",
          "text": "宝鸡市",
          "children": [
            {
              "value": "2960",
              "text": "渭滨区"
            },
            {
              "value": "2961",
              "text": "金台区"
            },
            {
              "value": "2962",
              "text": "陈仓区"
            },
            {
              "value": "2963",
              "text": "凤翔县"
            },
            {
              "value": "2964",
              "text": "岐山县"
            },
            {
              "value": "2965",
              "text": "扶风县"
            },
            {
              "value": "2966",
              "text": "眉县"
            },
            {
              "value": "2967",
              "text": "陇县"
            },
            {
              "value": "2968",
              "text": "千阳县"
            },
            {
              "value": "2969",
              "text": "麟游县"
            },
            {
              "value": "2970",
              "text": "凤县"
            },
            {
              "value": "2971",
              "text": "太白县"
            }
          ]
        },
        {
          "value": "2972",
          "text": "咸阳市",
          "children": [
            {
              "value": "2973",
              "text": "秦都区"
            },
            {
              "value": "2974",
              "text": "杨陵区"
            },
            {
              "value": "2975",
              "text": "渭城区"
            },
            {
              "value": "2976",
              "text": "三原县"
            },
            {
              "value": "2977",
              "text": "泾阳县"
            },
            {
              "value": "2978",
              "text": "乾县"
            },
            {
              "value": "2979",
              "text": "礼泉县"
            },
            {
              "value": "2980",
              "text": "永寿县"
            },
            {
              "value": "2981",
              "text": "彬县"
            },
            {
              "value": "2982",
              "text": "长武县"
            },
            {
              "value": "2983",
              "text": "旬邑县"
            },
            {
              "value": "2984",
              "text": "淳化县"
            },
            {
              "value": "2985",
              "text": "武功县"
            },
            {
              "value": "2986",
              "text": "兴平市"
            }
          ]
        },
        {
          "value": "2987",
          "text": "渭南市",
          "children": [
            {
              "value": "2988",
              "text": "临渭区"
            },
            {
              "value": "2989",
              "text": "华州区"
            },
            {
              "value": "2990",
              "text": "潼关县"
            },
            {
              "value": "2991",
              "text": "大荔县"
            },
            {
              "value": "2992",
              "text": "合阳县"
            },
            {
              "value": "2993",
              "text": "澄城县"
            },
            {
              "value": "2994",
              "text": "蒲城县"
            },
            {
              "value": "2995",
              "text": "白水县"
            },
            {
              "value": "2996",
              "text": "富平县"
            },
            {
              "value": "2997",
              "text": "韩城市"
            },
            {
              "value": "2998",
              "text": "华阴市"
            }
          ]
        },
        {
          "value": "2999",
          "text": "延安市",
          "children": [
            {
              "value": "3000",
              "text": "宝塔区"
            },
            {
              "value": "3001",
              "text": "延长县"
            },
            {
              "value": "3002",
              "text": "延川县"
            },
            {
              "value": "3003",
              "text": "子长县"
            },
            {
              "value": "3004",
              "text": "安塞县"
            },
            {
              "value": "3005",
              "text": "志丹县"
            },
            {
              "value": "3006",
              "text": "吴起县"
            },
            {
              "value": "3007",
              "text": "甘泉县"
            },
            {
              "value": "3008",
              "text": "富县"
            },
            {
              "value": "3009",
              "text": "洛川县"
            },
            {
              "value": "3010",
              "text": "宜川县"
            },
            {
              "value": "3011",
              "text": "黄龙县"
            },
            {
              "value": "3012",
              "text": "黄陵县"
            }
          ]
        },
        {
          "value": "3013",
          "text": "汉中市",
          "children": [
            {
              "value": "3014",
              "text": "汉台区"
            },
            {
              "value": "3015",
              "text": "南郑县"
            },
            {
              "value": "3016",
              "text": "城固县"
            },
            {
              "value": "3017",
              "text": "洋县"
            },
            {
              "value": "3018",
              "text": "西乡县"
            },
            {
              "value": "3019",
              "text": "勉县"
            },
            {
              "value": "3020",
              "text": "宁强县"
            },
            {
              "value": "3021",
              "text": "略阳县"
            },
            {
              "value": "3022",
              "text": "镇巴县"
            },
            {
              "value": "3023",
              "text": "留坝县"
            },
            {
              "value": "3024",
              "text": "佛坪县"
            },
            {
              "value": "4098",
              "text": "经济开发区南区"
            }
          ]
        },
        {
          "value": "3025",
          "text": "安康市",
          "children": [
            {
              "value": "3026",
              "text": "汉滨区"
            },
            {
              "value": "3027",
              "text": "汉阴县"
            },
            {
              "value": "3028",
              "text": "石泉县"
            },
            {
              "value": "3029",
              "text": "宁陕县"
            },
            {
              "value": "3030",
              "text": "紫阳县"
            },
            {
              "value": "3031",
              "text": "岚皋县"
            },
            {
              "value": "3032",
              "text": "平利县"
            },
            {
              "value": "3033",
              "text": "镇坪县"
            },
            {
              "value": "3034",
              "text": "旬阳县"
            },
            {
              "value": "3035",
              "text": "白河县"
            }
          ]
        },
        {
          "value": "3036",
          "text": "商洛市",
          "children": [
            {
              "value": "3037",
              "text": "商州市"
            },
            {
              "value": "3038",
              "text": "洛南县"
            },
            {
              "value": "3039",
              "text": "丹凤县"
            },
            {
              "value": "3040",
              "text": "商南县"
            },
            {
              "value": "3041",
              "text": "山阳县"
            },
            {
              "value": "3042",
              "text": "镇安县"
            },
            {
              "value": "3043",
              "text": "柞水县"
            }
          ]
        },
        {
          "value": "3044",
          "text": "榆林市",
          "children": [
            {
              "value": "3045",
              "text": "榆阳区"
            },
            {
              "value": "3046",
              "text": "神木县"
            },
            {
              "value": "3047",
              "text": "府谷县"
            },
            {
              "value": "3048",
              "text": "横山县"
            },
            {
              "value": "3049",
              "text": "靖边县"
            },
            {
              "value": "3050",
              "text": "定边县"
            },
            {
              "value": "3051",
              "text": "绥德县"
            },
            {
              "value": "3052",
              "text": "米脂县"
            },
            {
              "value": "3053",
              "text": "佳县"
            },
            {
              "value": "3054",
              "text": "吴堡县"
            },
            {
              "value": "3055",
              "text": "清涧县"
            },
            {
              "value": "3056",
              "text": "子洲县"
            }
          ]
        }
      ]
    },
    {
      "value": "3057",
      "text": "甘肃省",
      "children": [
        {
          "value": "3058",
          "text": "兰州市",
          "children": [
            {
              "value": "3059",
              "text": "城关区"
            },
            {
              "value": "3060",
              "text": "七里河区"
            },
            {
              "value": "3061",
              "text": "西固区"
            },
            {
              "value": "3062",
              "text": "安宁区"
            },
            {
              "value": "3063",
              "text": "红古区"
            },
            {
              "value": "3064",
              "text": "永登县"
            },
            {
              "value": "3065",
              "text": "皋兰县"
            },
            {
              "value": "3066",
              "text": "榆中县"
            }
          ]
        },
        {
          "value": "3067",
          "text": "嘉峪关市",
          "children": [
            {
              "value": "3068",
              "text": "市辖区"
            },
            {
              "value": "4051",
              "text": "长城区"
            },
            {
              "value": "4056",
              "text": "镜铁区"
            },
            {
              "value": "4060",
              "text": "雄关区"
            }
          ]
        },
        {
          "value": "3069",
          "text": "金昌市",
          "children": [
            {
              "value": "3070",
              "text": "金川区"
            },
            {
              "value": "3071",
              "text": "永昌县"
            }
          ]
        },
        {
          "value": "3072",
          "text": "白银市",
          "children": [
            {
              "value": "3073",
              "text": "白银区"
            },
            {
              "value": "3074",
              "text": "平川区"
            },
            {
              "value": "3075",
              "text": "靖远县"
            },
            {
              "value": "3076",
              "text": "会宁县"
            },
            {
              "value": "3077",
              "text": "景泰县"
            }
          ]
        },
        {
          "value": "3078",
          "text": "天水市",
          "children": [
            {
              "value": "3079",
              "text": "秦州区"
            },
            {
              "value": "3080",
              "text": "麦积区"
            },
            {
              "value": "3081",
              "text": "清水县"
            },
            {
              "value": "3082",
              "text": "秦安县"
            },
            {
              "value": "3083",
              "text": "甘谷县"
            },
            {
              "value": "3084",
              "text": "武山县"
            },
            {
              "value": "3085",
              "text": "张家川回族自治县"
            }
          ]
        },
        {
          "value": "3086",
          "text": "酒泉市",
          "children": [
            {
              "value": "3087",
              "text": "玉门市"
            },
            {
              "value": "3088",
              "text": "肃州区"
            },
            {
              "value": "3089",
              "text": "敦煌市"
            },
            {
              "value": "3090",
              "text": "金塔县"
            },
            {
              "value": "3091",
              "text": "肃北蒙古族自治县"
            },
            {
              "value": "3092",
              "text": "阿克塞哈萨克族自治县"
            },
            {
              "value": "3093",
              "text": "瓜州县"
            }
          ]
        },
        {
          "value": "3094",
          "text": "张掖市",
          "children": [
            {
              "value": "3095",
              "text": "甘州区"
            },
            {
              "value": "3096",
              "text": "肃南裕固族自治县"
            },
            {
              "value": "3097",
              "text": "民乐县"
            },
            {
              "value": "3098",
              "text": "临泽县"
            },
            {
              "value": "3099",
              "text": "高台县"
            },
            {
              "value": "3100",
              "text": "山丹县"
            }
          ]
        },
        {
          "value": "3101",
          "text": "武威市",
          "children": [
            {
              "value": "3102",
              "text": "凉州区"
            },
            {
              "value": "3103",
              "text": "民勤县"
            },
            {
              "value": "3104",
              "text": "古浪县"
            },
            {
              "value": "3105",
              "text": "天祝藏族自治县"
            }
          ]
        },
        {
          "value": "3106",
          "text": "定西市",
          "children": [
            {
              "value": "3107",
              "text": "安定区"
            },
            {
              "value": "3108",
              "text": "通渭县"
            },
            {
              "value": "3109",
              "text": "陇西县"
            },
            {
              "value": "3110",
              "text": "渭源县"
            },
            {
              "value": "3111",
              "text": "临洮县"
            },
            {
              "value": "3112",
              "text": "漳县"
            },
            {
              "value": "3113",
              "text": "岷县"
            }
          ]
        },
        {
          "value": "3114",
          "text": "陇南市",
          "children": [
            {
              "value": "3115",
              "text": "武都县"
            },
            {
              "value": "3116",
              "text": "宕昌县"
            },
            {
              "value": "3117",
              "text": "成县"
            },
            {
              "value": "3118",
              "text": "康县"
            },
            {
              "value": "3119",
              "text": "文县"
            },
            {
              "value": "3120",
              "text": "西和县"
            },
            {
              "value": "3121",
              "text": "礼县"
            },
            {
              "value": "3122",
              "text": "两当县"
            },
            {
              "value": "3123",
              "text": "徽县"
            }
          ]
        },
        {
          "value": "3124",
          "text": "平凉市",
          "children": [
            {
              "value": "3125",
              "text": "崆峒区"
            },
            {
              "value": "3126",
              "text": "泾川县"
            },
            {
              "value": "3127",
              "text": "灵台县"
            },
            {
              "value": "3128",
              "text": "崇信县"
            },
            {
              "value": "3129",
              "text": "华亭县"
            },
            {
              "value": "3130",
              "text": "庄浪县"
            },
            {
              "value": "3131",
              "text": "静宁县"
            },
            {
              "value": "3132",
              "text": "西峰市"
            }
          ]
        },
        {
          "value": "3133",
          "text": "庆阳市",
          "children": [
            {
              "value": "3134",
              "text": "庆城县"
            },
            {
              "value": "3135",
              "text": "环县"
            },
            {
              "value": "3136",
              "text": "华池县"
            },
            {
              "value": "3137",
              "text": "合水县"
            },
            {
              "value": "3138",
              "text": "正宁县"
            },
            {
              "value": "3139",
              "text": "宁县"
            },
            {
              "value": "3140",
              "text": "镇原县"
            },
            {
              "value": "3636",
              "text": "西峰区"
            }
          ]
        },
        {
          "value": "3141",
          "text": "临夏回族自治州",
          "children": [
            {
              "value": "3142",
              "text": "临夏市"
            },
            {
              "value": "3143",
              "text": "临夏县"
            },
            {
              "value": "3144",
              "text": "康乐县"
            },
            {
              "value": "3145",
              "text": "永靖县"
            },
            {
              "value": "3146",
              "text": "广河县"
            },
            {
              "value": "3147",
              "text": "和政县"
            },
            {
              "value": "3148",
              "text": "东乡族自治县"
            },
            {
              "value": "3149",
              "text": "积石山保安族东乡族撒拉族自治县"
            }
          ]
        },
        {
          "value": "3150",
          "text": "甘南藏族自治州",
          "children": [
            {
              "value": "3151",
              "text": "合作市"
            },
            {
              "value": "3152",
              "text": "临潭县"
            },
            {
              "value": "3153",
              "text": "卓尼县"
            },
            {
              "value": "3154",
              "text": "舟曲县"
            },
            {
              "value": "3155",
              "text": "迭部县"
            },
            {
              "value": "3156",
              "text": "玛曲县"
            },
            {
              "value": "3157",
              "text": "碌曲县"
            },
            {
              "value": "3158",
              "text": "夏河县"
            }
          ]
        }
      ]
    },
    {
      "value": "3159",
      "text": "青海省",
      "children": [
        {
          "value": "3160",
          "text": "西宁市",
          "children": [
            {
              "value": "3161",
              "text": "城东区"
            },
            {
              "value": "3162",
              "text": "城中区"
            },
            {
              "value": "3163",
              "text": "城西区"
            },
            {
              "value": "3164",
              "text": "城北区"
            },
            {
              "value": "3165",
              "text": "大通回族土族自治县"
            },
            {
              "value": "3170",
              "text": "湟中县"
            },
            {
              "value": "3171",
              "text": "湟源县"
            }
          ]
        },
        {
          "value": "3166",
          "text": "海东市",
          "children": [
            {
              "value": "3167",
              "text": "平安县"
            },
            {
              "value": "3168",
              "text": "民和回族土族自治县"
            },
            {
              "value": "3169",
              "text": "乐都县"
            },
            {
              "value": "3172",
              "text": "互助土族自治县"
            },
            {
              "value": "3173",
              "text": "化隆回族自治县"
            },
            {
              "value": "3174",
              "text": "循化撒拉族自治县"
            }
          ]
        },
        {
          "value": "3175",
          "text": "海北藏族自治州",
          "children": [
            {
              "value": "3176",
              "text": "门源回族自治县"
            },
            {
              "value": "3177",
              "text": "祁连县"
            },
            {
              "value": "3178",
              "text": "海晏县"
            },
            {
              "value": "3179",
              "text": "刚察县"
            }
          ]
        },
        {
          "value": "3180",
          "text": "黄南藏族自治州",
          "children": [
            {
              "value": "3181",
              "text": "同仁县"
            },
            {
              "value": "3182",
              "text": "尖扎县"
            },
            {
              "value": "3183",
              "text": "泽库县"
            },
            {
              "value": "3184",
              "text": "河南蒙古族自治县"
            }
          ]
        },
        {
          "value": "3185",
          "text": "海南藏族自治州",
          "children": [
            {
              "value": "3186",
              "text": "同德县"
            },
            {
              "value": "3187",
              "text": "贵德县"
            },
            {
              "value": "3188",
              "text": "兴海县"
            },
            {
              "value": "3189",
              "text": "贵南县"
            },
            {
              "value": "3662",
              "text": "共和县"
            }
          ]
        },
        {
          "value": "3190",
          "text": "果洛藏族自治州",
          "children": [
            {
              "value": "3191",
              "text": "玛沁县"
            },
            {
              "value": "3192",
              "text": "班玛县"
            },
            {
              "value": "3193",
              "text": "甘德县"
            },
            {
              "value": "3194",
              "text": "达日县"
            },
            {
              "value": "3195",
              "text": "久治县"
            },
            {
              "value": "3196",
              "text": "玛多县"
            }
          ]
        },
        {
          "value": "3197",
          "text": "玉树藏族自治州",
          "children": [
            {
              "value": "3198",
              "text": "玉树县"
            },
            {
              "value": "3199",
              "text": "杂多县"
            },
            {
              "value": "3200",
              "text": "称多县"
            },
            {
              "value": "3201",
              "text": "治多县"
            },
            {
              "value": "3202",
              "text": "囊谦县"
            },
            {
              "value": "3203",
              "text": "曲麻莱县"
            }
          ]
        },
        {
          "value": "3204",
          "text": "海西蒙古族藏族自治州",
          "children": [
            {
              "value": "3205",
              "text": "格尔木市"
            },
            {
              "value": "3206",
              "text": "德令哈市"
            },
            {
              "value": "3207",
              "text": "乌兰县"
            },
            {
              "value": "3208",
              "text": "都兰县"
            },
            {
              "value": "3209",
              "text": "天峻县"
            },
            {
              "value": "4078",
              "text": "大柴旦行委"
            },
            {
              "value": "4081",
              "text": "冷湖行委"
            },
            {
              "value": "4084",
              "text": "茫崖行委"
            }
          ]
        }
      ]
    },
    {
      "value": "3210",
      "text": "宁夏",
      "children": [
        {
          "value": "3211",
          "text": "银川市",
          "children": [
            {
              "value": "3212",
              "text": "兴庆区"
            },
            {
              "value": "3213",
              "text": "西夏区"
            },
            {
              "value": "3214",
              "text": "金凤区"
            },
            {
              "value": "3215",
              "text": "永宁县"
            },
            {
              "value": "3216",
              "text": "贺兰县"
            },
            {
              "value": "3217",
              "text": "灵武市"
            }
          ]
        },
        {
          "value": "3218",
          "text": "石嘴山市",
          "children": [
            {
              "value": "3219",
              "text": "大武口区"
            },
            {
              "value": "3220",
              "text": "惠农区"
            },
            {
              "value": "3221",
              "text": "平罗县"
            }
          ]
        },
        {
          "value": "3222",
          "text": "吴忠市",
          "children": [
            {
              "value": "3223",
              "text": "利通区"
            },
            {
              "value": "3224",
              "text": "红寺堡开发区"
            },
            {
              "value": "3225",
              "text": "盐池县"
            },
            {
              "value": "3226",
              "text": "同心县"
            },
            {
              "value": "3227",
              "text": "青铜峡市"
            }
          ]
        },
        {
          "value": "3228",
          "text": "固原市",
          "children": [
            {
              "value": "3229",
              "text": "原州区"
            },
            {
              "value": "3230",
              "text": "西吉县"
            },
            {
              "value": "3231",
              "text": "隆德县"
            },
            {
              "value": "3232",
              "text": "泾源县"
            },
            {
              "value": "3233",
              "text": "彭阳县"
            }
          ]
        },
        {
          "value": "3234",
          "text": "中卫市",
          "children": [
            {
              "value": "3235",
              "text": "沙坡头区"
            },
            {
              "value": "3236",
              "text": "中宁县"
            },
            {
              "value": "3237",
              "text": "海原县"
            }
          ]
        }
      ]
    },
    {
      "value": "3238",
      "text": "新疆",
      "children": [
        {
          "value": "3239",
          "text": "乌鲁木齐市",
          "children": [
            {
              "value": "3240",
              "text": "天山区"
            },
            {
              "value": "3241",
              "text": "沙依巴克区"
            },
            {
              "value": "3242",
              "text": "新市区(高新技术产业开发区)"
            },
            {
              "value": "3243",
              "text": "水磨沟区"
            },
            {
              "value": "3244",
              "text": "头屯河区(经济技术开发区)"
            },
            {
              "value": "3245",
              "text": "达坂城区"
            },
            {
              "value": "3246",
              "text": "米东区"
            },
            {
              "value": "3247",
              "text": "乌鲁木齐县"
            }
          ]
        },
        {
          "value": "3248",
          "text": "克拉玛依市",
          "children": [
            {
              "value": "3249",
              "text": "独山子区"
            },
            {
              "value": "3250",
              "text": "克拉玛依区"
            },
            {
              "value": "3251",
              "text": "白碱滩区"
            },
            {
              "value": "3252",
              "text": "乌尔禾区"
            }
          ]
        },
        {
          "value": "3253",
          "text": "吐鲁番地区",
          "children": [
            {
              "value": "3254",
              "text": "吐鲁番市"
            },
            {
              "value": "3255",
              "text": "鄯善县"
            },
            {
              "value": "3256",
              "text": "托克逊县"
            }
          ]
        },
        {
          "value": "3257",
          "text": "哈密地区",
          "children": [
            {
              "value": "3258",
              "text": "哈密市"
            },
            {
              "value": "3259",
              "text": "巴里坤县"
            },
            {
              "value": "3260",
              "text": "伊吾县"
            }
          ]
        },
        {
          "value": "3261",
          "text": "昌吉回族自治州",
          "children": [
            {
              "value": "3262",
              "text": "昌吉市"
            },
            {
              "value": "3263",
              "text": "阜康市"
            },
            {
              "value": "3264",
              "text": "呼图壁县"
            },
            {
              "value": "3265",
              "text": "玛纳斯县"
            },
            {
              "value": "3266",
              "text": "奇台县"
            },
            {
              "value": "3267",
              "text": "吉木萨尔县"
            },
            {
              "value": "3268",
              "text": "木垒县"
            },
            {
              "value": "4015",
              "text": "准东经济技术开发区"
            }
          ]
        },
        {
          "value": "3269",
          "text": "博尔塔拉蒙古自治州",
          "children": [
            {
              "value": "3270",
              "text": "博乐市"
            },
            {
              "value": "3271",
              "text": "精河县"
            },
            {
              "value": "3272",
              "text": "温泉县"
            },
            {
              "value": "3641",
              "text": "阿拉山口市"
            }
          ]
        },
        {
          "value": "3273",
          "text": "巴音郭楞蒙古自治州",
          "children": [
            {
              "value": "3274",
              "text": "库尔勒市"
            },
            {
              "value": "3275",
              "text": "轮台县"
            },
            {
              "value": "3276",
              "text": "尉犁县"
            },
            {
              "value": "3277",
              "text": "若羌县"
            },
            {
              "value": "3278",
              "text": "且末县"
            },
            {
              "value": "3279",
              "text": "焉耆县"
            },
            {
              "value": "3280",
              "text": "和静县"
            },
            {
              "value": "3281",
              "text": "和硕县"
            },
            {
              "value": "3282",
              "text": "博湖县"
            }
          ]
        },
        {
          "value": "3283",
          "text": "阿克苏市",
          "children": [
            {
              "value": "3284",
              "text": "阿克苏市"
            },
            {
              "value": "3285",
              "text": "温宿县"
            },
            {
              "value": "3286",
              "text": "库车县"
            },
            {
              "value": "3287",
              "text": "沙雅县"
            },
            {
              "value": "3288",
              "text": "新和县"
            },
            {
              "value": "3289",
              "text": "拜城县"
            },
            {
              "value": "3290",
              "text": "乌什县"
            },
            {
              "value": "3291",
              "text": "阿瓦提县"
            },
            {
              "value": "3292",
              "text": "柯坪县"
            }
          ]
        },
        {
          "value": "3293",
          "text": "克孜勒苏柯尔克孜自治州",
          "children": [
            {
              "value": "3294",
              "text": "阿图什市"
            },
            {
              "value": "3295",
              "text": "阿克陶县"
            },
            {
              "value": "3296",
              "text": "阿合奇县"
            },
            {
              "value": "3297",
              "text": "乌恰县"
            }
          ]
        },
        {
          "value": "3298",
          "text": "喀什地区",
          "children": [
            {
              "value": "3299",
              "text": "喀什市"
            },
            {
              "value": "3300",
              "text": "疏附县"
            },
            {
              "value": "3301",
              "text": "疏勒县"
            },
            {
              "value": "3302",
              "text": "英吉沙县"
            },
            {
              "value": "3303",
              "text": "泽普县"
            },
            {
              "value": "3304",
              "text": "莎车县"
            },
            {
              "value": "3305",
              "text": "叶城县"
            },
            {
              "value": "3306",
              "text": "麦盖提县"
            },
            {
              "value": "3307",
              "text": "岳普湖县"
            },
            {
              "value": "3308",
              "text": "伽师县"
            },
            {
              "value": "3309",
              "text": "巴楚县"
            },
            {
              "value": "3310",
              "text": "塔什库尔干县"
            }
          ]
        },
        {
          "value": "3311",
          "text": "和田市",
          "children": [
            {
              "value": "3312",
              "text": "和田市"
            },
            {
              "value": "3313",
              "text": "和田县"
            },
            {
              "value": "3314",
              "text": "墨玉县"
            },
            {
              "value": "3315",
              "text": "皮山县"
            },
            {
              "value": "3316",
              "text": "洛浦县"
            },
            {
              "value": "3317",
              "text": "策勒县"
            },
            {
              "value": "3318",
              "text": "于田县"
            },
            {
              "value": "3319",
              "text": "民丰县"
            }
          ]
        },
        {
          "value": "3320",
          "text": "伊犁哈萨克自治州",
          "children": [
            {
              "value": "3321",
              "text": "奎屯市"
            },
            {
              "value": "3322",
              "text": "霍尔果斯市"
            },
            {
              "value": "3323",
              "text": "伊宁市"
            },
            {
              "value": "3324",
              "text": "伊宁县"
            },
            {
              "value": "3325",
              "text": "察布查尔县"
            },
            {
              "value": "3326",
              "text": "霍城县"
            },
            {
              "value": "3327",
              "text": "巩留县"
            },
            {
              "value": "3328",
              "text": "新源县"
            },
            {
              "value": "3329",
              "text": "昭苏县"
            },
            {
              "value": "3330",
              "text": "特克斯县"
            },
            {
              "value": "3331",
              "text": "尼勒克县"
            }
          ]
        },
        {
          "value": "3332",
          "text": "塔城地区",
          "children": [
            {
              "value": "3333",
              "text": "塔城市"
            },
            {
              "value": "3334",
              "text": "乌苏市"
            },
            {
              "value": "3335",
              "text": "额敏县"
            },
            {
              "value": "3336",
              "text": "沙湾县"
            },
            {
              "value": "3337",
              "text": "托里县"
            },
            {
              "value": "3338",
              "text": "裕民县"
            },
            {
              "value": "3339",
              "text": "和布克赛尔县"
            }
          ]
        },
        {
          "value": "3340",
          "text": "阿勒泰地区",
          "children": [
            {
              "value": "3341",
              "text": "阿勒泰市"
            },
            {
              "value": "3342",
              "text": "布尔津县"
            },
            {
              "value": "3343",
              "text": "富蕴县"
            },
            {
              "value": "3344",
              "text": "福海县"
            },
            {
              "value": "3345",
              "text": "哈巴河县"
            },
            {
              "value": "3346",
              "text": "青河县"
            },
            {
              "value": "3347",
              "text": "吉木乃县"
            },
            {
              "value": "4026",
              "text": "北屯市"
            }
          ]
        },
        {
          "value": "3348",
          "text": "自治区直辖县",
          "children": [
            {
              "value": "3349",
              "text": "石河子市"
            },
            {
              "value": "3350",
              "text": "阿拉尔市"
            },
            {
              "value": "3351",
              "text": "图木舒克市"
            },
            {
              "value": "3352",
              "text": "五家渠市"
            }
          ]
        },
        {
          "value": "3663",
          "text": "北屯市",
          "children": [
            {
              "value": "3663",
              "text": "北屯市"
            }
          ]
        },
        {
          "value": "3664",
          "text": "铁门关市",
          "children": [
            {
              "value": "3664",
              "text": "铁门关市"
            }
          ]
        },
        {
          "value": "3665",
          "text": "双河市",
          "children": [
            {
              "value": "3665",
              "text": "双河市"
            }
          ]
        },
        {
          "value": "3666",
          "text": "可克达拉市",
          "children": [
            {
              "value": "3666",
              "text": "可克达拉市"
            }
          ]
        },
        {
          "value": "4037",
          "text": "昆玉市",
          "children": [
            {
              "value": "4040",
              "text": "昆玉市"
            }
          ]
        }
      ]
    },
    {
      "value": "3353",
      "text": "台湾",
      "children": [
        {
          "value": "3362",
          "text": "台北市",
          "children": [
            {
              "value": "3362",
              "text": "台北市"
            }
          ]
        },
        {
          "value": "3363",
          "text": "高雄市",
          "children": [
            {
              "value": "3363",
              "text": "高雄市"
            }
          ]
        },
        {
          "value": "3364",
          "text": "基隆市",
          "children": [
            {
              "value": "3364",
              "text": "基隆市"
            }
          ]
        },
        {
          "value": "3365",
          "text": "台中市",
          "children": [
            {
              "value": "3365",
              "text": "台中市"
            }
          ]
        },
        {
          "value": "3366",
          "text": "台南市",
          "children": [
            {
              "value": "3366",
              "text": "台南市"
            }
          ]
        },
        {
          "value": "3367",
          "text": "新竹市",
          "children": [
            {
              "value": "3367",
              "text": "新竹市"
            }
          ]
        },
        {
          "value": "3368",
          "text": "嘉义市",
          "children": [
            {
              "value": "3368",
              "text": "嘉义市"
            }
          ]
        },
        {
          "value": "3369",
          "text": "台北县",
          "children": [
            {
              "value": "3369",
              "text": "台北县"
            }
          ]
        },
        {
          "value": "3370",
          "text": "板桥市",
          "children": [
            {
              "value": "3370",
              "text": "板桥市"
            }
          ]
        },
        {
          "value": "3371",
          "text": "宜兰县",
          "children": [
            {
              "value": "3371",
              "text": "宜兰县"
            }
          ]
        },
        {
          "value": "3372",
          "text": "宜兰市",
          "children": [
            {
              "value": "3372",
              "text": "宜兰市"
            }
          ]
        },
        {
          "value": "3373",
          "text": "新竹县",
          "children": [
            {
              "value": "3373",
              "text": "新竹县"
            }
          ]
        },
        {
          "value": "3374",
          "text": "竹北市",
          "children": [
            {
              "value": "3374",
              "text": "竹北市"
            }
          ]
        },
        {
          "value": "3375",
          "text": "桃园县",
          "children": [
            {
              "value": "3375",
              "text": "桃园县"
            }
          ]
        },
        {
          "value": "3376",
          "text": "桃园市",
          "children": [
            {
              "value": "3376",
              "text": "桃园市"
            }
          ]
        },
        {
          "value": "3377",
          "text": "苗栗县",
          "children": [
            {
              "value": "3377",
              "text": "苗栗县"
            }
          ]
        },
        {
          "value": "3378",
          "text": "苗栗市",
          "children": [
            {
              "value": "3378",
              "text": "苗栗市"
            }
          ]
        },
        {
          "value": "3379",
          "text": "台中县",
          "children": [
            {
              "value": "3379",
              "text": "台中县"
            }
          ]
        },
        {
          "value": "3380",
          "text": "丰原市",
          "children": [
            {
              "value": "3380",
              "text": "丰原市"
            }
          ]
        },
        {
          "value": "3381",
          "text": "彰化县",
          "children": [
            {
              "value": "3381",
              "text": "彰化县"
            }
          ]
        },
        {
          "value": "3382",
          "text": "彰化市",
          "children": [
            {
              "value": "3382",
              "text": "彰化市"
            }
          ]
        },
        {
          "value": "3383",
          "text": "南投县",
          "children": [
            {
              "value": "3383",
              "text": "南投县"
            }
          ]
        },
        {
          "value": "3384",
          "text": "南投市",
          "children": [
            {
              "value": "3384",
              "text": "南投市"
            }
          ]
        },
        {
          "value": "3385",
          "text": "嘉义县",
          "children": [
            {
              "value": "3385",
              "text": "嘉义县"
            }
          ]
        },
        {
          "value": "3386",
          "text": "太保市",
          "children": [
            {
              "value": "3386",
              "text": "太保市"
            }
          ]
        },
        {
          "value": "3387",
          "text": "云林县",
          "children": [
            {
              "value": "3387",
              "text": "云林县"
            }
          ]
        },
        {
          "value": "3388",
          "text": "斗六市",
          "children": [
            {
              "value": "3388",
              "text": "斗六市"
            }
          ]
        },
        {
          "value": "3389",
          "text": "台南县",
          "children": [
            {
              "value": "3389",
              "text": "台南县"
            }
          ]
        },
        {
          "value": "3390",
          "text": "新营市",
          "children": [
            {
              "value": "3390",
              "text": "新营市"
            }
          ]
        },
        {
          "value": "3391",
          "text": "高雄县",
          "children": [
            {
              "value": "3391",
              "text": "高雄县"
            }
          ]
        },
        {
          "value": "3392",
          "text": "凤山市",
          "children": [
            {
              "value": "3392",
              "text": "凤山市"
            }
          ]
        },
        {
          "value": "3393",
          "text": "屏东县",
          "children": [
            {
              "value": "3393",
              "text": "屏东县"
            }
          ]
        },
        {
          "value": "3394",
          "text": "屏东市",
          "children": [
            {
              "value": "3394",
              "text": "屏东市"
            }
          ]
        },
        {
          "value": "3395",
          "text": "台东县",
          "children": [
            {
              "value": "3395",
              "text": "台东县"
            }
          ]
        },
        {
          "value": "3396",
          "text": "台东市",
          "children": [
            {
              "value": "3396",
              "text": "台东市"
            }
          ]
        },
        {
          "value": "3397",
          "text": "花莲县",
          "children": [
            {
              "value": "3397",
              "text": "花莲县"
            }
          ]
        },
        {
          "value": "3398",
          "text": "花莲市",
          "children": [
            {
              "value": "3398",
              "text": "花莲市"
            }
          ]
        },
        {
          "value": "3399",
          "text": "澎湖县",
          "children": [
            {
              "value": "3399",
              "text": "澎湖县"
            }
          ]
        },
        {
          "value": "3400",
          "text": "马公市",
          "children": [
            {
              "value": "3400",
              "text": "马公市"
            }
          ]
        }
      ]
    },
    {
      "value": "3354",
      "text": "澳门",
      "children": [
        {
          "value": "3355",
          "text": "花地玛堂区",
          "children": [
            {
              "value": "3355",
              "text": "花地玛堂区"
            }
          ]
        },
        {
          "value": "3356",
          "text": "圣安多尼堂区",
          "children": [
            {
              "value": "3356",
              "text": "圣安多尼堂区"
            }
          ]
        },
        {
          "value": "3357",
          "text": "大堂区",
          "children": [
            {
              "value": "3357",
              "text": "大堂区"
            }
          ]
        },
        {
          "value": "3358",
          "text": "望德唐区",
          "children": [
            {
              "value": "3358",
              "text": "望德唐区"
            }
          ]
        },
        {
          "value": "3359",
          "text": "风顺堂区",
          "children": [
            {
              "value": "3359",
              "text": "风顺堂区"
            }
          ]
        },
        {
          "value": "3360",
          "text": "嘉模堂区",
          "children": [
            {
              "value": "3360",
              "text": "嘉模堂区"
            }
          ]
        },
        {
          "value": "3361",
          "text": "圣方济各堂区",
          "children": [
            {
              "value": "3361",
              "text": "圣方济各堂区"
            }
          ]
        }
      ]
    },
    {
      "value": "3561",
      "text": "马来西亚",
      "children": [
        {
          "value": "3562",
          "text": "马六甲",
          "children": [
            {
              "value": "3562",
              "text": "马六甲"
            }
          ]
        }
      ]
    },
    {
      "value": "3667",
      "text": "香港",
      "children": [
        {
          "value": "3668",
          "text": "香港岛",
          "children": [
            {
              "value": "3671",
              "text": "中西区"
            },
            {
              "value": "3672",
              "text": "湾仔区"
            },
            {
              "value": "3673",
              "text": "东区"
            },
            {
              "value": "3674",
              "text": "南区"
            }
          ]
        },
        {
          "value": "3669",
          "text": "九龙半岛",
          "children": [
            {
              "value": "3669",
              "text": "九龙半岛"
            }
          ]
        },
        {
          "value": "3670",
          "text": "新界",
          "children": [
            {
              "value": "3670",
              "text": "新界"
            }
          ]
        },
        {
          "value": "4126",
          "text": "中西区",
          "children": [
            {
              "value": "4126",
              "text": "中西区"
            }
          ]
        },
        {
          "value": "4128",
          "text": "东区",
          "children": [
            {
              "value": "4128",
              "text": "东区"
            }
          ]
        },
        {
          "value": "4131",
          "text": "九龙城区",
          "children": [
            {
              "value": "4131",
              "text": "九龙城区"
            }
          ]
        },
        {
          "value": "4132",
          "text": "观塘区",
          "children": [
            {
              "value": "4132",
              "text": "观塘区"
            }
          ]
        },
        {
          "value": "4134",
          "text": "深水埗区",
          "children": [
            {
              "value": "4134",
              "text": "深水埗区"
            }
          ]
        },
        {
          "value": "4136",
          "text": "湾仔区",
          "children": [
            {
              "value": "4136",
              "text": "湾仔区"
            }
          ]
        },
        {
          "value": "4137",
          "text": "黄大仙区",
          "children": [
            {
              "value": "4137",
              "text": "黄大仙区"
            }
          ]
        },
        {
          "value": "4139",
          "text": "油尖旺区",
          "children": [
            {
              "value": "4139",
              "text": "油尖旺区"
            }
          ]
        },
        {
          "value": "4142",
          "text": "离岛区",
          "children": [
            {
              "value": "4142",
              "text": "离岛区"
            }
          ]
        },
        {
          "value": "4143",
          "text": "葵青区",
          "children": [
            {
              "value": "4143",
              "text": "葵青区"
            }
          ]
        },
        {
          "value": "4145",
          "text": "北区",
          "children": [
            {
              "value": "4145",
              "text": "北区"
            }
          ]
        },
        {
          "value": "4147",
          "text": "西贡区",
          "children": [
            {
              "value": "4147",
              "text": "西贡区"
            }
          ]
        },
        {
          "value": "4149",
          "text": "沙田区",
          "children": [
            {
              "value": "4149",
              "text": "沙田区"
            }
          ]
        },
        {
          "value": "4151",
          "text": "屯门区",
          "children": [
            {
              "value": "4151",
              "text": "屯门区"
            }
          ]
        },
        {
          "value": "4153",
          "text": "大埔区",
          "children": [
            {
              "value": "4153",
              "text": "大埔区"
            }
          ]
        },
        {
          "value": "4154",
          "text": "荃湾区",
          "children": [
            {
              "value": "4154",
              "text": "荃湾区"
            }
          ]
        },
        {
          "value": "4156",
          "text": "元朗区",
          "children": [
            {
              "value": "4156",
              "text": "元朗区"
            }
          ]
        }
      ]
    }
  ]